var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-191",
    d: "M77.77,453.45c-95.13-54.91-95.13-144,0-198.87s249.34-54.92,344.46,0,95.13,144,0,198.87S172.89,508.37,77.77,453.45Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-191",
    d: "M62.18,407.56l137.75,79.53a13.39,13.39,0,0,0,12.17,0l222.22-128.3c3.37-1.94,3.37-5.08,0-7L296.57,272.23a13.45,13.45,0,0,0-12.17,0L62.18,400.54C58.81,402.48,58.81,405.62,62.18,407.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-191",
    d: "M88,447.85c9.94,5.8,9.94,15.22,0,21s-26.06,5.81-36,0-9.94-15.22,0-21S78.09,442,88,447.85Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-191",
    d: "M368.67,475.57a4.13,4.13,0,0,1-4-3.31L364,468.7c-1.56-.31-3.09-.69-4.54-1.13l-6.93,3.21a4.68,4.68,0,0,1-2,.41h0a4.7,4.7,0,0,1-2.37-.61l-7.09-4.09a3.52,3.52,0,0,1-.3-6l3.72-2.67q-.27-.39-.51-.78l-8.66-.54a4,4,0,0,1-3.7-3.94v-5.27a4,4,0,0,1,3.7-3.94l8.66-.55c.16-.26.33-.52.51-.77l-3.72-2.68a3.51,3.51,0,0,1,.3-6l7.09-4.1a4.81,4.81,0,0,1,2.38-.61,4.67,4.67,0,0,1,1.95.42l6.93,3.21a45.62,45.62,0,0,1,4.54-1.13l.68-3.56a4.14,4.14,0,0,1,4-3.32H379.1a4.12,4.12,0,0,1,4,3.32l.68,3.56a45,45,0,0,1,4.54,1.13l6.93-3.21a4.68,4.68,0,0,1,2-.42,4.8,4.8,0,0,1,2.37.61l7.09,4.1a3.57,3.57,0,0,1,1.84,2.91,3.62,3.62,0,0,1-1.53,3.08L403.25,442c.17.25.34.51.5.77l8.66.55a4,4,0,0,1,3.7,3.94v5.27a4,4,0,0,1-3.69,3.94l-8.67.54c-.16.26-.33.52-.5.78L407,460.5a3.51,3.51,0,0,1-.3,6l-7.1,4.09a4.9,4.9,0,0,1-4.33.2l-6.93-3.21c-1.46.44-3,.82-4.54,1.13l-.67,3.56a4.13,4.13,0,0,1-4,3.31Zm-5.27-30c-2.2,1.27-3.47,2.85-3.47,4.32s1.27,3.05,3.47,4.32a23.49,23.49,0,0,0,21,0c2.2-1.27,3.46-2.84,3.46-4.32s-1.26-3.05-3.46-4.32a23.57,23.57,0,0,0-21,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.27,430.29h0l0,6.15h0a.61.61,0,0,0,.29.47l3.24,2.34a1.61,1.61,0,0,1-.82.35l-9.45.59a1,1,0,0,0-.89.95v11.42a1,1,0,0,0,.89.94l9.45.6a1.51,1.51,0,0,1,.8.33l-3.26,2.35a.59.59,0,0,0-.28.47h0v6.17h0a.62.62,0,0,0,.33.47l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.71,2.71,0,0,1,1.64-.1A41.8,41.8,0,0,0,365.7,466a1.35,1.35,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,42.17,42.17,0,0,0,5.59-1.33,2.71,2.71,0,0,1,1.64.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09a.57.57,0,0,0,.33-.48h0l0-6.16h0a.63.63,0,0,0-.28-.47L402,454.44a1.51,1.51,0,0,1,.82-.34l9.45-.6a1,1,0,0,0,.89-.94l0-7.4h0v-4a1,1,0,0,0-.88-.95l-9.46-.59a1.56,1.56,0,0,1-.8-.34l3.26-2.35a.56.56,0,0,0,.28-.47h0l0-6.15h0a.56.56,0,0,0-.33-.48l-7.1-4.1a1.91,1.91,0,0,0-1.57-.07L389.31,429a2.63,2.63,0,0,1-1.64.1,43.25,43.25,0,0,0-5.58-1.33,1.34,1.34,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1-.87H368.67a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.66,2.66,0,0,1-1.65-.1l-7.19-3.33a1.91,1.91,0,0,0-1.57.07l-7.09,4.1A.56.56,0,0,0,342.27,430.29Zm43.6,20.4c-6.62,3.82-17.35,3.82-24,0-2.59-1.49-4.16-3.35-4.72-5.29a10.87,10.87,0,0,1,4.72-4.52c6.62-3.82,17.35-3.82,24,0,2.59,1.49,4.1,3.16,4.61,4.86A9.84,9.84,0,0,1,385.87,450.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.27,430.29h0l0,6.15h0a.61.61,0,0,0,.29.47l3.24,2.34a1.61,1.61,0,0,1-.82.35l-9.45.59a1,1,0,0,0-.89.95v11.42a1,1,0,0,0,.89.94l9.45.6a1.51,1.51,0,0,1,.8.33l-3.26,2.35a.59.59,0,0,0-.28.47h0v6.17h0a.62.62,0,0,0,.33.47l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.71,2.71,0,0,1,1.64-.1A41.8,41.8,0,0,0,365.7,466a1.35,1.35,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,42.17,42.17,0,0,0,5.59-1.33,2.71,2.71,0,0,1,1.64.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09a.57.57,0,0,0,.33-.48h0l0-6.16h0a.63.63,0,0,0-.28-.47L402,454.44a1.51,1.51,0,0,1,.82-.34l9.45-.6a1,1,0,0,0,.89-.94l0-7.4h0v-4a1,1,0,0,0-.88-.95l-9.46-.59a1.56,1.56,0,0,1-.8-.34l3.26-2.35a.56.56,0,0,0,.28-.47h0l0-6.15h0a.56.56,0,0,0-.33-.48l-7.1-4.1a1.91,1.91,0,0,0-1.57-.07L389.31,429a2.63,2.63,0,0,1-1.64.1,43.25,43.25,0,0,0-5.58-1.33,1.34,1.34,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1-.87H368.67a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.66,2.66,0,0,1-1.65-.1l-7.19-3.33a1.91,1.91,0,0,0-1.57.07l-7.09,4.1A.56.56,0,0,0,342.27,430.29Zm43.6,20.4c-6.62,3.82-17.35,3.82-24,0-2.59-1.49-4.16-3.35-4.72-5.29a10.87,10.87,0,0,1,4.72-4.52c6.62-3.82,17.35-3.82,24,0,2.59,1.49,4.1,3.16,4.61,4.86A9.84,9.84,0,0,1,385.87,450.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.49,451.58a.74.74,0,0,0,.1,1.15l2.37,1.71a1.54,1.54,0,0,1,.83-.34l9.45-.6a1,1,0,0,0,.89-.95l0-7.39v1.25a1,1,0,0,1-.88.94l-9.45.6a1.71,1.71,0,0,0-1.28.85A14.44,14.44,0,0,1,399.49,451.58Zm6-21.23a.73.73,0,0,1-.28.42l-5.62,4a.74.74,0,0,0-.11,1.15,14.19,14.19,0,0,1,2,2.79,1.64,1.64,0,0,0,.47.52l3.26-2.35a.59.59,0,0,0,.28-.48h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,436.86c6.62-3.83,17.35-3.83,24,0,4.18,2.42,5.72,5.78,4.61,8.89-.49-1.69-2-3.36-4.61-4.86-6.62-3.82-17.35-3.82-24,0a11,11,0,0,0-4.73,4.52C356.29,442.39,357.87,439.18,361.9,436.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,452.56a1,1,0,0,0,.89.94l9.45.6a1.33,1.33,0,0,1,.46.13v-6.16A1.17,1.17,0,0,0,345,448l-9.45-.6a1,1,0,0,1-.88-.82Zm7.61-16.11h0a.58.58,0,0,0,.28.47l3.25,2.33a1.91,1.91,0,0,0,.45-.5,13.6,13.6,0,0,1,1.9-2.66.64.64,0,0,1,.1-.13.82.82,0,0,0,.19-.32l0-.12a.65.65,0,0,0,0-.24.76.76,0,0,0-.17-.35.81.81,0,0,0-.14-.12l-5.62-4.05a.69.69,0,0,1-.13-.11.32.32,0,0,1-.11-.18.33.33,0,0,1,0-.19h0Zm0,27a.59.59,0,0,0,.34.47l7.09,4.09a1.8,1.8,0,0,0,1.09.19V462a2,2,0,0,1-1.1-.19l-7.09-4.1a.66.66,0,0,1-.34-.43Zm46.34,1.14a2.18,2.18,0,0,1,.71.16l7.19,3.33a1.62,1.62,0,0,0,.64.13l0-6.14a1.47,1.47,0,0,1-.64-.14l-7.19-3.33a2.32,2.32,0,0,0-.7-.17Zm-20.85,7.49a1.14,1.14,0,0,0,.92.52h10.42a1,1,0,0,0,.63-.23v-6.15a1,1,0,0,1-.64.23H368.66a1.1,1.1,0,0,1-.87-.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,452.56a1,1,0,0,0,.89.94l9.45.6a1.33,1.33,0,0,1,.46.13v-6.16A1.17,1.17,0,0,0,345,448l-9.45-.6a1,1,0,0,1-.88-.82Zm7.61-16.11h0a.58.58,0,0,0,.28.47l3.25,2.33a1.91,1.91,0,0,0,.45-.5,13.6,13.6,0,0,1,1.9-2.66.64.64,0,0,1,.1-.13.82.82,0,0,0,.19-.32l0-.12a.65.65,0,0,0,0-.24.76.76,0,0,0-.17-.35.81.81,0,0,0-.14-.12l-5.62-4.05a.69.69,0,0,1-.13-.11.32.32,0,0,1-.11-.18.33.33,0,0,1,0-.19h0Zm0,27a.59.59,0,0,0,.34.47l7.09,4.09a1.8,1.8,0,0,0,1.09.19V462a2,2,0,0,1-1.1-.19l-7.09-4.1a.66.66,0,0,1-.34-.43Zm46.34,1.14a2.18,2.18,0,0,1,.71.16l7.19,3.33a1.62,1.62,0,0,0,.64.13l0-6.14a1.47,1.47,0,0,1-.64-.14l-7.19-3.33a2.32,2.32,0,0,0-.7-.17Zm-20.85,7.49a1.14,1.14,0,0,0,.92.52h10.42a1,1,0,0,0,.63-.23v-6.15a1,1,0,0,1-.64.23H368.66a1.1,1.1,0,0,1-.87-.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,425.71l-7.09,4.1a.52.52,0,0,0-.05.95l5.62,4.05a.74.74,0,0,1,.1,1.15,14.13,14.13,0,0,0-2,2.79,1.76,1.76,0,0,1-1.28.85l-9.45.59a1,1,0,0,0-.89.95v5.27a1,1,0,0,0,.89.94l9.45.6a1.76,1.76,0,0,1,1.28.85,14,14,0,0,0,2,2.78.74.74,0,0,1-.11,1.15l-5.62,4a.53.53,0,0,0,.05,1l7.09,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.66,2.66,0,0,1,1.65-.09,41.64,41.64,0,0,0,5.58,1.32,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87H379.1a1.11,1.11,0,0,0,1-.87l.9-4.74a1.34,1.34,0,0,1,1-1,41.64,41.64,0,0,0,5.58-1.32,2.63,2.63,0,0,1,1.64.09l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.1-4.09a.53.53,0,0,0,.05-1l-5.63-4a.75.75,0,0,1-.1-1.15,14.44,14.44,0,0,0,2-2.78,1.74,1.74,0,0,1,1.27-.85l9.46-.6a1,1,0,0,0,.88-.94v-5.27a1,1,0,0,0-.88-.95l-9.46-.59a1.74,1.74,0,0,1-1.27-.85,14.19,14.19,0,0,0-2-2.79.75.75,0,0,1,.1-1.15l5.63-4.05a.52.52,0,0,0-.05-.95l-7.1-4.1a1.91,1.91,0,0,0-1.57-.07L389.31,429a2.63,2.63,0,0,1-1.64.1,43.25,43.25,0,0,0-5.58-1.33,1.34,1.34,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1-.87H368.67a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.66,2.66,0,0,1-1.65-.1l-7.19-3.33A1.91,1.91,0,0,0,349.69,425.71Zm36.18,11.14c6.61,3.82,6.61,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S379.25,433,385.87,436.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,425.71l-7.09,4.1a.52.52,0,0,0-.05.95l5.62,4.05a.74.74,0,0,1,.1,1.15,14.13,14.13,0,0,0-2,2.79,1.76,1.76,0,0,1-1.28.85l-9.45.59a1,1,0,0,0-.89.95v5.27a1,1,0,0,0,.89.94l9.45.6a1.76,1.76,0,0,1,1.28.85,14,14,0,0,0,2,2.78.74.74,0,0,1-.11,1.15l-5.62,4a.53.53,0,0,0,.05,1l7.09,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.66,2.66,0,0,1,1.65-.09,41.64,41.64,0,0,0,5.58,1.32,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87H379.1a1.11,1.11,0,0,0,1-.87l.9-4.74a1.34,1.34,0,0,1,1-1,41.64,41.64,0,0,0,5.58-1.32,2.63,2.63,0,0,1,1.64.09l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.1-4.09a.53.53,0,0,0,.05-1l-5.63-4a.75.75,0,0,1-.1-1.15,14.44,14.44,0,0,0,2-2.78,1.74,1.74,0,0,1,1.27-.85l9.46-.6a1,1,0,0,0,.88-.94v-5.27a1,1,0,0,0-.88-.95l-9.46-.59a1.74,1.74,0,0,1-1.27-.85,14.19,14.19,0,0,0-2-2.79.75.75,0,0,1,.1-1.15l5.63-4.05a.52.52,0,0,0-.05-.95l-7.1-4.1a1.91,1.91,0,0,0-1.57-.07L389.31,429a2.63,2.63,0,0,1-1.64.1,43.25,43.25,0,0,0-5.58-1.33,1.34,1.34,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1-.87H368.67a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.66,2.66,0,0,1-1.65-.1l-7.19-3.33A1.91,1.91,0,0,0,349.69,425.71Zm36.18,11.14c6.61,3.82,6.61,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S379.25,433,385.87,436.85Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,466.77H368.67a1.45,1.45,0,0,1-1.39-1.15l-.9-4.74a1,1,0,0,0-.76-.73,45.85,45.85,0,0,1-5.63-1.34,2.27,2.27,0,0,0-1.39.08l-7.19,3.33a2.23,2.23,0,0,1-1.89-.08l-7.1-4.1a.94.94,0,0,1-.5-.75.91.91,0,0,1,.42-.79l5.63-4.05a.42.42,0,0,0,.18-.29.46.46,0,0,0-.13-.34A14.73,14.73,0,0,1,346,449a1.38,1.38,0,0,0-1-.66l-9.45-.6a1.31,1.31,0,0,1-1.21-1.29v-5.27a1.31,1.31,0,0,1,1.21-1.29l9.45-.6a1.39,1.39,0,0,0,1-.67,15,15,0,0,1,2.06-2.85.5.5,0,0,0,.13-.35.44.44,0,0,0-.18-.29l-5.62-4a.88.88,0,0,1,.07-1.55l7.1-4.09a2.27,2.27,0,0,1,1.89-.09l7.19,3.33a2.27,2.27,0,0,0,1.39.09,41.74,41.74,0,0,1,5.63-1.34,1,1,0,0,0,.76-.73l.9-4.74a1.44,1.44,0,0,1,1.39-1.15H379.1a1.45,1.45,0,0,1,1.39,1.15l.9,4.74a1,1,0,0,0,.75.73,41.74,41.74,0,0,1,5.63,1.34,2.31,2.31,0,0,0,1.4-.09l7.19-3.33a2.27,2.27,0,0,1,1.89.09l7.09,4.09a.88.88,0,0,1,.08,1.55l-5.62,4a.4.4,0,0,0-.18.29.42.42,0,0,0,.13.35,14.49,14.49,0,0,1,2.05,2.85,1.41,1.41,0,0,0,1,.67l9.45.6a1.31,1.31,0,0,1,1.21,1.29v5.27a1.31,1.31,0,0,1-1.21,1.29l-9.45.6a1.39,1.39,0,0,0-1,.66,14.67,14.67,0,0,1-2.05,2.86.39.39,0,0,0-.13.34.37.37,0,0,0,.18.29l5.62,4.05a.92.92,0,0,1,.43.79,1,1,0,0,1-.51.75l-7.09,4.1a2.31,2.31,0,0,1-1.89.08l-7.19-3.33a2.23,2.23,0,0,0-1.4-.08,45.26,45.26,0,0,1-5.62,1.34,1,1,0,0,0-.76.73l-.9,4.73A1.45,1.45,0,0,1,379.1,466.77ZM359.43,458a2.66,2.66,0,0,1,.77.1,42.31,42.31,0,0,0,5.54,1.32,1.72,1.72,0,0,1,1.32,1.29l.9,4.74a.76.76,0,0,0,.71.58H379.1a.77.77,0,0,0,.71-.58l.9-4.74a1.7,1.7,0,0,1,1.32-1.29,42.31,42.31,0,0,0,5.54-1.32,3,3,0,0,1,1.89.12l7.19,3.33a1.55,1.55,0,0,0,1.25-.06l7.09-4.09c.1-.06.16-.12.16-.18s0-.13-.14-.2l-5.62-4a1.09,1.09,0,0,1-.16-1.67,14,14,0,0,0,2-2.72,2.1,2.1,0,0,1,1.56-1l9.46-.6a.6.6,0,0,0,.55-.59v-5.27a.61.61,0,0,0-.56-.6l-9.45-.6a2.07,2.07,0,0,1-1.56-1,14.27,14.27,0,0,0-2-2.71,1.17,1.17,0,0,1-.31-.89,1.12,1.12,0,0,1,.47-.78l5.62-4a.28.28,0,0,0,.14-.19c0-.06-.06-.13-.16-.18L397.9,426a1.6,1.6,0,0,0-1.25-.06l-7.19,3.34a3,3,0,0,1-1.9.11,42.16,42.16,0,0,0-5.53-1.32,1.68,1.68,0,0,1-1.32-1.28l-.9-4.74a.77.77,0,0,0-.71-.59H368.67a.76.76,0,0,0-.71.59l-.9,4.74a1.71,1.71,0,0,1-1.32,1.28,43.17,43.17,0,0,0-5.54,1.32,3,3,0,0,1-1.9-.11L351.11,426a1.6,1.6,0,0,0-1.25.06l-7.09,4.1a.27.27,0,0,0-.16.18.28.28,0,0,0,.14.19l5.62,4a1.08,1.08,0,0,1,.47.78,1.17,1.17,0,0,1-.31.89,14,14,0,0,0-2,2.71,2.07,2.07,0,0,1-1.56,1l-9.45.6a.61.61,0,0,0-.56.6v5.27a.6.6,0,0,0,.56.59l9.45.6a2.08,2.08,0,0,1,1.56,1,14,14,0,0,0,2,2.72,1.13,1.13,0,0,1,.31.88,1.1,1.1,0,0,1-.47.79l-5.62,4c-.09.07-.14.14-.14.2s.06.12.16.18l7.09,4.09a1.58,1.58,0,0,0,1.26.06l7.18-3.33A2.71,2.71,0,0,1,359.43,458Zm14.45-4.14A24.85,24.85,0,0,1,361.72,451c-3.31-1.91-5.13-4.47-5.13-7.22s1.82-5.31,5.13-7.22c6.71-3.87,17.62-3.87,24.32,0h0c3.31,1.91,5.14,4.48,5.14,7.22s-1.83,5.31-5.14,7.22A24.8,24.8,0,0,1,373.88,453.9Zm0-19.57a24.26,24.26,0,0,0-11.81,2.82c-3.09,1.79-4.79,4.14-4.79,6.62s1.7,4.84,4.79,6.62c6.52,3.76,17.11,3.76,23.62,0,3.09-1.78,4.79-4.13,4.79-6.62s-1.7-4.83-4.79-6.62h0A24.26,24.26,0,0,0,373.88,434.33Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-191",
    d: "M432.57,426.49l-.95-1.85c-.95-.09-1.89-.21-2.8-.37h0l-3.19,2.12a5.24,5.24,0,0,1-2.87.82,4.77,4.77,0,0,1-1.83-.34l-4.93-2a3.68,3.68,0,0,1-1.33-6l.67-.72-5.23.21a4.54,4.54,0,0,1-4.24-3.11l-.85-2.72a3.93,3.93,0,0,1,3.11-5.08L411,407l-1.06-.53a3.65,3.65,0,0,1-.71-6.18l3.14-2.61a5.17,5.17,0,0,1,3.28-1.14,4.69,4.69,0,0,1,1.42.21l4.67,1.46h.07s0,0,0,0c.49-.21,1-.42,1.52-.61l-.11-.95a4.07,4.07,0,0,1,3.62-4.54l6.15-.64.45,0a4.74,4.74,0,0,1,4.12,2.5l.95,1.85c.95.09,1.89.21,2.81.37h0l3.19-2.12a5.25,5.25,0,0,1,2.87-.83,5,5,0,0,1,1.83.34l4.92,2a3.68,3.68,0,0,1,1.34,6l-.67.72,5.23-.21a4.55,4.55,0,0,1,4.24,3.1l.85,2.72A3.94,3.94,0,0,1,462,413l-2.88.49,1.06.54a3.65,3.65,0,0,1,.71,6.17l-3.14,2.62a5.23,5.23,0,0,1-3.29,1.14,4.67,4.67,0,0,1-1.41-.21l-4.68-1.47h-.07s0,0,0,0c-.49.21-1,.41-1.52.6l.11.95a4.06,4.06,0,0,1-3.62,4.54l-6.16.65-.44,0A4.73,4.73,0,0,1,432.57,426.49Zm-5.25-17.86c-.42.35-1.11,1-1,1.71s1,1.79,3.16,2.65a15.15,15.15,0,0,0,5.58,1c3.13,0,6.1-.85,7.75-2.23.42-.35,1.11-1,1-1.71s-1-1.78-3.16-2.65a15.19,15.19,0,0,0-5.58-1C431.94,406.41,429,407.26,427.32,408.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423,395.78a3.39,3.39,0,0,1-2,.14l-4.79-1.5a2.22,2.22,0,0,0-1.88.37l-3.14,2.61a.76.76,0,0,0-.31.59h0V403h0a.7.7,0,0,0,.44.62l1.7.86-4.36.74a.92.92,0,0,0-.78.94h0v5.06h0a1.15,1.15,0,0,0,0,.31l.85,2.72a1.52,1.52,0,0,0,1.43,1l5.62-.23a2.73,2.73,0,0,1,1.36.42l-.29.31a.8.8,0,0,0-.24.54h0v5.07h0a.72.72,0,0,0,.51.66l4.92,2a2.3,2.3,0,0,0,1.93-.2l3.31-2.2a3.14,3.14,0,0,1,2-.39c1.05.18,2.11.31,3.19.39a2.17,2.17,0,0,1,1.59,1l1.23,2.39a1.7,1.7,0,0,0,1.58.86l6.16-.64a1.08,1.08,0,0,0,1-1.06h0v-3.43a1.34,1.34,0,0,1,.63-.44,25.21,25.21,0,0,0,2.57-.95,3.39,3.39,0,0,1,2-.13l4.78,1.5a2.27,2.27,0,0,0,1.89-.37l3.14-2.62a.74.74,0,0,0,.31-.56h0v-5.08h0a.72.72,0,0,0-.44-.62l-1.7-.85,4.36-.75a.91.91,0,0,0,.79-.88h0V404h0a1.23,1.23,0,0,0,0-.33l-.86-2.72a1.49,1.49,0,0,0-1.42-1l-5.62.22a2.54,2.54,0,0,1-1.36-.42l.29-.3a.79.79,0,0,0,.24-.55h0v-5h0v-.06h0a.72.72,0,0,0-.51-.63l-4.92-2a2.33,2.33,0,0,0-1.93.19l-3.31,2.2a3.14,3.14,0,0,1-2,.4c-1.05-.18-2.11-.31-3.19-.39a2.19,2.19,0,0,1-1.59-1l-1.23-2.39a1.7,1.7,0,0,0-1.58-.86l-6.16.64a1.06,1.06,0,0,0-.95,1.2l.28,2.34a1.35,1.35,0,0,1-.92,1.39A25.18,25.18,0,0,0,423,395.78Zm21.75,13.14c-3.7,3.09-11,3.85-16.37,1.71a9.11,9.11,0,0,1-4.21-3.05,7.29,7.29,0,0,1,1.25-1.33c3.7-3.08,11-3.84,16.37-1.71a9.19,9.19,0,0,1,4.2,3A6.65,6.65,0,0,1,444.73,408.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,395.78a3.39,3.39,0,0,1-2,.14l-4.79-1.5a2.22,2.22,0,0,0-1.88.37l-3.14,2.61a.76.76,0,0,0-.31.59h0V403h0a.7.7,0,0,0,.44.62l1.7.86-4.36.74a.92.92,0,0,0-.78.94h0v5.06h0a1.15,1.15,0,0,0,0,.31l.85,2.72a1.52,1.52,0,0,0,1.43,1l5.62-.23a2.73,2.73,0,0,1,1.36.42l-.29.31a.8.8,0,0,0-.24.54h0v5.07h0a.72.72,0,0,0,.51.66l4.92,2a2.3,2.3,0,0,0,1.93-.2l3.31-2.2a3.14,3.14,0,0,1,2-.39c1.05.18,2.11.31,3.19.39a2.17,2.17,0,0,1,1.59,1l1.23,2.39a1.7,1.7,0,0,0,1.58.86l6.16-.64a1.08,1.08,0,0,0,1-1.06h0v-3.43a1.34,1.34,0,0,1,.63-.44,25.21,25.21,0,0,0,2.57-.95,3.39,3.39,0,0,1,2-.13l4.78,1.5a2.27,2.27,0,0,0,1.89-.37l3.14-2.62a.74.74,0,0,0,.31-.56h0v-5.08h0a.72.72,0,0,0-.44-.62l-1.7-.85,4.36-.75a.91.91,0,0,0,.79-.88h0V404h0a1.23,1.23,0,0,0,0-.33l-.86-2.72a1.49,1.49,0,0,0-1.42-1l-5.62.22a2.54,2.54,0,0,1-1.36-.42l.29-.3a.79.79,0,0,0,.24-.55h0v-5h0v-.06h0a.72.72,0,0,0-.51-.63l-4.92-2a2.33,2.33,0,0,0-1.93.19l-3.31,2.2a3.14,3.14,0,0,1-2,.4c-1.05-.18-2.11-.31-3.19-.39a2.19,2.19,0,0,1-1.59-1l-1.23-2.39a1.7,1.7,0,0,0-1.58-.86l-6.16.64a1.06,1.06,0,0,0-.95,1.2l.28,2.34a1.35,1.35,0,0,1-.92,1.39A25.18,25.18,0,0,0,423,395.78Zm21.75,13.14c-3.7,3.09-11,3.85-16.37,1.71a9.11,9.11,0,0,1-4.21-3.05,7.29,7.29,0,0,1,1.25-1.33c3.7-3.08,11-3.84,16.37-1.71a9.19,9.19,0,0,1,4.2,3A6.65,6.65,0,0,1,444.73,408.92Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.47,408.08a1.06,1.06,0,0,0,.45,1.45l2.25,1.13,4.36-.74a.93.93,0,0,0,.79-.89v-5a.93.93,0,0,1-.79.84l-5.36.91a1.84,1.84,0,0,0-1.3,1.25A8.65,8.65,0,0,1,454.47,408.08Zm-.92-14.29a.77.77,0,0,1-.24.54l-2.24,2.38a1,1,0,0,0,.14,1.44,11.3,11.3,0,0,1,1.35,1.2,2.16,2.16,0,0,0,.46.36l.29-.31a.81.81,0,0,0,.24-.55h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.77,399.48c4.6,1.84,6.22,5.24,4.19,8.11a9,9,0,0,0-4.19-3c-5.34-2.13-12.66-1.37-16.37,1.71a6.58,6.58,0,0,0-1.24,1.33c-1.43-2-1.1-4.45,1.24-6.4C429.1,398.1,436.43,397.34,441.77,399.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.49,422.08a1.81,1.81,0,0,1,.53.58l1.23,2.39a1.62,1.62,0,0,0,.9.76v-5.07a1.76,1.76,0,0,1-.91-.76L434,417.59a1.66,1.66,0,0,0-.51-.59Zm-16.91-.68a.7.7,0,0,0,.5.65l4.93,2a2.24,2.24,0,0,0,1.29.05V419A2.33,2.33,0,0,1,422,419l-4.92-2a.7.7,0,0,1-.51-.66h0Zm32.66-2.12,4.73,1.48a2.23,2.23,0,0,0,1.2,0v-5.06a2.1,2.1,0,0,1-1.19,0l-4.72-1.49Zm-41.43-8a.87.87,0,0,0,.05.31l.84,2.72a1.52,1.52,0,0,0,1.42,1l5.63-.23a2.66,2.66,0,0,1,.88.18v-5.06a2.15,2.15,0,0,0-.87-.18l-5.63.22a1.51,1.51,0,0,1-1.42-1l-.85-2.72a1.57,1.57,0,0,1-.05-.3Zm3-8.21h0a.72.72,0,0,0,.44.63l1.71.84,1-.16a1.83,1.83,0,0,0,1.31-1.26,6.26,6.26,0,0,1,.41-1.06l.09-.27a1.5,1.5,0,0,0,0-.2,1,1,0,0,0-.06-.4.92.92,0,0,0-.27-.41.86.86,0,0,0-.23-.17l-4-2a1.35,1.35,0,0,1-.25-.18.7.7,0,0,1-.21-.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.49,422.08a1.81,1.81,0,0,1,.53.58l1.23,2.39a1.62,1.62,0,0,0,.9.76v-5.07a1.76,1.76,0,0,1-.91-.76L434,417.59a1.66,1.66,0,0,0-.51-.59Zm-16.91-.68a.7.7,0,0,0,.5.65l4.93,2a2.24,2.24,0,0,0,1.29.05V419A2.33,2.33,0,0,1,422,419l-4.92-2a.7.7,0,0,1-.51-.66h0Zm32.66-2.12,4.73,1.48a2.23,2.23,0,0,0,1.2,0v-5.06a2.1,2.1,0,0,1-1.19,0l-4.72-1.49Zm-41.43-8a.87.87,0,0,0,.05.31l.84,2.72a1.52,1.52,0,0,0,1.42,1l5.63-.23a2.66,2.66,0,0,1,.88.18v-5.06a2.15,2.15,0,0,0-.87-.18l-5.63.22a1.51,1.51,0,0,1-1.42-1l-.85-2.72a1.57,1.57,0,0,1-.05-.3Zm3-8.21h0a.72.72,0,0,0,.44.63l1.71.84,1-.16a1.83,1.83,0,0,0,1.31-1.26,6.26,6.26,0,0,1,.41-1.06l.09-.27a1.5,1.5,0,0,0,0-.2,1,1,0,0,0-.06-.4.92.92,0,0,0-.27-.41.86.86,0,0,0-.23-.17l-4-2a1.35,1.35,0,0,1-.25-.18.7.7,0,0,1-.21-.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.27,394.79l-3.14,2.61a.67.67,0,0,0,.13,1.2l3.95,2a1.07,1.07,0,0,1,.45,1.45,9.15,9.15,0,0,0-.4,1.06,1.85,1.85,0,0,1-1.31,1.26l-5.35.91a.93.93,0,0,0-.75,1.23l.85,2.72a1.5,1.5,0,0,0,1.42,1l5.63-.22a2.73,2.73,0,0,1,1.82.77,12.25,12.25,0,0,0,1.35,1.2,1,1,0,0,1,.13,1.44l-2.23,2.38a.69.69,0,0,0,.27,1.2l4.92,2a2.33,2.33,0,0,0,1.93-.19l3.31-2.2a3.07,3.07,0,0,1,2-.4q1.58.27,3.18.39a2.19,2.19,0,0,1,1.6,1l1.22,2.39a1.73,1.73,0,0,0,1.59.86l6.16-.64a1.06,1.06,0,0,0,.95-1.2l-.28-2.34a1.34,1.34,0,0,1,.92-1.39,23,23,0,0,0,2.57-.95,3.36,3.36,0,0,1,2-.13l4.79,1.5a2.23,2.23,0,0,0,1.89-.37L459,412.7a.66.66,0,0,0-.13-1.19l-3.95-2a1.08,1.08,0,0,1-.46-1.45,7.7,7.7,0,0,0,.41-1.06,1.83,1.83,0,0,1,1.3-1.26l5.36-.91a.94.94,0,0,0,.75-1.23l-.86-2.72a1.49,1.49,0,0,0-1.42-1l-5.62.22a2.71,2.71,0,0,1-1.82-.77,12.14,12.14,0,0,0-1.35-1.2,1,1,0,0,1-.14-1.44l2.24-2.38a.69.69,0,0,0-.27-1.2l-4.92-2a2.33,2.33,0,0,0-1.93.19l-3.31,2.2a3.14,3.14,0,0,1-2,.4c-1.05-.18-2.11-.31-3.19-.39a2.19,2.19,0,0,1-1.59-1l-1.23-2.39a1.7,1.7,0,0,0-1.58-.86l-6.16.64a1.06,1.06,0,0,0-.95,1.2l.28,2.34a1.35,1.35,0,0,1-.92,1.39,25.18,25.18,0,0,0-2.57.94,3.39,3.39,0,0,1-2,.14l-4.79-1.5A2.22,2.22,0,0,0,414.27,394.79Zm27.5,4.69c5.33,2.13,6.66,6.36,3,9.44s-11,3.85-16.37,1.71-6.66-6.36-3-9.45S436.43,397.34,441.77,399.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.27,394.79l-3.14,2.61a.67.67,0,0,0,.13,1.2l3.95,2a1.07,1.07,0,0,1,.45,1.45,9.15,9.15,0,0,0-.4,1.06,1.85,1.85,0,0,1-1.31,1.26l-5.35.91a.93.93,0,0,0-.75,1.23l.85,2.72a1.5,1.5,0,0,0,1.42,1l5.63-.22a2.73,2.73,0,0,1,1.82.77,12.25,12.25,0,0,0,1.35,1.2,1,1,0,0,1,.13,1.44l-2.23,2.38a.69.69,0,0,0,.27,1.2l4.92,2a2.33,2.33,0,0,0,1.93-.19l3.31-2.2a3.07,3.07,0,0,1,2-.4q1.58.27,3.18.39a2.19,2.19,0,0,1,1.6,1l1.22,2.39a1.73,1.73,0,0,0,1.59.86l6.16-.64a1.06,1.06,0,0,0,.95-1.2l-.28-2.34a1.34,1.34,0,0,1,.92-1.39,23,23,0,0,0,2.57-.95,3.36,3.36,0,0,1,2-.13l4.79,1.5a2.23,2.23,0,0,0,1.89-.37L459,412.7a.66.66,0,0,0-.13-1.19l-3.95-2a1.08,1.08,0,0,1-.46-1.45,7.7,7.7,0,0,0,.41-1.06,1.83,1.83,0,0,1,1.3-1.26l5.36-.91a.94.94,0,0,0,.75-1.23l-.86-2.72a1.49,1.49,0,0,0-1.42-1l-5.62.22a2.71,2.71,0,0,1-1.82-.77,12.14,12.14,0,0,0-1.35-1.2,1,1,0,0,1-.14-1.44l2.24-2.38a.69.69,0,0,0-.27-1.2l-4.92-2a2.33,2.33,0,0,0-1.93.19l-3.31,2.2a3.14,3.14,0,0,1-2,.4c-1.05-.18-2.11-.31-3.19-.39a2.19,2.19,0,0,1-1.59-1l-1.23-2.39a1.7,1.7,0,0,0-1.58-.86l-6.16.64a1.06,1.06,0,0,0-.95,1.2l.28,2.34a1.35,1.35,0,0,1-.92,1.39,25.18,25.18,0,0,0-2.57.94,3.39,3.39,0,0,1-2,.14l-4.79-1.5A2.22,2.22,0,0,0,414.27,394.79Zm27.5,4.69c5.33,2.13,6.66,6.36,3,9.44s-11,3.85-16.37,1.71-6.66-6.36-3-9.45S436.43,397.34,441.77,399.48Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7,421.28a2.17,2.17,0,0,1-1.84-1.1l-1.23-2.39a1.73,1.73,0,0,0-1.24-.81c-1.09-.08-2.18-.22-3.23-.4a2.8,2.8,0,0,0-1.67.33l-3.31,2.2a2.77,2.77,0,0,1-2.33.24l-4.92-2a1.17,1.17,0,0,1-.76-.83,1.19,1.19,0,0,1,.34-1.07l2.23-2.37a.53.53,0,0,0,.15-.4.56.56,0,0,0-.24-.41,13.93,13.93,0,0,1-1.39-1.24,2.36,2.36,0,0,0-1.49-.65l-5.63.23a1.92,1.92,0,0,1-1.85-1.3l-.85-2.72a1.36,1.36,0,0,1,1.09-1.78l5.35-.92a1.42,1.42,0,0,0,1-.95,8.5,8.5,0,0,1,.42-1.12A.65.65,0,0,0,415,401l-3.95-2a1.17,1.17,0,0,1-.68-.89,1.18,1.18,0,0,1,.46-1l3.14-2.61a2.69,2.69,0,0,1,2.29-.46l4.79,1.51a3,3,0,0,0,1.74-.12,23.53,23.53,0,0,1,2.61-1,.92.92,0,0,0,.62-.93l-.28-2.34a1.51,1.51,0,0,1,.31-1.12,1.54,1.54,0,0,1,1-.56l6.15-.64a2.15,2.15,0,0,1,2,1.09l1.22,2.39a1.8,1.8,0,0,0,1.25.81,31,31,0,0,1,3.23.4,2.74,2.74,0,0,0,1.67-.34L446,391a2.77,2.77,0,0,1,2.33-.24l4.92,2a1.12,1.12,0,0,1,.42,1.9L451.39,397a.5.5,0,0,0-.15.4.56.56,0,0,0,.24.41,15.3,15.3,0,0,1,1.39,1.24,2.34,2.34,0,0,0,1.49.64l5.63-.22a1.94,1.94,0,0,1,1.85,1.3l.85,2.72a1.37,1.37,0,0,1-1.09,1.78l-5.35.92a1.4,1.4,0,0,0-1,.95,7.35,7.35,0,0,1-.43,1.12.65.65,0,0,0,.26.89l3.95,2a1.15,1.15,0,0,1,.68.89,1.18,1.18,0,0,1-.46,1l-3.15,2.61a2.64,2.64,0,0,1-2.29.45l-4.78-1.5a3,3,0,0,0-1.74.12,24.3,24.3,0,0,1-2.61,1,.92.92,0,0,0-.62.93l.28,2.34a1.47,1.47,0,0,1-.32,1.12,1.5,1.5,0,0,1-1,.56l-6.15.64Zm-7.85-5.58a3.33,3.33,0,0,1,.46,0c1,.18,2.08.31,3.15.39a2.57,2.57,0,0,1,1.94,1.28l1.23,2.38a1.26,1.26,0,0,0,1.16.63l6.15-.64a.63.63,0,0,0,.44-.24.59.59,0,0,0,.13-.48l-.28-2.34a1.78,1.78,0,0,1,1.22-1.85,25,25,0,0,0,2.53-.93,3.74,3.74,0,0,1,2.33-.15l4.79,1.5a1.81,1.81,0,0,0,1.48-.29l3.15-2.62a.33.33,0,0,0,.15-.26c0-.07-.08-.15-.21-.21l-3.95-2a1.49,1.49,0,0,1-.65-2,5.84,5.84,0,0,0,.38-1,2.26,2.26,0,0,1,1.65-1.56l5.35-.92a.49.49,0,0,0,.42-.67L461,401a1.08,1.08,0,0,0-1-.7l-5.62.22a3.16,3.16,0,0,1-2.15-.9,13.39,13.39,0,0,0-1.3-1.16,1.44,1.44,0,0,1-.57-1,1.36,1.36,0,0,1,.38-1L453,394a.37.37,0,0,0,.13-.3.37.37,0,0,0-.24-.21l-4.92-2a1.94,1.94,0,0,0-1.53.16l-3.31,2.2a3.53,3.53,0,0,1-2.3.46c-1-.17-2.08-.3-3.15-.39a2.53,2.53,0,0,1-1.94-1.27l-1.23-2.39a1.28,1.28,0,0,0-1.16-.62l-6.15.64a.65.65,0,0,0-.58.72l.29,2.34a1.78,1.78,0,0,1-1.23,1.85,24.85,24.85,0,0,0-2.52.93,3.81,3.81,0,0,1-2.33.15l-4.79-1.5a1.84,1.84,0,0,0-1.49.29l-3.14,2.62a.33.33,0,0,0-.15.25c0,.08.08.16.21.22l4,2a1.5,1.5,0,0,1,.64,2,8.17,8.17,0,0,0-.38,1,2.24,2.24,0,0,1-1.64,1.56l-5.36.92a.52.52,0,0,0-.37.23.55.55,0,0,0,0,.44l.85,2.72a1.14,1.14,0,0,0,1,.7l5.62-.22a3.14,3.14,0,0,1,2.15.9,13.39,13.39,0,0,0,1.3,1.16,1.44,1.44,0,0,1,.57,1,1.4,1.4,0,0,1-.38,1.05l-2.24,2.37a.38.38,0,0,0-.12.3.34.34,0,0,0,.24.21l4.92,2a1.94,1.94,0,0,0,1.53-.15l3.31-2.2A3.59,3.59,0,0,1,428.85,415.7Zm6.18-3.43A18.49,18.49,0,0,1,428.2,411c-3-1.2-4.93-3.13-5.27-5.3a5.27,5.27,0,0,1,2.2-4.88c3.8-3.16,11.34-4,16.8-1.77h0c3,1.2,4.93,3.13,5.27,5.29a5.28,5.28,0,0,1-2.2,4.89C442.65,411.21,438.87,412.27,435,412.27Zm0-13.58c-3.63,0-7.19,1-9.39,2.83a4.4,4.4,0,0,0-1.9,4.08c.29,1.85,2,3.54,4.74,4.63,5.2,2.09,12.35,1.35,15.93-1.64a4.4,4.4,0,0,0,1.9-4.08c-.29-1.86-2-3.54-4.74-4.64h0A17.82,17.82,0,0,0,435.07,398.69Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.52,394.92c0,3.46,2.59,5.68,5.79,7.52l131,75.63a12.75,12.75,0,0,0,11.57,0l211.32-122c3.2-1.85,5.79-4.22,5.79-7.69s-2.59-5.6-5.79-7.44l-131-75.63a12.75,12.75,0,0,0-11.57,0l-211.32,122C68.11,389.16,65.52,391.46,65.52,394.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,394l131,75.63a12.75,12.75,0,0,0,11.57,0l211.32-122c3.2-1.85,3.2-4.84,0-6.68l-131-75.63a12.75,12.75,0,0,0-11.57,0l-211.32,122C68.11,389.16,68.11,392.15,71.31,394Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09,471v8.43a11.72,11.72,0,0,1-5.79-1.38l-131-75.63c-3.2-1.84-5.79-4.06-5.79-7.52,0-3.25,2.33-5.51,5.34-7.35-2.48,1.75-2.53,4.7.45,6.43l131,75.63A11.84,11.84,0,0,0,208.09,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18,388.29,283.37,276.18a6,6,0,0,1,5.46,0l7.08,4c1.5.87,1.5,2.28,0,3.15L101.68,395.4a6,6,0,0,1-5.45,0l-7-3.95C87.68,390.58,87.68,389.16,89.18,388.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,399.54,302.44,287.43a5.58,5.58,0,0,1,5-.28L358,316.34c1.25.72,1,2-.47,2.88l-194,112a5.58,5.58,0,0,1-5,.28l-50.76-29C106.54,401.7,106.75,400.41,108.25,399.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,334.52,282.6,331c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51l5.82,3.36A1,1,0,0,0,276.52,334.52Zm-8.88-12.15-6.08,3.51c-.25.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36A1,1,0,0,0,267.64,322.37ZM248,333.71l-10.29,5.94c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l10.29-5.94c.26-.15.28-.38,0-.51l-5.82-3.36A1,1,0,0,0,248,333.71Zm10.76-6.21L252.68,331c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38,0-.51l-5.82-3.36A1,1,0,0,0,258.76,327.5Zm-23.85,13.77-6.08,3.51c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36A1,1,0,0,0,234.91,341.27ZM226,346.4l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,226,346.4Zm22.8,13.71,6.08-3.51c.26-.15.28-.38,0-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,248.82,360.11Zm-8.89,5.13,6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51l5.82,3.36A1,1,0,0,0,239.93,365.24Zm-8.88,5.13,6.08-3.51c.25-.15.28-.38.05-.51L231.36,363a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,231.05,370.37Zm-8.89,5.13,6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.26.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,222.16,375.5Zm45.48-35.85,6.08-3.51c.25-.15.28-.38,0-.51L268,332.27a1,1,0,0,0-.88,0L261,335.81c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,267.64,339.65ZM257.71,355l13.56-7.83c.26-.15.28-.38.05-.51l-14.13-8.16a1,1,0,0,0-.88,0l-7,4.05c-.26.15-.29.38-.06.51l7.48,4.32c.23.13.21.36-.05.51l-5.61,3.24c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,257.71,355Zm-40.58-3.45L211.05,355c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51L218,351.5A1,1,0,0,0,217.13,351.53Zm-8.88,5.13-6.08,3.51c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36A1,1,0,0,0,208.25,356.66Zm-49.18,54.78a1,1,0,0,0,.88,0L166,407.9c.25-.15.28-.38.05-.51L160.27,404a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.06.51Zm-21.92-13.73-6.08,3.51c-.25.15-.28.38,0,.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51L138,397.68A1,1,0,0,0,137.15,397.71ZM148.42,408a1,1,0,0,0,.89,0l6.08-3.52c.25-.14.28-.37.05-.51l-5.82-3.35a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.37,0,.51Zm24.52,5.51L179,410c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,172.94,413.51Zm-9.77,5.16a1,1,0,0,0,.88,0l6.09-3.51c.25-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51ZM146,392.58,140,396.09c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,146,392.58Zm44.43-25.65-6.08,3.51c-.25.15-.28.37,0,.51l5.82,3.35a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.37,0-.51l-5.81-3.35A1,1,0,0,0,190.47,366.93Zm-35.54,20.52L148.85,391c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38,0-.51l-5.82-3.36A1,1,0,0,0,154.93,387.45Zm44.43-25.66-6.08,3.52c-.26.14-.28.37-.05.51l5.81,3.35a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.37.05-.51l-5.82-3.36A1,1,0,0,0,199.36,361.79Zm-17.77,10.27-6.08,3.51c-.26.15-.29.37-.06.51l5.82,3.35a1,1,0,0,0,.89,0l6.07-3.51c.26-.14.29-.37.06-.51L182.47,372A1,1,0,0,0,181.59,372.06Zm-8.89,5.13-6.08,3.51c-.26.15-.28.37-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.52l-5.82-3.35A1,1,0,0,0,172.7,377.19Zm-8.89,5.13-6.08,3.51c-.25.15-.28.37,0,.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36A1,1,0,0,0,163.81,382.32Zm40.58,3.44,6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,204.39,385.76ZM287.29,311l-6.08,3.51c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38.05-.51L288.17,311A1,1,0,0,0,287.29,311Zm-10.76,6.21-6.08,3.51c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,276.53,317.24Zm19.64-11.34-6.08,3.51c-.25.15-.28.38,0,.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36A1,1,0,0,0,296.17,305.9Zm-49.11,45.63,6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51l5.81,3.36A1,1,0,0,0,247.06,351.53Zm58.88-50.79a1,1,0,0,0-.88,0L299,304.28c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51Zm-92.67,79.89,6.08-3.51c.26-.15.28-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51l5.82,3.36A1,1,0,0,0,213.27,380.63Zm109-62.92,6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,322.25,317.71Zm-17.2.34,6.08-3.52c.26-.14.28-.37.05-.5l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.37,0,.51l5.82,3.36A1,1,0,0,0,305.05,318.05Zm9.2-12.51a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.37-.05.51l5.82,3.35a1,1,0,0,0,.88,0L320,309.4c.26-.14.28-.37.05-.51Zm1.87-1.08,14.13,8.15a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-14.13-8.15a1,1,0,0,0-.88,0L316.18,304C315.92,304.09,315.9,304.32,316.12,304.46ZM295.6,315.83l-6.08,3.51c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,295.6,315.83Zm-66.88,38.61L222.64,358c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36A1,1,0,0,0,228.72,354.44Zm83.76-31.57a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.37.05-.51l-5.81-3.36a1,1,0,0,0-.89,0L306.71,319c-.25.15-.28.38,0,.51ZM237.6,349.31l-6.08,3.51c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36A1,1,0,0,0,237.6,349.31Zm-69.64,57a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51Zm-10.33-10.82L151.55,399c-.26.15-.29.37-.06.51l5.82,3.35a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.37,0-.51l-5.81-3.35A1,1,0,0,0,157.63,395.49Zm20.1,5.66,6.08-3.51c.26-.15.28-.38.05-.51L178,393.77a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,177.73,401.15Zm8.88-5.13,6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0L180,392.18c-.26.15-.29.38-.06.51l5.82,3.36A1,1,0,0,0,186.61,396Zm8.89-5.13,6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.26.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,195.5,390.89Zm-29-.53-6.08,3.51c-.26.14-.28.37-.05.51l5.82,3.35a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.37.05-.51l-5.82-3.35A1,1,0,0,0,166.51,390.36Zm8.89-5.14-6.08,3.51c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.37,0-.51l-5.82-3.36A1,1,0,0,0,175.4,385.22Zm35.54-20.52-6.08,3.51c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36A1,1,0,0,0,210.94,364.7Zm-8.88,5.13L196,373.34c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36A1,1,0,0,0,202.06,369.83Zm17.77-10.26-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,219.83,359.57Zm-35.55,20.52-6.08,3.51c-.25.15-.28.38,0,.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36A1,1,0,0,0,184.28,380.09Zm8.89-5.13-6.08,3.51c-.26.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36A1,1,0,0,0,193.17,375Zm-11.34,33.42,6.08-3.51c.26-.15.28-.38.05-.51L182.14,401a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,181.83,408.38ZM135,406.17l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51C135.18,406.53,135.2,406.3,135,406.17Zm11.58,2.91-5.81-3.36a1,1,0,0,0-.89,0l-9.35,5.4c-.26.15-.28.37-.05.51l5.81,3.36a1,1,0,0,0,.89,0l9.35-5.4C146.76,409.44,146.78,409.21,146.55,409.08Zm-20.26-9.55-5.82-3.35a1,1,0,0,0-.88,0l-7.49,4.32c-.25.15-.28.37,0,.51l5.82,3.36a1,1,0,0,0,.88,0l7.48-4.32C126.49,399.9,126.52,399.67,126.29,399.53Zm5.73-3.31a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51Zm25.18,16.3-5.82-3.36a1,1,0,0,0-.88,0l-11.69,6.75c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0L157.15,413C157.41,412.88,157.43,412.66,157.2,412.52Zm4.1,7.23-5.82-3.36a1,1,0,0,0-.88,0l-7.48,4.32c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l7.48-4.32C161.51,420.11,161.53,419.88,161.3,419.75Zm36.8-61.67a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51Zm-17.78,10.26a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.06.51Zm-39.41,22.75a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51Zm48.3-27.88a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51Zm-17.77,10.26a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51Zm-5.77,46.64a1,1,0,0,0-.89,0l-9.35,5.4c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l9.35-5.4c.26-.15.28-.38,0-.51Zm-7-39.28a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38,0-.51l-5.82-3.36a1,1,0,0,0-.88,0L152.92,377c-.26.15-.28.38,0,.51ZM149.8,386a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51L151,378.55a1,1,0,0,0-.88,0L144,382.09c-.26.15-.28.38-.05.51Zm180.5-60.9a1,1,0,0,0-.89,0l-15,8.64c-.26.15-.28.38-.06.51l5.82,3.36a1,1,0,0,0,.89,0l15-8.64c.26-.15.28-.38.05-.51ZM310.65,336.4a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.38.05-.51ZM190.71,403.25l6.08-3.51c.26-.15.29-.38.06-.51L191,395.87a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51l5.82,3.36A1,1,0,0,0,190.71,403.25Zm102.17-56.59a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51Zm46.3-26.73a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0L345,323.8c.26-.15.28-.38.05-.51Zm14.71-1.77L339.76,310a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51l14.13,8.16a1,1,0,0,0,.88,0l6.08-3.51C354.09,318.52,354.12,318.29,353.89,318.16Zm-94.22,47.67a1,1,0,0,0-.88,0l-7.48,4.32c-.26.15-.28.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l7.49-4.32c.26-.15.28-.38.05-.51Zm22.45-13a1,1,0,0,0-.88,0l-9.35,5.4c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l9.36-5.4c.26-.15.28-.38.05-.51Zm-43,24.84a1,1,0,0,0-.88,0l-50,28.89c-.26.15-.28.38-.06.51l5.82,3.36a1,1,0,0,0,.89,0l50-28.9c.26-.15.28-.37,0-.51Zm-52.85,30.52a1,1,0,0,0-.88,0l-7.48,4.32c-.26.15-.28.38,0,.51l5.81,3.36a1,1,0,0,0,.89,0L192,412.1c.26-.15.28-.38.05-.51Zm63.14-36.46a1,1,0,0,0-.88,0L241,376.12c-.26.15-.28.38-.05.52l5.81,3.35a1,1,0,0,0,.89,0l7.48-4.32c.26-.15.28-.37,0-.51ZM176,414.17a1,1,0,0,0-.88,0l-7.48,4.32c-.26.15-.28.38-.05.51l5.81,3.36a1,1,0,0,0,.89,0l7.48-4.32c.26-.15.28-.38.05-.51Zm94-54.28a1,1,0,0,0-.88,0l-7.48,4.32c-.26.15-.29.38-.06.51l5.82,3.36a1,1,0,0,0,.88,0l7.49-4.32c.26-.15.28-.38,0-.51Zm31.81-18.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51l5.82,3.36a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51Zm19.9-13.89,6.08-3.51c.26-.15.28-.38.05-.51L322,320.26a1,1,0,0,0-.89,0L315,323.8c-.25.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,321.67,327.64Zm-36.26,1.75,6.08-3.51c.26-.15.28-.38.05-.51L285.72,322a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,285.41,329.39Zm-23.6,32.81,17.77-10.26c.26-.15.28-.37.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-17.77,10.26c-.26.15-.28.37,0,.51l5.81,3.35A1,1,0,0,0,261.81,362.2Zm50.09-29.4a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.06.51ZM304.48,328l6.08-3.51c.25-.15.28-.37.05-.51l-5.82-3.35a1,1,0,0,0-.88,0l-6.08,3.52c-.26.14-.28.37-.05.51l5.81,3.35A1,1,0,0,0,304.48,328Zm-51.56,39.37,6.08-3.52c.26-.14.28-.37.05-.51L253.23,360a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.37-.05.51l5.82,3.35A1,1,0,0,0,252.92,367.34Zm39.34-23.2a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51ZM208.49,393l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51L207.6,393A1,1,0,0,0,208.49,393Zm8.88-5.13,6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0L210.73,384c-.26.15-.29.38-.06.51l5.82,3.36A1,1,0,0,0,217.37,387.86ZM199.6,398.12l6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0L193,394.28c-.26.15-.28.38,0,.51l5.82,3.36A1,1,0,0,0,199.6,398.12Zm35.55-20.52,6.08-3.51c.25-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,235.15,377.6Zm-8.89,5.13,6.08-3.51c.26-.15.28-.38,0-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.82,3.36A1,1,0,0,0,226.26,382.73ZM244,372.47l6.08-3.52c.26-.14.28-.37.06-.51l-5.82-3.35a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.37,0,.51l5.82,3.36A1,1,0,0,0,244,372.47Zm48.5-71.38a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-1.55-.89a1,1,0,0,0-.88,0L291,299.69c-.26.15-.28.38,0,.51Zm-44.17,28a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.26.15-.28.38-.05.51Zm17.77-10.26a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51Zm-28.62,16.52a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.51c-.26.15-.28.38-.05.51Zm19.73-11.39a1,1,0,0,0,.89,0l6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38,0,.51Zm-37.51,21.65a1,1,0,0,0,.89,0L226.7,342c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0L214,341.71c-.26.15-.28.38-.05.51Zm8.89-5.13a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38.06-.51L229.82,333a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51Zm46.13-29.1a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.37,0-.51l-1.55-.89a1,1,0,0,0-.88,0L273.26,310c-.26.15-.29.38-.06.51ZM301.41,296a1,1,0,0,0,.89,0l6.08-3.51c.25-.15.28-.38.05-.51l-1.55-.89a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.29.38-.06.51ZM313.63,303a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.29-.38.06-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.06.51Zm16.93,19.49,6.08-3.51c.26-.15.28-.38.05-.51l-5.82-3.36a1,1,0,0,0-.88,0l-6.08,3.51c-.26.15-.28.38-.05.51l5.81,3.36A1,1,0,0,0,330.56,322.51Zm-46.92-16.29a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.38,0-.51l-1.54-.89a1,1,0,0,0-.89,0l-6.08,3.51c-.25.15-.28.38-.05.51Zm-72.79,44.49a1,1,0,0,0,.88,0l6.08-3.51c.26-.15.28-.37.05-.51l-5.81-3.36a1,1,0,0,0-.89,0l-6.08,3.52c-.26.14-.28.37-.05.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-191"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "236.3 401.28 237.62 402.05 272.74 422.31 335.18 386.26 336.48 385.52 300.05 364.49 236.3 401.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.38 386.72 300.05 366.92 238.42 402.51 272.74 422.31 334.38 386.72",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,388.21c-2.54-1.17-3.23-3.19-3.47-6.74L48.18,215.34a11.52,11.52,0,0,1,5.35-9.77l211.32-122c3.2-1.85,5.54-2.85,8.49-.83s3,3.13,3.26,6.68L288,255.55a11.49,11.49,0,0,1-5.35,9.77l-211.32,122C68.09,389.17,66.28,389.71,63,388.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6,89.42c-.24-3.55-3-4.93-6.23-3.09l-211.32,122a10.93,10.93,0,0,0-4,4.25l-5.51-2.77h0a11,11,0,0,1,4-4.26l211.31-122c3.19-1.84,5.55-2.86,8.49-.83C276.44,84.88,276.36,85.87,276.6,89.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.86,387.57c-2.91,1.72-4.76,1.93-7.85.63-2.37-1-3.22-3.18-3.47-6.73L48.19,215.33a10.26,10.26,0,0,1,1.39-5.51l5.51,2.75v0a10.46,10.46,0,0,0-1.39,5.51L65.06,384.24C65.28,387.53,68.13,389.18,70.86,387.57Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.72,214.69,266.08,97.31c1.92-1.11,3.59-.28,3.74,1.85l10.59,155A6.89,6.89,0,0,1,277.2,260L73.84,377.39c-1.92,1.1-3.59.27-3.73-1.86l-10.6-155A6.91,6.91,0,0,1,62.72,214.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.72,214.69a6.91,6.91,0,0,0-3.21,5.86L69.93,373l201-116a6.91,6.91,0,0,0,3.21-5.86L263.76,98.65Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.13,28.1,350,24.53,162.28,132.9V272c0,2.08.73,3.54,1.91,4.22h0l6.13,3.56h0c1.18.68,2.82.59,4.62-.46L349.6,178.48a14.46,14.46,0,0,0,6.53-11.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,279.44a5.24,5.24,0,0,0,2.55-.79L349.22,177.82a13.61,13.61,0,0,0,6.16-10.66V29.4L169.16,136.9V275.53C169.16,278,170.23,279.44,172,279.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.62,30.71V167.16a13,13,0,0,1-5.78,10L174.19,278a4.51,4.51,0,0,1-2.17.69c-1.9,0-2.1-2.21-2.1-3.16V137.34L354.62,30.71m1.51-2.61L168.41,136.47V275.53c0,3,1.47,4.67,3.61,4.67a5.9,5.9,0,0,0,2.92-.9L349.6,178.48a14.46,14.46,0,0,0,6.53-11.32V28.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,14.48c-1.18-.72-2.84-.64-4.68.42L168.81,115.72A14.46,14.46,0,0,0,162.28,127v5.86l6.13,3.57L356.13,28.1V22.24c0-2.07-.72-3.53-1.89-4.22S349.21,15.14,348.15,14.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,130.61a14.43,14.43,0,0,1,6.53-11.32L349.6,18.47c3.61-2.09,6.53-.4,6.53,3.77V28.1L168.41,136.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,18.06c-1.19-.74-2.85-.67-4.7.41L175,119.29a13.24,13.24,0,0,0-4.62,4.87l-6.14-3.55a13.49,13.49,0,0,1,4.63-4.89L343.47,14.89c1.84-1.05,3.5-1.13,4.68-.41s5,2.9,6.09,3.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.31,32.39a5,5,0,0,0-2.28,4c0,1.46,1,2,2.28,1.32a5,5,0,0,0,2.28-3.95C335.59,32.25,334.57,31.66,333.31,32.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,27.79A5,5,0,0,0,339,31.74c0,1.46,1,2.05,2.28,1.32a5,5,0,0,0,2.28-4C343.58,27.65,342.56,27.06,341.3,27.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.28,23.19A5,5,0,0,0,347,27.14c0,1.46,1,2.05,2.28,1.32a5.06,5.06,0,0,0,2.29-3.95C351.57,23.05,350.54,22.46,349.28,23.19Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Content--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.62,171.94a1,1,0,0,1-.5-1.87l77.18-44.55a1,1,0,0,1,1.36.36,1,1,0,0,1-.36,1.37l-77.18,44.56A1,1,0,0,1,225.62,171.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,179a1,1,0,0,1-.5-1.87l77.18-44.56a1,1,0,0,1,1,1.73l-77.18,44.56A1,1,0,0,1,225.62,179Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,186a1,1,0,0,1-.87-.5,1,1,0,0,1,.37-1.36l77.18-44.56a1,1,0,0,1,1.36.36,1,1,0,0,1-.36,1.37l-77.18,44.56A1,1,0,0,1,225.62,186Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wideos--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.94,258.22a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l28.43-16.42a.52.52,0,0,1,.69.19.51.51,0,0,1-.19.68l-28.43,16.42A.59.59,0,0,1,180.94,258.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.94,262.92a.5.5,0,0,1-.25-.93l28.43-16.42a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-28.43,16.41A.47.47,0,0,1,180.94,262.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,255.87a.43.43,0,0,1-.25-.07.48.48,0,0,1-.25-.43V222.54a.52.52,0,0,1,.25-.44L213.18,201a.5.5,0,0,1,.5,0,.48.48,0,0,1,.25.43v32.83a.5.5,0,0,1-.25.44l-36.55,21.1A.47.47,0,0,1,176.88,255.87Zm.49-33.05V254.5L212.93,234V202.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,239.39a4.67,4.67,0,0,1-2.36-.61c-1.7-1-2.63-3-2.63-5.69,0-5.33,3.76-11.84,8.37-14.5,2.33-1.35,4.55-1.55,6.25-.57s2.63,3,2.63,5.69c0,5.33-3.76,11.84-8.38,14.5A7.8,7.8,0,0,1,191.52,239.39Zm7.26-21a7,7,0,0,0-3.38,1,17.44,17.44,0,0,0-7.87,13.64c0,2.32.76,4,2.13,4.83s3.23.59,5.24-.57a17.43,17.43,0,0,0,7.88-13.64c0-2.32-.76-4-2.13-4.83A3.76,3.76,0,0,0,198.78,218.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,224.9h6c.74,0,.94.46.46,1l-6.92,8c-.48.56-.87.41-.87-.32v-7.34A1.34,1.34,0,0,1,193.27,224.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,224.9h6c.74,0,.94.46.46,1l-6.92,8c-.48.56-.87.41-.87-.32v-7.34A1.34,1.34,0,0,1,193.27,224.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,232.42a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l28.44-16.41a.5.5,0,1,1,.5.86l-28.44,16.42A.45.45,0,0,1,225.62,232.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,237.12a.5.5,0,0,1-.25-.93l28.44-16.42a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-28.44,16.42A.54.54,0,0,1,225.62,237.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.56,230.07a.51.51,0,0,1-.25-.06.5.5,0,0,1-.25-.44V196.74a.48.48,0,0,1,.25-.43l36.56-21.11a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v32.84a.5.5,0,0,1-.25.43L221.81,230A.57.57,0,0,1,221.56,230.07Zm.5-33v31.68l35.55-20.53V176.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,213.6a4.78,4.78,0,0,1-2.37-.61c-1.69-1-2.63-3-2.63-5.7,0-5.33,3.76-11.84,8.38-14.5h0c2.33-1.35,4.55-1.55,6.24-.57s2.63,3,2.63,5.69c0,5.33-3.76,11.84-8.37,14.51A7.93,7.93,0,0,1,236.21,213.6Zm7.25-21a6.83,6.83,0,0,0-3.37,1h0c-4.35,2.5-7.88,8.62-7.88,13.63,0,2.32.76,4,2.13,4.83s3.24.59,5.25-.57a17.43,17.43,0,0,0,7.87-13.64c0-2.32-.76-4-2.13-4.82A3.67,3.67,0,0,0,243.46,192.61Zm-3.62.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,199.11h6c.74,0,.94.45.46,1l-6.92,8c-.48.56-.87.42-.87-.32v-7.34A1.33,1.33,0,0,1,238,199.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,199.11h6c.74,0,.94.45.46,1l-6.92,8c-.48.56-.87.42-.87-.32v-7.34A1.33,1.33,0,0,1,238,199.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.3,206.62a.5.5,0,0,1-.25-.93l28.44-16.42a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-28.44,16.41A.45.45,0,0,1,270.3,206.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.3,211.33a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L298.49,194a.5.5,0,1,1,.5.86l-28.44,16.42A.45.45,0,0,1,270.3,211.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,204.28a.55.55,0,0,1-.25-.07.52.52,0,0,1-.25-.43V170.94a.48.48,0,0,1,.25-.43l36.56-21.11a.5.5,0,0,1,.5,0,.52.52,0,0,1,.25.44v32.83a.5.5,0,0,1-.25.43l-36.56,21.11A.55.55,0,0,1,266.24,204.28Zm.5-33.05v31.68l35.56-20.53V150.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.89,187.8a4.68,4.68,0,0,1-2.37-.61c-1.69-1-2.63-3-2.63-5.69,0-5.34,3.76-11.84,8.38-14.51h0c2.33-1.34,4.55-1.55,6.24-.57s2.63,3,2.63,5.7c0,5.33-3.76,11.83-8.37,14.5A7.93,7.93,0,0,1,280.89,187.8Zm7.25-21a6.83,6.83,0,0,0-3.37,1.05h0c-4.35,2.5-7.88,8.62-7.88,13.64,0,2.32.76,4,2.13,4.82s3.24.59,5.25-.57c4.34-2.5,7.87-8.62,7.87-13.63,0-2.32-.75-4-2.13-4.83A3.67,3.67,0,0,0,288.14,166.81Zm-3.62.62h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,173.31h6c.74,0,.95.45.46,1l-6.91,8c-.49.55-.88.41-.88-.33v-7.34A1.34,1.34,0,0,1,282.64,173.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,173.31h6c.74,0,.95.45.46,1l-6.91,8c-.49.55-.88.41-.88-.33v-7.34A1.34,1.34,0,0,1,282.64,173.31Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,180.82a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l28.44-16.42a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-28.44,16.42A.51.51,0,0,1,315,180.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,185.53a.5.5,0,0,1-.25-.93l28.44-16.42a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-28.44,16.41A.43.43,0,0,1,315,185.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.92,178.48a.47.47,0,0,1-.25-.07.5.5,0,0,1-.25-.43V145.14a.52.52,0,0,1,.25-.43l36.56-21.1a.5.5,0,0,1,.75.43v32.83a.49.49,0,0,1-.25.43l-36.56,21.11A.45.45,0,0,1,310.92,178.48Zm.5-33v31.68L347,156.58V124.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.57,162a4.61,4.61,0,0,1-2.36-.61c-1.7-1-2.63-3-2.63-5.69,0-5.33,3.75-11.84,8.37-14.51,2.33-1.34,4.55-1.54,6.24-.56s2.63,3,2.63,5.69c0,5.33-3.75,11.84-8.37,14.5A7.83,7.83,0,0,1,325.57,162Zm7.26-21a6.91,6.91,0,0,0-3.38,1,17.44,17.44,0,0,0-7.87,13.64c0,2.32.75,4,2.13,4.83s3.23.59,5.24-.57a17.44,17.44,0,0,0,7.87-13.64c0-2.32-.75-4-2.13-4.83A3.65,3.65,0,0,0,332.83,141Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,147.51h6c.73,0,.94.45.46,1l-6.92,8c-.48.56-.87.41-.87-.33v-7.33A1.33,1.33,0,0,1,327.32,147.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,147.51h6c.73,0,.94.45.46,1l-6.92,8c-.48.56-.87.41-.87-.33v-7.33A1.33,1.33,0,0,1,327.32,147.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.62,329.84l-6.6,3.81h0l-1.72,1-25.06,14.47-1,.59-2.74-19.13s-2.91,11.75-6.3,24.35l-11,6.36-2.4,1.38L69.93,373l-2.77-40.47c.37-5.66.86-13.18,1.54-23.33,2.31-34.46,3.93-38.26,8-53.73h65C143.54,276.89,144.32,306.93,144.62,329.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.94,285.28c-.55,5.73-10.73,13.08-15.49,14.22l-6.36,30.65,1.14,19-1,.59-2.74-19.13,5.7-34.59S124.59,293,131.94,285.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,260.77a47.69,47.69,0,0,0-4.29,9.08A87.7,87.7,0,0,0,87,279.47c-.75,3.26-1.38,6.54-1.81,9.85a65.59,65.59,0,0,0-.66,10c.8-3.26,1.54-6.48,2.28-9.71s1.46-6.46,2.24-9.67,1.55-6.41,2.37-9.61S93.16,264,94.16,260.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,262a35.7,35.7,0,0,0-4.52,5.08,48.73,48.73,0,0,0-3.68,5.71A43.79,43.79,0,0,0,78.8,279a27.38,27.38,0,0,0-1.53,6.64l3-6c1-2,2.06-3.92,3.13-5.85s2.14-3.88,3.21-5.83S88.8,264,89.79,262Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,302c-.63,10.45-1.38,20.88-2.41,31.3-.87,9-2.8,18.83-4.51,28l-2.4,1.38c1.84-9.59,4-20.05,5.28-29.58C94.32,322.73,95.61,312.35,97.05,302Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,333.65l-1.72,1c-.1-1.8-.21-3.6-.31-5.4L134.28,302c1.4,9,2.49,18.07,3.34,27.15C137.75,330.64,137.89,332.14,138,333.65Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.37,177.76c10.83.35,12.53,1.71,25.67,11.93a192.63,192.63,0,0,0,18.9,13.21s11.13,13.52,11.58,16.15,1.37,8.57-3.87,11.89c-3.34,2.11-6.91,1.4-9,1.6-4.31.41-7-3.09-8.75-4.16-12.15-7.23-24.34-13.83-24.34-13.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.05,167.16c-1.82-1.08-2.15.6-2.77.83,0,0,1.87-2.15-1.27-4-1.93-1.15-2.87,1.55-2.91,1.19,0-.16,2.33-5.67,4.24-10.35,1.81-4.44.25-5.7-.48-6s-1.46-.06-3.14,3.17-6.62,12.9-7.74,14.91-1.93,3-2.64.34c-.67-2.45-1.28-4.77-2.71-6.27-2.38-2.5-4.24-1.4-3.86.52.53,2.7.49,5.87.87,10.28.2,2.3.25,4.46.52,6,.81,5.54-2.42,8.08-6.27,12.43-3.15,3.55-6.39,6.47-13.62,13.61-6.86,6.77-6.59,22.71.18,25.51,7.77,3.22,10.87-.88,16.51-9.48,4.78-7.3,11.36-20.59,13.15-23.66s2.44-5,4.92-6.48c3.37-2.05,4.87-4.25,6.74-7.5.89-1.55,2.58-4.41,3.69-6.73s1.22-4-.11-5c-1.8-1.35-2.33.65-2.51.44S212.64,168.7,210.05,167.16Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,171c2.52,2.47,4.3,9.15,3.21,13.56C202.47,179.93,200.68,173.13,196.11,171Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.52,166.62c-1.47,2.73-2.89,5.71-2.52,6.92s1.26,1.83,2.25,1.57a3.63,3.63,0,0,0,1.58-.86,3.28,3.28,0,0,0-.37,2.12,2.25,2.25,0,0,0,2.57,1.15,3,3,0,0,0,1.48-1.25s-.61,1.62,0,2.51a2.07,2.07,0,0,0,3.13-.26c-.73,1.27-1.78,2-3.09,1.31s-1-1.68-1-1.68a2.31,2.31,0,0,1-2.57-.05,2.36,2.36,0,0,1-1.36-2.47,2.18,2.18,0,0,1-3.41-1.15c-.57-1.68,0-2.88,1.09-4.82A13.35,13.35,0,0,1,202.52,166.62Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,200.72c-1.32-9.53-2.58-22.33-17.34-22.92l-19.2-.92c-4.69,1.22-34.22,9.73-34.22,9.73l9.28,49.82s-2.1,20.84-2.54,33.7c13.64,8.65,51.9,8.15,66.31-.53C139.86,256.43,138.31,210.15,137,200.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,276.57v5.37a37.22,37.22,0,0,0,12.86-6.37l.13-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,212.34c-.51-12.07-2.47-22.49-7-28.16s-9.48-7.28-20.14-7.11v1.24c1.24.11,3.38,1.74,4.38,3.34,1.85,3,3.68,8,6,16.57,3.09,11.74,6.53,35.65,6.69,49.77s0,28.58,0,28.58,10.78-3.45,13-7c2-5.29-.14-6.45-.11-9.85C145.52,243.75,143,221.18,142.59,212.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,212.34c-.51-12.07-2.47-22.49-7-28.16s-9.48-7.28-20.14-7.11v1.24c1.24.11,3.38,1.74,4.38,3.34,1.85,3,3.68,8,6,16.57,3.09,11.74,6.53,35.65,6.69,49.77s0,28.58,0,28.58,10.78-3.45,13-7c2-5.29-.14-6.45-.11-9.85C145.52,243.75,143,221.18,142.59,212.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,271.48s-1.16,4.52-.92,5.83,2.09,3.1,8.57,5.3c5.81,2,16.87,5.57,26.63,5.24l.34-6.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,196.48c-1.51-6.43-6.7-13.34-8.25-19.6,0,0-2.71,2.37-10.47,2.85-4.56.28-7.93,4.22-10.89,5.51-6,2.58-7,8.75-4.59,17.4,0,0,3.9,18.64,6,30.11a64.76,64.76,0,0,1-.4,26.81c-.85,3.66-3.27,9.4-.11,11.94,8.64,7.48,34.55,10.24,34.55,10.24s.73-16.2,0-48.74C104.3,214.76,100.83,204.68,98.89,196.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,196.48c-1.51-6.43-6.7-13.34-8.25-19.6,0,0-2.71,2.37-10.47,2.85-4.56.28-7.93,4.22-10.89,5.51-6,2.58-7,8.75-4.59,17.4,0,0,3.9,18.64,6,30.11a64.76,64.76,0,0,1-.4,26.81c-.85,3.66-3.27,9.4-.11,11.94,8.64,7.48,34.55,10.24,34.55,10.24s.73-16.2,0-48.74C104.3,214.76,100.83,204.68,98.89,196.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.8,130.23a10.53,10.53,0,0,0-5.29-1c-2,.15-2.7.22-4.41,1.62A5.41,5.41,0,0,0,76.24,134a7.4,7.4,0,0,0,.74,5c.68,1.44,0,2.68-.4,4.13a5,5,0,0,0,1.45,5c1.27,1.09,3,2,3.79,3.52.94,1.83.87,4,1.82,5.86a14.5,14.5,0,0,0,3.09,4,18.94,18.94,0,0,1,2.14,2.87c.67.89,2,1.28,2.86,1.89.32.21,1.07,1.13,1.5,1,.6-.21.09-2.08,0-2.49-.16-1.65-.28-3.3-.48-4.94L92,153.53s3.69-5.89,3.8-10.5c.16-5.94-1.26-8.26-1.26-8.26C92.4,133.35,90.2,131.35,87.8,130.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,139.16a17.15,17.15,0,0,0,2.54,8.75c1.39,2.26,3.85,5.29,6.57,6a30,30,0,0,0,3,.46,24.28,24.28,0,0,0,10-1c2.4-.74,4.83-1.76,6.37-3.82a22.91,22.91,0,0,0,2.78-4.12c.23-.53.2-1.1.44-1.63.56-1.28,1.69-2.46,2-3.82a13.2,13.2,0,0,0-.11-3.66c-.06-1.35.74-2.39.75-3.71a4.82,4.82,0,0,0-1.07-3.31,13.54,13.54,0,0,0-1.39-1.64,8.85,8.85,0,0,0-2.63-1.43c-.83-.39-1.59-1-2.43-1.36a31,31,0,0,0-6.38-2.1,20.4,20.4,0,0,0-9.45.24c-3.18.85-6.18,3.67-8,6.31A17.23,17.23,0,0,0,94.74,139.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.11,163c3.86,1.2,5.72-1.38,5.72-1.38l2,19.5a20.88,20.88,0,0,0,19.83,6.52c4.11-.85,6.31-4.07,1.85-9.27l-.46-5.77a34.71,34.71,0,0,0,6.51-.53c4.15-1,6.55-4.48,7.48-9.12,1.48-7.45.43-20.17-3-33.89-5-3.31-22.71-.73-32.13,6.24,1.54,5.89,1.74,7.62,1.37,11.31s-1.58,5.46-2.65,5.7c-2,.45-2.46-1.7-3.84-3s-6.36-1.69-8.13,2.9S82.14,162.06,85.11,163Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.06,172.57c-6.74-.18-15.4-2.7-17.77-5.61A22.69,22.69,0,0,1,93,161.61s.42,4.16,2.25,6.73,8.5,6.78,19,6.73Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,118.48a3.39,3.39,0,0,1-1.66-1.29,15.36,15.36,0,0,0-1.91-3.12,6.27,6.27,0,0,0-5-2c-1.72.08-3.28,1.29-5,1.69s-2.67-.37-4.16-1.15c-1.87-1-4.82-.72-6.76,0a6.62,6.62,0,0,0-2.38,1.49c-.62.66-.91,1.59-1.69,2.11-1.41.91-3.75.11-5.34.09-2.79,0-5,1-5.36,3.39-.18,1-.14,1.79-.31,2.71a3,3,0,0,1-1.34,1.87,5.3,5.3,0,0,0-2.52,3.29,5.21,5.21,0,0,0,1.76,5.23,6.7,6.7,0,0,0,5.64,1c.34,1.54,2.32,2.51,3.83,2.57a6.41,6.41,0,0,0,2.54-.18c.29-.09,2.47-1.25,2.19-1.67a5.22,5.22,0,0,0,4.43,2.16,5.9,5.9,0,0,0,5.18-3c-.39.73.86,1.69,1.36,2a5.58,5.58,0,0,0,2.76.6,4.65,4.65,0,0,0,4-2.41,3.2,3.2,0,0,1,3.2-1.56,13.61,13.61,0,0,0,3.63.3,4.21,4.21,0,0,0,3.68-5.86c1.17,1.6,4.48,2,4.6-.54a.86.86,0,0,1-1.48-.37c-.23-.85.61-1.81.72-2.63a3.83,3.83,0,0,0-2.36-3.93C125.53,119,124.71,118.79,124,118.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,147.11a2,2,0,1,1-2.13-1.91A2,2,0,0,1,109,147.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.28,140.44l-4.41,2a2.54,2.54,0,0,1,1.26-3.28A2.35,2.35,0,0,1,106.28,140.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81,139.5l-4.76-1a2.34,2.34,0,0,1,2.81-1.91A2.55,2.55,0,0,1,124.81,139.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,145.05a2,2,0,0,1-1.82,2.2,2.06,2.06,0,1,1,1.82-2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12,152.48l-7,3-2.82-12.5C116.25,142.94,119.68,147.46,123.12,152.48Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,158.4l6.68,2a3.43,3.43,0,0,1-4.3,2.44A3.66,3.66,0,0,1,110,158.4Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,159.42a3.64,3.64,0,0,0,2.5,3.46,3.38,3.38,0,0,0,2.33-.15A5.35,5.35,0,0,0,109.91,159.42Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,178.34c5.44,7,13.59,26.56,15.39,41.49.66-6.44,1.41-22.85,0-27a39,39,0,0,0-4.59-8.53s1-3.23.7-3.65c-1.44-1.92-11.83-6.42-11.83-6.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,173.15l.47,4.54c2.68,5.12,5.54,9.78,7.72,19.11a182.55,182.55,0,0,1,3.87,25.61s-10.54-17.67-13-22.38c-1.54-3-.62-11.93-.62-11.93s-5.5-1.49-6.22-2.26c-1-1.06.87-6.91.87-6.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.17,179.73c-13.92-1.57-14.77,1-28.46,12.8-8.85,7.62-20.8,16.25-21.48,25.35-.7,9.34,3.39,13.05,5.27,15.44s7.16,2.77,9.47-.26c3-1.29,4.31-2.57,7.35-4.75,8.22-5.9,17-12.13,19.85-14.49C79.45,207.85,83,193.15,80.17,179.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.65,159.11c-.09,1.49.53,2.27,2.28,2.68s3.82.29,6.57,1.41a6.64,6.64,0,0,1,4.22,5.23c.07,1.48-.52,2.25-1.48,2s-2.72-1.73-5.62-2.2c-2.6-.42-4-.1-6.81.53s-3.89,1-7.49,1.54c-1.87.29-4,1.64-4.28,6.69-.21,3.39.55,13.14,2,24.82,1,8.26,1.1,9.58,0,17.39-.84,5.92-7.17,12.62-10.26,12.82-6.8.44-12.6-12-12.57-19.71,0-7.87,2.46-18.5,4.36-27.58,2.14-10.24,3.26-15.09,3.86-17.42.72-2.76,1.9-4.38,2.66-7.52.86-3.55,3.1-9.71,4.45-11.64s4.85-2.07,7.47-2.34,3.1.2,3.32.93c2.62-.31,4.6-.66,5.08.52,3.12-.16,4.38-.26,4.89,1.44,2.08.1,2.58.55,2.85,1.54.18.63.33,1.7-1,3.73A28.08,28.08,0,0,1,60.65,159.11Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,149a6.28,6.28,0,0,0,.16,2,12.72,12.72,0,0,0,.59,1.87l0,.09,0,.09a9,9,0,0,0-.74,2.21,3.54,3.54,0,0,0,.12,2.13,1.67,1.67,0,0,0,.68.69l.1.05s0,0,0,0,0,0,.09,0a2.38,2.38,0,0,0,.37-.35,23.24,23.24,0,0,0,1.39-1.9,8.92,8.92,0,0,0,1.14-2,5.16,5.16,0,0,0,.1-1.1c0-.4,0-.79,0-1.19a44.86,44.86,0,0,0-.27-4.77,24.39,24.39,0,0,1,.77,4.75c0,.4.06.8.07,1.21a4.35,4.35,0,0,1-.06,1.28,8.69,8.69,0,0,1-1.17,2.2,21.45,21.45,0,0,1-1.43,2,2.85,2.85,0,0,1-.5.47.94.94,0,0,1-.45.17.6.6,0,0,1-.31,0l-.17-.09a2.31,2.31,0,0,1-1-1,4.06,4.06,0,0,1-.08-2.57,9.7,9.7,0,0,1,.94-2.28V153a8.32,8.32,0,0,1-.43-2A5.28,5.28,0,0,1,49.6,149Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.49,148.74a4.21,4.21,0,0,0,1.34,1.68,3.31,3.31,0,0,0,1.92.63l-.07.74a3.92,3.92,0,0,1-2.09-1.09A4.31,4.31,0,0,1,46.49,148.74Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.05,152.52a4.47,4.47,0,0,1-1.55.26,6.89,6.89,0,0,1-1.51-.11,6.3,6.3,0,0,1-2.67-1.27l0,0a7.2,7.2,0,0,0,2.71.88,4.55,4.55,0,0,0,2.68-.39Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.42,147.27a4.39,4.39,0,0,1,.17,2.41c-.15.81-.38,1.59-.59,2.37a41.25,41.25,0,0,1-1.51,4.65,25,25,0,0,1-3.32,3.62,2.8,2.8,0,0,1-1.13.73,1.64,1.64,0,0,1-1.4-.32,2.31,2.31,0,0,1-.78-1.16,3.51,3.51,0,0,1-.17-1.33l.73.07a2.28,2.28,0,0,0,.61,1.91,1,1,0,0,0,.86.25,2.22,2.22,0,0,0,.91-.54,26.07,26.07,0,0,0,3.31-3.44A42.36,42.36,0,0,0,57.74,152c.24-.77.51-1.54.69-2.32a4.34,4.34,0,0,0-.06-2.37Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.28,148.72a4.21,4.21,0,0,1-.22,2.19,13.13,13.13,0,0,1-.89,2c-.73,1.3-1.52,2.53-2.3,3.8a11.91,11.91,0,0,1-1.32,1.83,19.32,19.32,0,0,1-1.69,1.47l-.89.69a3.26,3.26,0,0,1-1.06.58,1.79,1.79,0,0,1-1.32-.1,2.37,2.37,0,0,1-.93-.9l.63-.37a1.26,1.26,0,0,0,1.45.74,6.84,6.84,0,0,0,1.78-1.08,18.89,18.89,0,0,0,1.71-1.36,12.71,12.71,0,0,0,1.34-1.7c.82-1.23,1.67-2.45,2.44-3.69a12.46,12.46,0,0,0,1-2A4.13,4.13,0,0,0,63.28,148.72Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.65,159.11a8.7,8.7,0,0,1-2,1.79,3.43,3.43,0,0,1-.63.33,1.13,1.13,0,0,1-.83,0,1.5,1.5,0,0,1-1-1.29l.74,0a.86.86,0,0,0,.43.83.66.66,0,0,0,.48.06,2.78,2.78,0,0,0,.59-.21A8.52,8.52,0,0,0,60.65,159.11Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82,170.11A7.08,7.08,0,0,1,45,168.36c-.65-.46,1.75,2.29,2.35,5.47a49.76,49.76,0,0,1,.54,5.4h0c0-.8.15-1.6.18-2.22.32-5,2.41-6.4,4.28-6.69A10.05,10.05,0,0,1,47.82,170.11Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,160.53a6.59,6.59,0,0,1,.36,3.33,9.08,9.08,0,0,1-1,3.11,8.74,8.74,0,0,0,.59-3.14,6.13,6.13,0,0,0-.65-3Z",
    style: {
      fill: "#af6152"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.49,76.28c-1.44-.83-3.42-.71-5.61.55l-75.95,43.85A17.56,17.56,0,0,0,220,134.43v11.76c0,2.53.89,4.3,2.33,5.13s3.49,2,4.81,2.76,3.42.72,5.62-.55l75.95-43.84a17.56,17.56,0,0,0,7.94-13.75V84.18c0-2.53-.89-4.31-2.33-5.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,123.45,308.7,79.6c4.38-2.53,7.94-.48,7.94,4.58V95.94a17.56,17.56,0,0,1-7.94,13.75l-75.95,43.84c-4.38,2.54-7.93.48-7.93-4.58V137.19A17.53,17.53,0,0,1,232.75,123.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,123.45,308.7,79.6c4.38-2.53,7.94-.48,7.94,4.58V95.94a17.56,17.56,0,0,1-7.94,13.75l-75.95,43.84c-4.38,2.54-7.93.48-7.93-4.58V137.19A17.53,17.53,0,0,1,232.75,123.45Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,154.08l-4.81-2.76c-1.44-.83-2.33-2.6-2.33-5.13V134.43a15.69,15.69,0,0,1,1.75-6.75l4.82,2.78a15.59,15.59,0,0,0-1.74,6.73V149C224.82,151.47,225.7,153.25,227.13,154.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,154.08l-4.81-2.76c-1.44-.83-2.33-2.6-2.33-5.13V134.43a15.69,15.69,0,0,1,1.75-6.75l4.82,2.78a15.59,15.59,0,0,0-1.74,6.73V149C224.82,151.47,225.7,153.25,227.13,154.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.72,128.44a4.67,4.67,0,0,1-.8,2.39,3,3,0,0,0-1.6.37,2.33,2.33,0,0,0-1.34,2c0,1.22.71,1.26,1.55,1.29,1.18.07,2.62.15,2.62,3.16,0,3.62-1.69,5.84-3.26,6.74-2.19,1.27-3.39.76-3.39,0a5.12,5.12,0,0,1,.9-2.49c.26-.15,1,.46,2.12-.21a2.58,2.58,0,0,0,1.35-2.33c0-1.33-1.14-1-2.22-1.21s-1.94-.67-1.94-3.33a7.44,7.44,0,0,1,3.41-6.46C237.65,127.5,238.72,127.71,238.72,128.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.85,121.88v9.67a8.71,8.71,0,0,1-4.18,7.79c-2.64,1.52-4.18.46-4.18-3v-9.67a1.4,1.4,0,0,1,.86-1.21l.49-.29c.61-.34.87-.25.87.22v9.45c0,1.55.79,2.22,2,1.55a4.55,4.55,0,0,0,2-3.82v-9.46a1.41,1.41,0,0,1,.87-1.21l.47-.27C248.59,121.32,248.85,121.42,248.85,121.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,120a7.31,7.31,0,0,1-1.56,4.27v.08c1.16-.31,1.95.81,1.95,2.52a7.15,7.15,0,0,1-3.6,6.58l-3.06,1.77c-.4.23-.58.06-.58-.56V120.9a1.24,1.24,0,0,1,.58-1.22l2.85-1.65C256.8,116.62,257.77,117.66,257.77,120Zm-4.62,1.62v3.31l1-.58a2.84,2.84,0,0,0,1.34-2.43c0-1.09-.43-1.4-1.31-.89Zm0,6.22v3.52l1.42-.81a2.85,2.85,0,0,0,1.32-2.57c0-1.15-.56-1.4-1.55-.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16,113.17a4.67,4.67,0,0,1-.8,2.39,2.93,2.93,0,0,0-1.59.37,2.34,2.34,0,0,0-1.35,2c0,1.22.71,1.25,1.55,1.28,1.18.07,2.62.15,2.62,3.17,0,3.61-1.69,5.83-3.26,6.74-2.19,1.26-3.38.75-3.38,0a5.12,5.12,0,0,1,.89-2.49c.26-.15,1,.46,2.12-.2a2.6,2.6,0,0,0,1.35-2.34c0-1.33-1.14-1-2.22-1.2s-1.94-.68-1.94-3.34a7.42,7.42,0,0,1,3.41-6.45C264.09,112.24,265.16,112.44,265.16,113.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,107.81a5.43,5.43,0,0,1-.93,2.62,3.37,3.37,0,0,0-2.12.52c-1.7,1-2.5,3.1-2.5,6.43s.81,4.59,2.47,3.63a10.08,10.08,0,0,0,2.36-2.25c.46-.26.85,1.06.85,1.44,0,1.33-2.06,3.06-3.21,3.72-3.23,1.86-4.74.23-4.74-5.25,0-5.28,1.61-8.83,4.81-10.68C272.71,107.26,274.45,106.88,274.45,107.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,105.66a7.05,7.05,0,0,1-1.68,4.5v.09c.36,0,.79.63,1,1.44l1.27,4.15a1.63,1.63,0,0,1,.07.38c0,.27-.27.6-.86,1l-.59.34c-.42.24-.75.32-.84,0l-1.14-3.67c-.29-.72-.52-1-1.45-.49l-.56.33v5.41a1.4,1.4,0,0,1-.87,1.21l-.49.28c-.6.35-.86.26-.86-.21v-14a1.24,1.24,0,0,1,.57-1.22l2.81-1.62C281.92,102.12,283,103,283,105.66Zm-4.75,1.48v3.6l1.36-.79a3.2,3.2,0,0,0,1.11-2.55c0-1-.46-1.42-1.21-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.12,99.79V114a1.43,1.43,0,0,1-.87,1.24l-.5.29c-.61.35-.87.23-.87-.24v-14.2a1.43,1.43,0,0,1,.87-1.23l.5-.29C286.86,99.2,287.12,99.32,287.12,99.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,97.91a7.24,7.24,0,0,1-1.56,4.27l0,.08c1.15-.31,1.94.81,1.94,2.52a7.15,7.15,0,0,1-3.6,6.58l-3.06,1.77c-.4.23-.57.06-.57-.56V98.82a1.23,1.23,0,0,1,.57-1.22L292.61,96C295,94.54,296,95.58,296,97.91Zm-4.61,1.62v3.31l1-.58a2.82,2.82,0,0,0,1.34-2.43c0-1.09-.43-1.4-1.31-.89Zm0,6.22v3.52l1.41-.81a2.82,2.82,0,0,0,1.33-2.56c0-1.16-.57-1.41-1.56-.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,90.39v.69c0,.78-.13,1.19-.43,1.36l-3.63,2.1v3.22l3.24-1.88c.3-.17.43.09.43.86v.69c0,.78-.13,1.19-.43,1.36l-3.24,1.87v3.6l3.64-2.11c.3-.17.43.08.43.86v.69c0,.78-.13,1.18-.43,1.36l-5.29,3c-.4.23-.57.07-.57-.55V93.8a1.23,1.23,0,0,1,.57-1.22l5.28-3C304,89.36,304.15,89.62,304.15,90.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,99.81v2a1.41,1.41,0,0,1-.86,1.21l-.46.26c-.61.35-.87.26-.87-.21v-2a1.4,1.4,0,0,1,.87-1.21l.46-.27C307.88,99.25,308.14,99.34,308.14,99.81Zm.45-12.51c-.25,3.25-.48,6.49-.72,9.74a1.23,1.23,0,0,1-.74,1.13l-.16.09c-.59.34-.73.18-.73-.28V88.75a1.4,1.4,0,0,1,.86-1.21l.62-.36C308.28,86.85,308.59,86.9,308.59,87.3Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bell--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.84,97.93,324,95.71h0l0,0h0c-1.86-1-4.42-.89-7.24.74-5.69,3.28-10.3,11.27-10.3,17.83,0,3.28,1.15,5.59,3,6.66h0l3.87,2.23c1.88,1.19,4.53,1.08,7.46-.61,5.69-3.29,10.3-11.27,10.3-17.84C331.08,101.3,329.84,98.94,327.84,97.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,110.8a16.76,16.76,0,0,0-.39,3.46c0,3.28,1.15,5.59,3,6.66h0l3.88,2.23.91-1.52,2.56-5.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.78,98.76c-5.68,3.29-10.3,11.27-10.3,17.84s4.62,9.23,10.3,6,10.3-11.27,10.3-17.84S326.47,95.48,320.78,98.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2,110.55h0a2.65,2.65,0,0,1-1.34-2.63v-2.53c0-2.87-1.75-4.2-3.91-2.95h0c-2.16,1.25-3.91,4.59-3.91,7.47v2.25a9,9,0,0,1-1.31,4.41h0a2.52,2.52,0,0,0-.32,1.15h0c0,.73.44,1.06,1,.75l9.13-5.28a2.35,2.35,0,0,0,1-1.88A.91.91,0,0,0,326.2,110.55Zm-5.26,8.56a4.48,4.48,0,0,0,1.88-3.58l-3.75,2.16C319.07,119.07,319.91,119.71,320.94,119.11Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.53,102.51,92.18,96.2l2.7-7.78V83.65l-8.26,4.77v4.76l3.55,6.15a.53.53,0,0,0,.24.21h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.53,102.51,92.18,96.2l2.7-7.78V83.65l-8.26,4.77v4.76l3.55,6.15a.53.53,0,0,0,.24.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.17,19.25A5.47,5.47,0,0,0,128.69,15l-2-1.16a5.47,5.47,0,0,0-5,0L52.61,53.76a5.49,5.49,0,0,0-2.47,4.29v51.32a5.49,5.49,0,0,0,2.47,4.28l2,1.17a5.47,5.47,0,0,0,4.95,0L91.8,96.18l3.55,6.14a.52.52,0,0,0,1-.09l3.75-10.81,28.64-16.56a5.47,5.47,0,0,0,2.48-4.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.14,109.37a5.49,5.49,0,0,0,2.47,4.28l2,1.17a5.58,5.58,0,0,0,4.53.2c-1.17.44-2-.22-2-1.63V62.07a5.06,5.06,0,0,1,.73-2.44l-7-4a5.12,5.12,0,0,0-.72,2.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,18.55c-.29-1.05-1.25-1.38-2.39-.73l-69.12,40a4.93,4.93,0,0,0-1.75,1.84l-7-4a5,5,0,0,1,1.75-1.84l69.1-40a5.49,5.49,0,0,1,5,0l2,1.16A5.51,5.51,0,0,1,131.09,18.55Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.76,71.31a1,1,0,0,1-.11-.64,1.94,1.94,0,0,1,.25-.77l4.91-8.65.45-.75a1.85,1.85,0,0,1,.61-.63l2.78-1.61a.36.36,0,0,1,.44,0,.78.78,0,0,1,.18.57V81.58a1.85,1.85,0,0,1-.18.78,1.2,1.2,0,0,1-.44.53l-3,1.73a.34.34,0,0,1-.43,0A.74.74,0,0,1,71,84V68.65l-2.72,4.74a.92.92,0,0,1-.45.45.31.31,0,0,1-.41-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8,71.44l.36.47a1.46,1.46,0,0,0,.47.38,1.35,1.35,0,0,0,.66.12,1.93,1.93,0,0,0,.91-.31,4.69,4.69,0,0,0,.92-.72,5,5,0,0,0,.77-1,5.44,5.44,0,0,0,.54-1.26,5.19,5.19,0,0,0,.19-1.45A1.8,1.8,0,0,0,86,66c-.4-.27-1-.21-1.66.2a2.44,2.44,0,0,0-.6.49c-.19.2-.37.4-.53.6s-.31.38-.44.56a1.26,1.26,0,0,1-.35.33l-3.56,2.06a.35.35,0,0,1-.46,0,.71.71,0,0,1-.16-.57l.69-13a2.23,2.23,0,0,1,.19-.78,1.1,1.1,0,0,1,.43-.52l9.77-5.65a.36.36,0,0,1,.44,0,.78.78,0,0,1,.18.57V54.1a1.85,1.85,0,0,1-.18.78,1.14,1.14,0,0,1-.44.53L82.7,59.25l-.16,3.22a8.94,8.94,0,0,1,.94-1.13,5.68,5.68,0,0,1,1.18-.9,5.92,5.92,0,0,1,2.46-.86,2.89,2.89,0,0,1,2,.49,3.66,3.66,0,0,1,1.3,1.85,9.45,9.45,0,0,1,.47,3.28,15.48,15.48,0,0,1-.51,4,15.67,15.67,0,0,1-1.42,3.55,13.77,13.77,0,0,1-2.11,2.89,12,12,0,0,1-2.61,2.07,6.62,6.62,0,0,1-2.77,1,3.23,3.23,0,0,1-2.07-.46,3.44,3.44,0,0,1-1.3-1.64,6.51,6.51,0,0,1-.48-2.52,1.45,1.45,0,0,1,.15-.63.86.86,0,0,1,.35-.43L81,71.36c.25-.15.43-.18.56-.12A.75.75,0,0,1,81.8,71.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,43.52a5.6,5.6,0,0,1,3-.93,2.92,2.92,0,0,1,2,.9,5.08,5.08,0,0,1,1.21,2.34,14.89,14.89,0,0,1,.47,3.37c0,1,0,2,0,3.14s0,2.14,0,3.12a22.8,22.8,0,0,1-.47,3.91,16.78,16.78,0,0,1-1.21,3.75,14.58,14.58,0,0,1-2,3.25,10.88,10.88,0,0,1-3,2.48,5.58,5.58,0,0,1-3,.93,2.92,2.92,0,0,1-2-.9,5.14,5.14,0,0,1-1.21-2.34,14.89,14.89,0,0,1-.47-3.37c0-1,0-2,0-3.07s0-2.17,0-3.19A23,23,0,0,1,93.38,53a16.87,16.87,0,0,1,1.21-3.74,14.58,14.58,0,0,1,2-3.25A11,11,0,0,1,99.58,43.52ZM102,57.73q.09-3,0-5.91a12,12,0,0,0-.18-1.52,2.43,2.43,0,0,0-.4-1,1,1,0,0,0-.73-.44,2,2,0,0,0-1.14.34,3.75,3.75,0,0,0-1.14,1,4.62,4.62,0,0,0-.73,1.28,7.22,7.22,0,0,0-.41,1.52,10.55,10.55,0,0,0-.16,1.71q-.12,3,0,5.91a8.43,8.43,0,0,0,.15,1.53,2.31,2.31,0,0,0,.41,1.05,1,1,0,0,0,.74.43,2,2,0,0,0,1.14-.34,3.75,3.75,0,0,0,1.14-1,5.13,5.13,0,0,0,.75-1.29,7.22,7.22,0,0,0,.41-1.52A15.14,15.14,0,0,0,102,57.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,54.05a.74.74,0,0,1,.07.35,1.45,1.45,0,0,1-.15.63,1,1,0,0,1-.35.43l-3.64,2.1a.56.56,0,0,1-.52.09,1,1,0,0,1-.41-.36l-4.32-5.88v8.24a1.71,1.71,0,0,1-.19.77,1.13,1.13,0,0,1-.43.53l-3,1.73a.33.33,0,0,1-.44,0,.77.77,0,0,1-.18-.56V39.36a1.8,1.8,0,0,1,.18-.77,1.17,1.17,0,0,1,.44-.54l3-1.72a.32.32,0,0,1,.43,0,.72.72,0,0,1,.19.56v7.42l4-9.92q.1-.27.3-.66a1.44,1.44,0,0,1,.61-.64l3.57-2.06a.26.26,0,0,1,.35,0,.61.61,0,0,1,.15.46,1.09,1.09,0,0,1-.07.42l-5.64,13.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,92.41a1.8,1.8,0,0,1,.93-.29,1.26,1.26,0,0,1,.68.23,1.28,1.28,0,0,1,.43.54,1.77,1.77,0,0,1,.16.66.53.53,0,0,1-.06.24.32.32,0,0,1-.14.16l-.35.21c-.06,0-.11,0-.15,0s-.08-.07-.12-.17a1.37,1.37,0,0,0-.14-.26.78.78,0,0,0-.27-.24.76.76,0,0,0-.41-.1,1.1,1.1,0,0,0-.56.19,2.15,2.15,0,0,0-.46.35,2.76,2.76,0,0,0-.4.49,2.43,2.43,0,0,0-.27.59,2.09,2.09,0,0,0-.11.67,1,1,0,0,0,.1.52.51.51,0,0,0,.32.25,1.25,1.25,0,0,0,.56,0l.82-.11a2.71,2.71,0,0,1,.83,0,1,1,0,0,1,.56.21,1,1,0,0,1,.32.51,3.25,3.25,0,0,1,.1.83,4.52,4.52,0,0,1-.17,1.2,5,5,0,0,1-1.2,2.11,4.3,4.3,0,0,1-1,.75,2,2,0,0,1-.92.31,1.3,1.3,0,0,1-.73-.17,1.34,1.34,0,0,1-.48-.52,1.71,1.71,0,0,1-.19-.76.53.53,0,0,1,.06-.24.36.36,0,0,1,.13-.16l.36-.21a.22.22,0,0,1,.15,0s.08.07.12.17a1,1,0,0,0,.16.32.76.76,0,0,0,.29.24.85.85,0,0,0,.44.07,1.42,1.42,0,0,0,.61-.22,3.29,3.29,0,0,0,.58-.44,3.37,3.37,0,0,0,.48-.58,2.94,2.94,0,0,0,.32-.67,1.87,1.87,0,0,0,.13-.69.81.81,0,0,0-.14-.52.65.65,0,0,0-.4-.21,1.71,1.71,0,0,0-.64,0c-.25,0-.53.08-.85.14a1.78,1.78,0,0,1-.73,0,1,1,0,0,1-.5-.28,1.35,1.35,0,0,1-.27-.55,3.63,3.63,0,0,1-.08-.79,4.21,4.21,0,0,1,.13-1A5.08,5.08,0,0,1,66,94.1a4.66,4.66,0,0,1,.64-.95A3.65,3.65,0,0,1,67.51,92.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.36,88a.14.14,0,0,1,.17,0,.31.31,0,0,1,.06.21v5.33a9.14,9.14,0,0,1-.13,1.59,7.18,7.18,0,0,1-.41,1.43,4.88,4.88,0,0,1-.73,1.2,3.77,3.77,0,0,1-1,.89A2,2,0,0,1,72.2,99a1,1,0,0,1-.72-.36,2.38,2.38,0,0,1-.41-1,6.71,6.71,0,0,1-.13-1.43V90.92a.59.59,0,0,1,.07-.29.53.53,0,0,1,.16-.21l.36-.2a.12.12,0,0,1,.16,0,.28.28,0,0,1,.07.21v5.4a2.53,2.53,0,0,0,.4,1.7q.41.4,1.11,0a2.81,2.81,0,0,0,1.11-1.28,5.1,5.1,0,0,0,.4-2.17V88.7a.62.62,0,0,1,.07-.29.43.43,0,0,1,.16-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,96.23a.12.12,0,0,1-.16,0A.28.28,0,0,1,77,96V87.4a.65.65,0,0,1,.07-.29.48.48,0,0,1,.16-.2l2.32-1.34a1.58,1.58,0,0,1,.92-.27.9.9,0,0,1,.58.31,1.52,1.52,0,0,1,.3.64,2.75,2.75,0,0,1,.09.73,3.57,3.57,0,0,1-.08.82,4.63,4.63,0,0,1-.2.68A3.81,3.81,0,0,1,81,89c-.08.13-.13.23-.17.28a1.46,1.46,0,0,1,.58.58A2.46,2.46,0,0,1,81.61,91a5,5,0,0,1-.12,1,5.18,5.18,0,0,1-.36,1.07,5,5,0,0,1-.59,1,3.1,3.1,0,0,1-.83.71Zm.59-8.46v2.69l1.65-.95a2.23,2.23,0,0,0,1.15-2c0-.44-.09-.72-.29-.84s-.48-.06-.86.16Zm0,3.89v3l1.77-1a2.24,2.24,0,0,0,.51-.41,2.53,2.53,0,0,0,.37-.55,3.63,3.63,0,0,0,.22-.6,2.68,2.68,0,0,0,.07-.62,1.74,1.74,0,0,0-.07-.53.67.67,0,0,0-.21-.37.52.52,0,0,0-.36-.13,1.16,1.16,0,0,0-.53.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,82.51a1.71,1.71,0,0,1,.93-.29,1.29,1.29,0,0,1,.68.23,1.22,1.22,0,0,1,.43.54,1.58,1.58,0,0,1,.15.66.42.42,0,0,1,0,.24.32.32,0,0,1-.14.16l-.35.21a.23.23,0,0,1-.15,0s-.08-.07-.12-.17a2.36,2.36,0,0,0-.14-.26.78.78,0,0,0-.27-.24.76.76,0,0,0-.41-.1,1.1,1.1,0,0,0-.56.19,2.49,2.49,0,0,0-.47.35,2.8,2.8,0,0,0-.39.49,2.91,2.91,0,0,0-.28.59,2.39,2.39,0,0,0-.1.66,1.06,1.06,0,0,0,.1.53.51.51,0,0,0,.32.25,1.25,1.25,0,0,0,.56,0l.82-.11a3.13,3.13,0,0,1,.83,0,1.14,1.14,0,0,1,.56.22,1,1,0,0,1,.32.51A3.25,3.25,0,0,1,87,88a4.52,4.52,0,0,1-.17,1.2,5.29,5.29,0,0,1-.47,1.13,5.8,5.8,0,0,1-.73,1,4.3,4.3,0,0,1-1,.75,2.18,2.18,0,0,1-.92.31,1.3,1.3,0,0,1-.73-.17,1.34,1.34,0,0,1-.48-.52,1.74,1.74,0,0,1-.19-.76.53.53,0,0,1,.06-.24.36.36,0,0,1,.13-.16l.36-.21a.22.22,0,0,1,.15,0s.08.07.12.17a.84.84,0,0,0,.16.31.65.65,0,0,0,.29.25.85.85,0,0,0,.44.07,1.42,1.42,0,0,0,.61-.22,3.29,3.29,0,0,0,.58-.44,3.37,3.37,0,0,0,.48-.58,3.43,3.43,0,0,0,.32-.67,1.93,1.93,0,0,0,.13-.7.8.8,0,0,0-.14-.51.75.75,0,0,0-.4-.22,2,2,0,0,0-.64,0l-.85.13a1.64,1.64,0,0,1-.73,0,1,1,0,0,1-.5-.28,1.35,1.35,0,0,1-.27-.55,3.7,3.7,0,0,1-.08-.79,4.21,4.21,0,0,1,.13-1,4.88,4.88,0,0,1,.38-1,4.66,4.66,0,0,1,.64-1A3.44,3.44,0,0,1,84.66,82.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.74,83.83c0,.4,0,.78,0,1.12s0,.72,0,1.11a2.34,2.34,0,0,0,.44,1.54c.27.3.66.3,1.18,0a2.58,2.58,0,0,0,.7-.56,3.44,3.44,0,0,0,.47-.68,3.39,3.39,0,0,0,.28-.75,5.11,5.11,0,0,0,.15-.74.85.85,0,0,1,.09-.27.46.46,0,0,1,.14-.16l.4-.23a.1.1,0,0,1,.13,0,.24.24,0,0,1,.06.18,5.77,5.77,0,0,1-.15,1,5.83,5.83,0,0,1-.43,1.23,6,6,0,0,1-.74,1.19,3.84,3.84,0,0,1-1.1.94,1.91,1.91,0,0,1-1,.31,1.11,1.11,0,0,1-.75-.32,1.84,1.84,0,0,1-.49-.85,4.7,4.7,0,0,1-.19-1.34q0-1.17,0-2.37a7.29,7.29,0,0,1,.19-1.54,6.51,6.51,0,0,1,.49-1.43,5.72,5.72,0,0,1,.75-1.19,3.69,3.69,0,0,1,1-.85,1.92,1.92,0,0,1,1.1-.33,1.18,1.18,0,0,1,.74.33,1.73,1.73,0,0,1,.43.73,3.45,3.45,0,0,1,.15.88.53.53,0,0,1-.06.24.36.36,0,0,1-.13.16l-.4.23a.14.14,0,0,1-.14,0A.27.27,0,0,1,92,81.3a2.65,2.65,0,0,0-.15-.57.92.92,0,0,0-.28-.42.73.73,0,0,0-.47-.14,1.49,1.49,0,0,0-.7.25,2.78,2.78,0,0,0-1.18,1.36A5.26,5.26,0,0,0,88.74,83.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,76a2.4,2.4,0,0,1,.8-.3,1,1,0,0,1,.66.11,1.17,1.17,0,0,1,.45.59,3.27,3.27,0,0,1,.17,1.16A5,5,0,0,1,98,79.43a4.7,4.7,0,0,1-.89,1.42l1.3,2.75a.31.31,0,0,1,0,.13.53.53,0,0,1-.06.24.36.36,0,0,1-.13.16l-.37.22c-.12.06-.21.07-.26,0l-.12-.16-1.25-2.67-1.49.86v3.39a.66.66,0,0,1-.07.3.42.42,0,0,1-.16.2l-.36.2a.11.11,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-8.6a.66.66,0,0,1,.07-.3.56.56,0,0,1,.16-.2Zm-1.51,5.24,1.46-.84a2.58,2.58,0,0,0,1-.94A2.73,2.73,0,0,0,97.5,78c0-.57-.11-.9-.34-1a1.14,1.14,0,0,0-1,.21L94.73,78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.77,83.23a.11.11,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-8.6a.66.66,0,0,1,.07-.3.56.56,0,0,1,.16-.2l.36-.2a.12.12,0,0,1,.16,0,.25.25,0,0,1,.07.21v8.6a.66.66,0,0,1-.07.3.42.42,0,0,1-.16.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08,81.9a.12.12,0,0,1-.16,0,.28.28,0,0,1-.07-.21V73.07a.65.65,0,0,1,.07-.29.42.42,0,0,1,.16-.2l2.32-1.34a1.58,1.58,0,0,1,.92-.27,1,1,0,0,1,.58.31,1.52,1.52,0,0,1,.3.64,3.23,3.23,0,0,1,.09.73,3.57,3.57,0,0,1-.08.82,4.63,4.63,0,0,1-.2.68c-.08.19-.16.36-.23.49s-.13.23-.17.28a1.46,1.46,0,0,1,.58.58,2.46,2.46,0,0,1,.24,1.19,4.9,4.9,0,0,1-.12,1,5,5,0,0,1-.36,1.07,4.61,4.61,0,0,1-.6,1,3.06,3.06,0,0,1-.82.71Zm.59-8.46v2.69l1.64-.95a2.21,2.21,0,0,0,1.16-2c0-.44-.09-.72-.29-.84s-.48-.06-.87.16Zm0,3.89v3l1.77-1a2.24,2.24,0,0,0,.51-.41,2.94,2.94,0,0,0,.37-.55,2.91,2.91,0,0,0,.22-.6,2.68,2.68,0,0,0,.07-.62,1.74,1.74,0,0,0-.07-.53.74.74,0,0,0-.21-.37.52.52,0,0,0-.36-.13,1.16,1.16,0,0,0-.53.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,75.35a.12.12,0,0,1,.16,0,.25.25,0,0,1,.07.21v.48a.62.62,0,0,1-.07.29.43.43,0,0,1-.16.2l-3.5,2a.12.12,0,0,1-.16,0,.28.28,0,0,1-.07-.21V69.74a.65.65,0,0,1,.07-.29.42.42,0,0,1,.16-.2l3.43-2a.13.13,0,0,1,.16,0,.29.29,0,0,1,.07.22V68a.65.65,0,0,1-.07.29.48.48,0,0,1-.16.2l-2.84,1.64v2.81l2.65-1.53a.12.12,0,0,1,.16,0,.28.28,0,0,1,.07.21v.48a.66.66,0,0,1-.07.3.56.56,0,0,1-.16.2l-2.65,1.53V77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,65.09a2.31,2.31,0,0,1,.8-.31,1.05,1.05,0,0,1,.67.11,1.22,1.22,0,0,1,.45.59,3.31,3.31,0,0,1,.17,1.16,5,5,0,0,1-.35,1.92,4.72,4.72,0,0,1-.9,1.42l1.31,2.75a.3.3,0,0,1,0,.13.52.52,0,0,1,0,.24.32.32,0,0,1-.14.16l-.37.22c-.11.06-.2.07-.25,0a.51.51,0,0,1-.12-.16l-1.25-2.67-1.49.86v3.39a.66.66,0,0,1-.07.3.48.48,0,0,1-.16.2l-.36.2a.11.11,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-8.6a.59.59,0,0,1,.07-.29.45.45,0,0,1,.16-.21Zm-1.5,5.23,1.46-.84a2.48,2.48,0,0,0,1-.94,2.73,2.73,0,0,0,.35-1.43c0-.57-.12-.9-.35-1s-.54,0-1,.21l-1.46.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23,62a1.69,1.69,0,0,1,.93-.28,1.28,1.28,0,0,1,.68.22,1.34,1.34,0,0,1,.43.54,1.58,1.58,0,0,1,.15.66.42.42,0,0,1,0,.24.35.35,0,0,1-.14.17l-.35.2a.15.15,0,0,1-.15,0s-.08-.07-.12-.17a1.66,1.66,0,0,0-.14-.25.93.93,0,0,0-.27-.25.86.86,0,0,0-.41-.1,1.2,1.2,0,0,0-.56.19,2.49,2.49,0,0,0-.47.35,3.81,3.81,0,0,0-.39.49,2.46,2.46,0,0,0-.28.59,2.53,2.53,0,0,0-.1.67,1.09,1.09,0,0,0,.1.53.5.5,0,0,0,.32.24,1.39,1.39,0,0,0,.56,0l.82-.12a2.71,2.71,0,0,1,.83,0,1.05,1.05,0,0,1,.56.22.94.94,0,0,1,.32.51,3.17,3.17,0,0,1,.1.82,4.52,4.52,0,0,1-.17,1.2A5.61,5.61,0,0,1,122,69.8a5.43,5.43,0,0,1-.73,1,4.3,4.3,0,0,1-1,.75,1.93,1.93,0,0,1-.93.31,1.21,1.21,0,0,1-.72-.17,1.28,1.28,0,0,1-.48-.52,1.67,1.67,0,0,1-.19-.76.46.46,0,0,1,.06-.23.4.4,0,0,1,.13-.17l.36-.2a.18.18,0,0,1,.15,0s.08.07.12.17a1.15,1.15,0,0,0,.15.32.75.75,0,0,0,.29.24.91.91,0,0,0,.45.08,1.61,1.61,0,0,0,.61-.23,2.84,2.84,0,0,0,.57-.43,3.07,3.07,0,0,0,.49-.59,3.18,3.18,0,0,0,.32-.67,2.09,2.09,0,0,0,.12-.69.8.8,0,0,0-.13-.51.64.64,0,0,0-.4-.22,2.27,2.27,0,0,0-.64,0c-.25,0-.53.08-.85.14a1.78,1.78,0,0,1-.73,0,.89.89,0,0,1-.5-.28,1.35,1.35,0,0,1-.27-.55,3.63,3.63,0,0,1-.08-.79,4.21,4.21,0,0,1,.13-1,4.56,4.56,0,0,1,.38-1,5,5,0,0,1,.64-.95A3.65,3.65,0,0,1,120.23,62Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Options--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.17,341.58a4.34,4.34,0,0,0,2,3.42l1.6.93a4.43,4.43,0,0,0,3.62.17c-.93.35-1.64-.18-1.64-1.31V227.45a4,4,0,0,1,.58-1.94l-5.56-3.21a4,4,0,0,0-.58,1.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,341.58a4.34,4.34,0,0,0,2,3.42l1.6.93a4.43,4.43,0,0,0,3.62.17c-.93.35-1.64-.18-1.64-1.31V227.45a4,4,0,0,1,.58-1.94l-5.56-3.21a4,4,0,0,0-.58,1.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.42,345.54a1.05,1.05,0,0,1-.26.13h0l-.07,0a1.17,1.17,0,0,1-.3.05c-.46,0-.53-.53-.53-.85V227.55a3.46,3.46,0,0,1,.51-1.66,3.27,3.27,0,0,1,1.18-1.28l59.08-34.1a1.34,1.34,0,0,1,.6-.19c.1,0,.36,0,.48.43a2,2,0,0,1,.05.42V308.51a2.51,2.51,0,0,1-1.51,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.58,190.79a1,1,0,0,1,0,.28V308.41c0,1.15,0,1.62-1.23,2.32L213.13,345l-.16.08h0l-.05,0a1,1,0,0,1,0-.29V227.45a3,3,0,0,1,.44-1.4,2.76,2.76,0,0,1,1-1.05l59.07-34.1a.9.9,0,0,1,.26-.11m.07-1.13a1.84,1.84,0,0,0-.88.27L213.69,224a4,4,0,0,0-1.39,1.47,4.14,4.14,0,0,0-.58,1.95V344.79c0,.9.45,1.41,1.09,1.41a1.42,1.42,0,0,0,.48-.08l.07,0a2.16,2.16,0,0,0,.34-.17L273,311.7a3.07,3.07,0,0,0,1.79-3.29V191.07a2.77,2.77,0,0,0-.07-.56,1,1,0,0,0-1-.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.67,190.51c-.23-.84-1-1.11-1.9-.58L213.7,224a3.87,3.87,0,0,0-1.39,1.47l-5.56-3.2a4,4,0,0,1,1.39-1.48l59.06-34.1a4.36,4.36,0,0,1,3.95,0l1.62.93A4.32,4.32,0,0,1,274.67,190.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.67,190.51c-.23-.84-1-1.11-1.9-.58L213.7,224a3.87,3.87,0,0,0-1.39,1.47l-5.56-3.2a4,4,0,0,1,1.39-1.48l59.06-34.1a4.36,4.36,0,0,1,3.95,0l1.62.93A4.32,4.32,0,0,1,274.67,190.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,277.76a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l33.27-19.18a.5.5,0,1,1,.5.86l-33.27,19.19A.55.55,0,0,1,232.3,277.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,282.07a.5.5,0,0,1-.25-.93L265.32,262a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68L232.55,282A.45.45,0,0,1,232.3,282.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.89,289a.55.55,0,0,1-.25-.07.5.5,0,0,1-.25-.43v-5.92a.5.5,0,0,1,.25-.43l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.5.5,0,0,1-.25.43l-5.1,2.95A.59.59,0,0,1,220.89,289Zm.5-6.13v4.76l4.1-2.37V280.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,285.61a.49.49,0,0,1-.34-.14L222,284.18a.5.5,0,0,1,0-.71.51.51,0,0,1,.71,0l.85.81,2.45-5.51a.51.51,0,0,1,.67-.25.5.5,0,0,1,.25.66l-2.75,6.15a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,290.42a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l33.27-19.18a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-33.27,19.18A.45.45,0,0,1,232.3,290.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,294.73a.5.5,0,0,1-.25-.93l33.27-19.19a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68l-33.27,19.19A.54.54,0,0,1,232.3,294.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.89,301.65a.45.45,0,0,1-.25-.07.48.48,0,0,1-.25-.43v-5.91a.5.5,0,0,1,.25-.44l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.52.52,0,0,1-.25.44l-5.1,2.94A.47.47,0,0,1,220.89,301.65Zm.5-6.13v4.76l4.1-2.37v-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,298.27a.49.49,0,0,1-.34-.14L222,296.84a.5.5,0,1,1,.69-.72l.85.8,2.45-5.51a.51.51,0,0,1,.67-.25.5.5,0,0,1,.25.66L224.13,298a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,303.08a.5.5,0,0,1-.25-.93L265.32,283a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69L232.55,303A.45.45,0,0,1,232.3,303.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,307.39a.5.5,0,0,1-.25-.93l33.27-19.18a.5.5,0,1,1,.5.86l-33.27,19.19A.54.54,0,0,1,232.3,307.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.89,314.31a.45.45,0,0,1-.25-.07.48.48,0,0,1-.25-.43V307.9a.5.5,0,0,1,.25-.44l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.52.52,0,0,1-.25.44l-5.1,2.94A.47.47,0,0,1,220.89,314.31Zm.5-6.12v4.75l4.1-2.36v-4.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,310.93a.53.53,0,0,1-.34-.13L222,309.5a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l.85.8,2.45-5.5a.5.5,0,1,1,.92.4l-2.75,6.16a.5.5,0,0,1-.36.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9,316.23,255.56,302c1.43-.82,2.58-.15,2.58,1.49v3.82a5.68,5.68,0,0,1-2.58,4.46L230.9,326c-1.43.82-2.58.15-2.58-1.49V320.7A5.68,5.68,0,0,1,230.9,316.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.69,320.84a.4.4,0,0,1-.37-.11.41.41,0,0,1-.07-.25,2.05,2.05,0,0,1,.08-.51c0-.19.11-.3.18-.34s.07,0,.13,0l.14,0a.52.52,0,0,0,.37-.05.78.78,0,0,0,.28-.29.83.83,0,0,0,.13-.49.66.66,0,0,0-.07-.34.31.31,0,0,0-.16-.16l-.26-.09a1,1,0,0,1-.59-.41,1.87,1.87,0,0,1-.18-.95,2.84,2.84,0,0,1,.31-1.34,2,2,0,0,1,.81-.88,1.09,1.09,0,0,1,.38-.14.53.53,0,0,1,.32,0c.06,0,.09.11.09.23a2.41,2.41,0,0,1-.06.49c0,.18-.09.29-.15.32a.3.3,0,0,1-.16,0,.59.59,0,0,0-.34.07.8.8,0,0,0-.3.31,1,1,0,0,0-.08.37.56.56,0,0,0,.11.4.73.73,0,0,0,.33.16l.12,0a.88.88,0,0,1,.53.4,1.88,1.88,0,0,1,.16.9,3.3,3.3,0,0,1-.13.92,2.63,2.63,0,0,1-.39.85,1.87,1.87,0,0,1-.64.61A1.35,1.35,0,0,1,236.69,320.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.79,319.6a.33.33,0,0,1,0-.22v-5.09a.68.68,0,0,1,0-.27.35.35,0,0,1,.15-.17l1.57-.91c.06,0,.1,0,.12,0a.63.63,0,0,1,0,.29v.25a1,1,0,0,1,0,.33.25.25,0,0,1-.12.17l-.93.54v1.19l.83-.48c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-.83.49v1.32l.94-.54s.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C238.87,319.63,238.82,319.64,238.79,319.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,318.2a.39.39,0,0,1,0-.23v-5.16a.49.49,0,0,1,.31-.44l.21-.13c.21-.12.31-.09.31.09v4.42l.79-.46c.06,0,.1,0,.13,0a.93.93,0,0,1,0,.29v.25a1.31,1.31,0,0,1,0,.33.29.29,0,0,1-.13.17l-1.42.83C241.31,318.23,241.26,318.23,241.23,318.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,316.94a.33.33,0,0,1-.05-.22v-5.09a.68.68,0,0,1,.05-.27.35.35,0,0,1,.15-.17l1.57-.91s.09,0,.12,0a.81.81,0,0,1,0,.29v.25a1.34,1.34,0,0,1,0,.33.32.32,0,0,1-.12.17l-.94.54v1.19l.84-.48s.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-.84.49v1.32l.95-.54c.05,0,.09,0,.11,0a.85.85,0,0,1,0,.29v.26a1.34,1.34,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C243.48,317,243.43,317,243.4,316.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,314.86a4.06,4.06,0,0,1-.34-2,6.76,6.76,0,0,1,.36-2.41,2.52,2.52,0,0,1,1.09-1.35,1.28,1.28,0,0,1,.46-.18c.11,0,.17.07.17.26a2.35,2.35,0,0,1-.07.6c-.05.19-.11.29-.18.29a.78.78,0,0,0-.34.12,1.14,1.14,0,0,0-.48.72,5.62,5.62,0,0,0-.16,1.46,3.8,3.8,0,0,0,.16,1.29.31.31,0,0,0,.5.16.83.83,0,0,0,.17-.12l.19-.17s0,0,0,0,.13,0,.16.11a1.69,1.69,0,0,1,.06.51.56.56,0,0,1,0,.23.57.57,0,0,1-.12.21,1.79,1.79,0,0,1-.24.22,1.6,1.6,0,0,1-.31.22C246.61,315.24,246.24,315.21,246,314.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.72,313.7v-4.42l-.59.34q-.09,0-.12,0a.63.63,0,0,1,0-.29v-.25a1,1,0,0,1,0-.33.25.25,0,0,1,.12-.17l2-1.17q.09,0,.12,0a.66.66,0,0,1,0,.29V308a1.05,1.05,0,0,1,0,.34.23.23,0,0,1-.12.16l-.6.35v4.42a.5.5,0,0,1-.31.44l-.21.13C248.82,313.91,248.72,313.88,248.72,313.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.15,267.14l0,.11v.64l-.93.54v-.65l0-.17a1.43,1.43,0,0,1-1.49-.22l.66-1.4a.9.9,0,0,0,.83.21l0-.14v-.91l0-.16c-.73.14-1.39.15-1.39-1a3.46,3.46,0,0,1,1.38-2.62l0-.13v-.63l.93-.54v.65l0,.19a1.12,1.12,0,0,1,1.31.35l-.67,1.43a.74.74,0,0,0-.66-.32l.07.14v.69l-.06.17.13,0c.83-.17,1.26.23,1.26,1.11A3.53,3.53,0,0,1,236.15,267.14Zm-.83-4.36a.84.84,0,0,0-.35.58c0,.16.14.24.35.18l0-.11V263Zm.83,2.06,0,.14v.61l0,.18a.9.9,0,0,0,.36-.61C236.51,265,236.44,264.83,236.15,264.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,264.76l-1,.6v-4l0-.69h0l-.24.66-.17.38-.63-.63,1.2-2.53.84-.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.44,264c-.35.2-.53-.06-.53-.57a1.34,1.34,0,0,1,.53-1.18c.34-.2.52.07.52.57A1.34,1.34,0,0,1,241.44,264Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45,262.32c-.7.4-1.23.41-1.61.06l.69-1.46a.73.73,0,0,0,.91,0,2.33,2.33,0,0,0,1-1.66h0a3,3,0,0,1-.93.94c-1.22.71-1.9,0-1.88-1.3a4.19,4.19,0,0,1,1.93-3.49c1.36-.78,2,.3,2,2.24C246.52,259.78,245.64,261.63,244.45,262.32Zm.11-5.49a2,2,0,0,0-.89,1.5c0,.41.23.85.85.49a1.93,1.93,0,0,0,.88-1.51C245.41,256.91,245.17,256.47,244.56,256.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,259.72c-.69.4-1.23.41-1.61.06l.69-1.46a.73.73,0,0,0,.91,0,2.3,2.3,0,0,0,1-1.66h0a3,3,0,0,1-.92.94c-1.23.71-1.9,0-1.89-1.3a4.23,4.23,0,0,1,1.93-3.49c1.36-.78,2,.31,2,2.24C251,257.19,250.15,259,249,259.72Zm.11-5.49a1.91,1.91,0,0,0-.88,1.5c0,.41.22.85.84.49a2,2,0,0,0,.89-1.51C249.91,254.31,249.68,253.87,249.06,254.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,246.25h-.13a.62.62,0,0,1-.43-.64l-.19-4.31-2.77-.65a.56.56,0,0,1-.4-.4,1.48,1.48,0,0,1,.35-1.27l3.18-3.48.79-4.88a1.35,1.35,0,0,1,.77-1.05.53.53,0,0,1,.55.14l2,2.16,3.27-2.24a.59.59,0,0,1,.71,0,.94.94,0,0,1,.14,1.09l-1.84,4.88,1.3,3.41a1.33,1.33,0,0,1-.13,1,1.1,1.1,0,0,1-.65.57l-3.24.72L240,245.71A.9.9,0,0,1,239.23,246.25Zm1.34-16.2a.82.82,0,0,0-.43.64l-.81,5-.05.06L236,239.32a1.09,1.09,0,0,0-.25.69.36.36,0,0,0,0,.13l3.15.74.2,4.7a.5.5,0,0,0,0,.16c.05,0,.17-.05.31-.29l2.69-4.62,3.46-.78a.59.59,0,0,0,.3-.31.78.78,0,0,0,.1-.59l-1.36-3.59,1.91-5.06c.12-.3.05-.48,0-.5l-.09,0-3.64,2.5-2.34-2.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,226a.89.89,0,0,1-.45-.12,1.39,1.39,0,0,1-.57-1.25,3.25,3.25,0,0,1,1.4-2.65,1.08,1.08,0,0,1,1.09-.07,1.38,1.38,0,0,1,.56,1.25,3.27,3.27,0,0,1-1.39,2.65A1.27,1.27,0,0,1,244.43,226Zm1-3.69a.77.77,0,0,0-.37.12,2.78,2.78,0,0,0-1.14,2.2.89.89,0,0,0,.31.8.58.58,0,0,0,.57-.07,2.81,2.81,0,0,0,1.14-2.2.91.91,0,0,0-.31-.8A.37.37,0,0,0,245.44,222.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.94,231.42a2.16,2.16,0,0,1-.9,1.73c-.5.29-.91,0-.91-.68a2.15,2.15,0,0,1,.91-1.73C251.54,230.45,251.94,230.75,251.94,231.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.66,250.84a7,7,0,0,1-1.22-.11.26.26,0,0,1-.2-.31.24.24,0,0,1,.3-.2,6.19,6.19,0,0,0,1.37.1.26.26,0,1,1,0,.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.62,250.24a.26.26,0,0,1-.24-.16.27.27,0,0,1,.15-.34,10.75,10.75,0,0,0,1.65-.79c6.4-3.69,11.6-13.64,11.6-22.18,0-4.44-1.43-7.82-3.93-9.26-2-1.18-4.67-1-7.41.62a17.11,17.11,0,0,0-3.23,2.48.26.26,0,0,1-.36-.37,17.77,17.77,0,0,1,3.33-2.56c2.9-1.67,5.72-1.89,7.93-.61,2.66,1.53,4.19,5.07,4.19,9.7,0,8.7-5.32,18.85-11.86,22.63a12.85,12.85,0,0,1-1.72.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.14,249.72a.21.21,0,0,1-.15-.05c-2.36-1.69-3.66-5-3.66-9.36a30.38,30.38,0,0,1,5.87-17,.27.27,0,0,1,.36-.05.26.26,0,0,1,.06.36,29.78,29.78,0,0,0-5.77,16.72c0,4.17,1.22,7.35,3.44,8.94a.28.28,0,0,1,.06.37A.25.25,0,0,1,235.14,249.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,221.86c.06-.18.2-.31.3-.29s.14.18.09.35-.2.3-.3.29S238.42,222,238.48,221.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,214.9c.06-.18.19-.3.3-.28s.14.17.08.35-.19.3-.3.28S250.79,215.08,250.85,214.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.07,250c.06-.18.19-.3.3-.28s.14.17.08.35-.19.3-.3.28S236,250.22,236.07,250Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.06,250.32c.06-.17.19-.3.3-.28s.14.18.08.35-.19.3-.3.29S240,250.5,240.06,250.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.39,252.84a7.72,7.72,0,0,1-4-1.06c-3.12-1.83-4.91-5.74-4.91-10.72a.26.26,0,0,1,.26-.26.26.26,0,0,1,.26.26c0,4.79,1.69,8.54,4.65,10.28,2.46,1.44,5.47,1.33,8.47-.34a13.34,13.34,0,0,0,1.31-.85.26.26,0,0,1,.3.42c-.52.37-1,.65-1.36.88A10.33,10.33,0,0,1,238.39,252.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,226.28a.26.26,0,0,1-.26-.26c0-4.25-1.44-7.82-4-9.8a.26.26,0,1,1,.32-.41c2.64,2.08,4.16,5.8,4.16,10.21A.26.26,0,0,1,256.69,226.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.76,233.5h-.07a.25.25,0,0,1-.17-.32c2.32-7.93,6.5-13.83,12.09-17.06a12.36,12.36,0,0,1,6.48-1.74.25.25,0,0,1,.23.28.25.25,0,0,1-.27.23,11.86,11.86,0,0,0-6.18,1.68c-5.47,3.16-9.57,8.95-11.86,16.76A.25.25,0,0,1,230.76,233.5Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.52,297.53a4.37,4.37,0,0,0,2,3.42l1.6.93a4.43,4.43,0,0,0,3.62.16c-.93.36-1.64-.18-1.64-1.3V183.4a4,4,0,0,1,.58-2l-5.56-3.21a4,4,0,0,0-.58,1.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.52,297.53a4.37,4.37,0,0,0,2,3.42l1.6.93a4.43,4.43,0,0,0,3.62.16c-.93.36-1.64-.18-1.64-1.3V183.4a4,4,0,0,1,.58-2l-5.56-3.21a4,4,0,0,0-.58,1.95Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77,301.49a1.2,1.2,0,0,1-.25.13h0l-.07,0a1.17,1.17,0,0,1-.3.05c-.46,0-.53-.53-.53-.85V183.5a3.53,3.53,0,0,1,.51-1.67,3.31,3.31,0,0,1,1.18-1.27l59.08-34.1a1.34,1.34,0,0,1,.6-.19c.1,0,.36,0,.48.43a1.93,1.93,0,0,1,0,.42V264.46a2.51,2.51,0,0,1-1.51,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,146.74a1.33,1.33,0,0,1,0,.28V264.36c0,1.14,0,1.62-1.23,2.32l-59.26,34.24-.16.07h-.09a.83.83,0,0,1,0-.28V183.4a3,3,0,0,1,.44-1.41,3,3,0,0,1,1-1.05l59.07-34.09a.83.83,0,0,1,.27-.11m.06-1.13a1.84,1.84,0,0,0-.88.27L290,180a3.92,3.92,0,0,0-1.38,1.47,4,4,0,0,0-.59,2V300.74c0,.9.45,1.41,1.09,1.41a1.72,1.72,0,0,0,.48-.08l.07,0,.34-.17,59.25-34.23a3.06,3.06,0,0,0,1.79-3.29V147a2.77,2.77,0,0,0-.07-.56,1,1,0,0,0-1-.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,146.46c-.23-.84-1-1.11-1.9-.58L290.05,180a3.8,3.8,0,0,0-1.39,1.47l-5.56-3.21a4,4,0,0,1,1.39-1.47l59.06-34.1a4.36,4.36,0,0,1,3.95,0l1.62.93A4.32,4.32,0,0,1,351,146.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,146.46c-.23-.84-1-1.11-1.9-.58L290.05,180a3.8,3.8,0,0,0-1.39,1.47l-5.56-3.21a4,4,0,0,1,1.39-1.47l59.06-34.1a4.36,4.36,0,0,1,3.95,0l1.62.93A4.32,4.32,0,0,1,351,146.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,233.7a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l33.27-19.18a.5.5,0,1,1,.5.86L308.9,233.64A.51.51,0,0,1,308.65,233.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,238a.5.5,0,0,1-.25-.93l33.27-19.19a.5.5,0,1,1,.5.87L308.9,238A.43.43,0,0,1,308.65,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,244.93a.54.54,0,0,1-.25-.06.52.52,0,0,1-.25-.44v-5.91a.5.5,0,0,1,.25-.43l5.1-3a.55.55,0,0,1,.5,0,.52.52,0,0,1,.25.44v5.91a.5.5,0,0,1-.25.43l-5.1,3A.54.54,0,0,1,297.24,244.93Zm.5-6.12v4.76l4.1-2.37v-4.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,241.56a.5.5,0,0,1-.35-.14l-1.36-1.29a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l.85.81,2.46-5.51a.5.5,0,1,1,.91.41l-2.75,6.15a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,246.37a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l33.27-19.18a.5.5,0,1,1,.5.86L308.9,246.3A.52.52,0,0,1,308.65,246.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,250.68a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l33.27-19.19a.52.52,0,0,1,.69.19.51.51,0,0,1-.19.68L308.9,250.61A.43.43,0,0,1,308.65,250.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,257.6a.55.55,0,0,1-.25-.07.5.5,0,0,1-.25-.43v-5.92a.52.52,0,0,1,.25-.43l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.49.49,0,0,1-.25.43l-5.1,2.95A.55.55,0,0,1,297.24,257.6Zm.5-6.13v4.76l4.1-2.37v-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,254.22a.5.5,0,0,1-.35-.14l-1.36-1.29a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l.85.8,2.46-5.51a.5.5,0,0,1,.91.41l-2.75,6.15a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,259a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l33.27-19.18a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69L308.9,259A.43.43,0,0,1,308.65,259Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,263.34a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l33.27-19.18a.5.5,0,1,1,.5.86L308.9,263.28A.51.51,0,0,1,308.65,263.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,270.26a.45.45,0,0,1-.25-.07.5.5,0,0,1-.25-.43v-5.91a.52.52,0,0,1,.25-.44l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.52.52,0,0,1-.25.44l-5.1,2.94A.45.45,0,0,1,297.24,270.26Zm.5-6.13v4.76l4.1-2.37v-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,266.88a.5.5,0,0,1-.35-.14l-1.36-1.29a.5.5,0,0,1,.69-.72l.85.8,2.46-5.5a.49.49,0,0,1,.66-.26.51.51,0,0,1,.25.66l-2.75,6.16a.5.5,0,0,1-.36.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,272.18l24.66-14.24c1.43-.82,2.58-.16,2.58,1.49v3.82a5.68,5.68,0,0,1-2.58,4.46L307.25,282c-1.43.83-2.58.16-2.58-1.48v-3.82A5.68,5.68,0,0,1,307.25,272.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,276.79a.4.4,0,0,1-.37-.11.41.41,0,0,1-.07-.25,2.05,2.05,0,0,1,.08-.51c.05-.19.11-.3.18-.34a.14.14,0,0,1,.13,0l.14,0a.52.52,0,0,0,.37-.05.78.78,0,0,0,.28-.29.83.83,0,0,0,.13-.49.66.66,0,0,0-.07-.34.34.34,0,0,0-.15-.16l-.27-.09a1,1,0,0,1-.59-.41,1.87,1.87,0,0,1-.18-1,2.82,2.82,0,0,1,.31-1.34,2,2,0,0,1,.81-.88,1.09,1.09,0,0,1,.38-.14.53.53,0,0,1,.32,0c.06,0,.09.11.09.23a2.41,2.41,0,0,1-.06.49c0,.18-.09.29-.15.32a.3.3,0,0,1-.15,0,.72.72,0,0,0-.35.08.66.66,0,0,0-.29.31.83.83,0,0,0-.08.37.57.57,0,0,0,.1.4.73.73,0,0,0,.33.16l.12,0a.9.9,0,0,1,.53.39,1.88,1.88,0,0,1,.16.9,3.31,3.31,0,0,1-.13.93,2.84,2.84,0,0,1-.38.85,2,2,0,0,1-.65.61A1.35,1.35,0,0,1,313,276.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,275.55a.35.35,0,0,1-.05-.22v-5.09a.68.68,0,0,1,.05-.27.35.35,0,0,1,.15-.17l1.57-.91q.09,0,.12,0a.71.71,0,0,1,0,.3v.25a1,1,0,0,1,0,.33.25.25,0,0,1-.12.17l-.93.54v1.19l.83-.48c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-.83.48v1.33l.94-.54c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C315.22,275.58,315.17,275.58,315.14,275.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.58,274.15a.39.39,0,0,1-.05-.23v-5.16a.52.52,0,0,1,.31-.45l.21-.12c.21-.12.31-.09.31.09v4.42l.8-.46a.08.08,0,0,1,.12,0,.89.89,0,0,1,0,.29v.25a1.42,1.42,0,0,1,0,.33.32.32,0,0,1-.12.17l-1.43.83C317.66,274.18,317.61,274.18,317.58,274.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75,272.89a.35.35,0,0,1-.05-.22v-5.09a.68.68,0,0,1,.05-.27.31.31,0,0,1,.15-.17l1.57-.91c.06,0,.09,0,.12,0a.9.9,0,0,1,0,.29v.26a1.34,1.34,0,0,1,0,.33.28.28,0,0,1-.12.17l-.94.54V269l.84-.48c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.25a1,1,0,0,1,0,.34.24.24,0,0,1-.11.16l-.84.48v1.33l1-.54s.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C319.83,272.92,319.78,272.92,319.75,272.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,270.81a4.08,4.08,0,0,1-.34-2.05,6.74,6.74,0,0,1,.36-2.4,2.49,2.49,0,0,1,1.09-1.35,1.28,1.28,0,0,1,.46-.18c.11,0,.17.07.17.26a2.35,2.35,0,0,1-.07.6c-.05.19-.11.29-.18.29a.9.9,0,0,0-.34.11,1.19,1.19,0,0,0-.48.73,5.62,5.62,0,0,0-.16,1.46,3.8,3.8,0,0,0,.16,1.29.31.31,0,0,0,.5.16l.18-.12.18-.17,0,0c.08,0,.13,0,.16.11a1.69,1.69,0,0,1,.06.51.85.85,0,0,1,0,.23.8.8,0,0,1-.13.21,2.85,2.85,0,0,1-.24.22l-.31.22C323,271.18,322.6,271.16,322.37,270.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.07,269.65v-4.42l-.59.34q-.09,0-.12,0a.85.85,0,0,1,0-.29V265a1.44,1.44,0,0,1,0-.34.23.23,0,0,1,.12-.16l2-1.17q.09,0,.12,0a.63.63,0,0,1,0,.29v.25a1,1,0,0,1,0,.33.23.23,0,0,1-.12.17l-.59.35v4.42a.53.53,0,0,1-.31.44l-.22.13C325.17,269.86,325.07,269.83,325.07,269.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.68,223.57l.05.1v.64l-.93.55v-.65l0-.18a1.41,1.41,0,0,1-1.49-.22l.66-1.4a.87.87,0,0,0,.83.21l0-.14v-.91l.05-.16c-.73.15-1.39.15-1.39-1a3.46,3.46,0,0,1,1.38-2.63l0-.12v-.64l.93-.54v.65l-.05.2a1.11,1.11,0,0,1,1.31.34l-.67,1.43a.79.79,0,0,0-.66-.32l.07.14v.69l-.06.17.13,0c.83-.17,1.26.23,1.26,1.11A3.52,3.52,0,0,1,311.68,223.57Zm-.83-4.37a.84.84,0,0,0-.35.59c0,.15.13.23.35.17l-.05-.11v-.48Zm.83,2.06.05.14V222l-.05.17a.9.9,0,0,0,.36-.61C312,221.41,312,221.25,311.68,221.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.61,221.25a1.39,1.39,0,0,1-1.88-.08l.67-1.44a.91.91,0,0,0,1.21.12,1.59,1.59,0,0,0,.81-1.21c0-.41-.24-.57-.77-.26l-.78.41v-1.28l.75-.47a1.24,1.24,0,0,0,.7-1c0-.36-.25-.44-.71-.17a3.09,3.09,0,0,0-1.18,1.42l-.69-.66a4.8,4.8,0,0,1,1.87-2.16c1.19-.68,1.76-.16,1.76.86a2.86,2.86,0,0,1-.65,1.72v0c.38-.07.74.33.74,1.05A3.69,3.69,0,0,1,315.61,221.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,219.52c-.35.2-.53-.07-.53-.58a1.32,1.32,0,0,1,.53-1.17c.34-.2.52.06.52.56A1.36,1.36,0,0,1,318.61,219.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.62,217.79c-.7.4-1.23.41-1.61.06l.69-1.46a.73.73,0,0,0,.91,0,2.3,2.3,0,0,0,1-1.65h0a2.87,2.87,0,0,1-.93.94c-1.22.71-1.9,0-1.88-1.3a4.19,4.19,0,0,1,1.93-3.48c1.36-.79,2,.3,2,2.23C323.69,215.26,322.81,217.1,321.62,217.79Zm.11-5.49a2,2,0,0,0-.89,1.51c0,.4.23.85.85.49a1.93,1.93,0,0,0,.88-1.52C322.58,212.39,322.34,212,321.73,212.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.12,215.19c-.69.4-1.23.41-1.61.06l.69-1.45a.75.75,0,0,0,.91,0,2.27,2.27,0,0,0,1-1.65h0a2.85,2.85,0,0,1-.92.94c-1.23.71-1.9,0-1.89-1.3a4.2,4.2,0,0,1,1.94-3.48c1.35-.79,2,.3,2,2.23C328.19,212.66,327.32,214.5,326.12,215.19Zm.11-5.49a1.94,1.94,0,0,0-.88,1.51c0,.4.22.85.84.49a2,2,0,0,0,.89-1.52C327.08,209.79,326.85,209.35,326.23,209.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,188.16h-.07a.42.42,0,0,1-.33-.39l-.23-1.82-1.28-.07a.38.38,0,0,1-.33-.24.76.76,0,0,1,.14-.75l1.43-1.8.21-2.24a.79.79,0,0,1,.42-.64.38.38,0,0,1,.4,0l1,.76,1.47-1.21a.43.43,0,0,1,.52-.05.54.54,0,0,1,.15.64l-.72,2.3.74,1.39a.66.66,0,0,1,0,.55.73.73,0,0,1-.39.43l-1.54.56-1.1,2.17A.59.59,0,0,1,320,188.16Zm-1.77-2.79,1.39.08a.27.27,0,0,1,.24.23l.23,1.79,1.09-2.17a.25.25,0,0,1,.14-.13l1.64-.6a.3.3,0,0,0,.11-.25l-.79-1.48a.27.27,0,0,1,0-.2l.72-2.28-1.44,1.18a.26.26,0,0,1-.32,0l-1.09-.83a.3.3,0,0,0-.07.18l-.22,2.32a.31.31,0,0,1-.06.13l-1.48,1.86A.37.37,0,0,0,318.21,185.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,179.11a1.57,1.57,0,0,1-.64,1.23c-.36.2-.64,0-.64-.49a1.51,1.51,0,0,1,.64-1.22C317.61,178.42,317.9,178.64,317.9,179.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,172.85h-.05a6.86,6.86,0,0,0-1.37-.1.26.26,0,1,1,0-.51,6.54,6.54,0,0,1,1.48.1.26.26,0,0,1,0,.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77,206.82a6.29,6.29,0,0,1-3.14-.82c-2.65-1.54-4.18-5.08-4.18-9.71,0-8.7,5.32-18.85,11.86-22.63a12.85,12.85,0,0,1,1.72-.83.27.27,0,0,1,.34.15.27.27,0,0,1-.15.34,11.3,11.3,0,0,0-1.66.79C313.17,177.8,308,187.75,308,196.29c0,4.44,1.43,7.82,3.92,9.26,2.05,1.18,4.68,1,7.42-.62a17,17,0,0,0,3.23-2.48.25.25,0,0,1,.36,0,.25.25,0,0,1,0,.36,17.15,17.15,0,0,1-3.33,2.56A9.72,9.72,0,0,1,314.77,206.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.34,199.88a.3.3,0,0,1-.16,0,.27.27,0,0,1-.05-.36,29.78,29.78,0,0,0,5.77-16.72c0-4.17-1.22-7.35-3.44-8.94a.27.27,0,0,1-.06-.37.26.26,0,0,1,.36-.05c2.36,1.69,3.66,5,3.66,9.36a30.38,30.38,0,0,1-5.87,17A.28.28,0,0,1,325.34,199.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.26,201.2c-.05.18-.19.31-.29.29s-.15-.18-.09-.35.2-.3.3-.29S324.32,201,324.26,201.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,208.16c-.06.18-.19.3-.3.28s-.14-.17-.08-.35.19-.3.3-.28S312,208,311.9,208.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,173c-.06.18-.19.3-.3.28s-.14-.17-.08-.35.19-.3.3-.28S326.74,172.85,326.68,173Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.69,172.74c-.06.17-.2.3-.3.28s-.15-.18-.09-.35.2-.3.3-.29S322.75,172.56,322.69,172.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,174.28c-.06.18-.19.3-.3.28s-.14-.17-.08-.35.19-.3.3-.28S316.79,174.1,316.73,174.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,175.6c-.06.18-.19.31-.29.29s-.15-.18-.09-.35.2-.31.3-.29S315.46,175.43,315.4,175.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.76,182.09a.26.26,0,0,1-.26-.26c0-4.83-1.6-8.52-4.4-10.14-2.37-1.37-5.41-1.13-8.54.68-.44.26-.89.54-1.32.85a.26.26,0,0,1-.36-.06.27.27,0,0,1,.06-.36c.45-.32.91-.61,1.37-.88,3.3-1.9,6.51-2.14,9.05-.68,3,1.71,4.66,5.57,4.66,10.59A.26.26,0,0,1,332.76,182.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.12,207.31a.25.25,0,0,1-.16-.06c-2.46-1.93-3.81-5.56-3.81-10.21a.26.26,0,1,1,.51,0c0,4.49,1.29,8,3.62,9.8a.27.27,0,0,1,0,.37A.26.26,0,0,1,310.12,207.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.25,208.72a5.68,5.68,0,0,1-.59,0,.26.26,0,1,1,0-.51,11.59,11.59,0,0,0,6-1.51c5.15-2.85,9.51-9.14,11.64-16.84a.26.26,0,0,1,.32-.18.26.26,0,0,1,.18.32c-2.17,7.83-6.62,14.24-11.89,17.15A12.5,12.5,0,0,1,314.25,208.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.73,201.16a3.47,3.47,0,0,1-1.74-.45c-1.45-.84-2.28-2.76-2.28-5.27a15.89,15.89,0,0,1,4.83-11,.26.26,0,0,1,.39.33,13,13,0,0,0-2.08,6.67c0,1.91.61,3.36,1.67,4a3.1,3.1,0,0,0,3.14-.27,11.29,11.29,0,0,0,4.52-6.34.26.26,0,0,1,.29-.18.27.27,0,0,1,.22.27c-.24,4.53-3,9.59-6.35,11.5A5.27,5.27,0,0,1,314.73,201.16Zm-.21-14.88a15.66,15.66,0,0,0-3.3,9.16c0,2.32.74,4.08,2,4.82a3.77,3.77,0,0,0,3.83-.33c2.68-1.55,5-5.25,5.81-9a10.84,10.84,0,0,1-4,4.64,3.62,3.62,0,0,1-3.66.27c-1.22-.71-1.93-2.32-1.93-4.42A12.9,12.9,0,0,1,314.52,186.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63,181.39a.25.25,0,0,1-.18-.08.25.25,0,0,1,0-.36c2.39-2.42,4.41-2.88,5.19-2.61a.27.27,0,0,1,.16.33.26.26,0,0,1-.34.16c-.52-.19-2.36.17-4.65,2.48A.25.25,0,0,1,323.63,181.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.17,186.51a.27.27,0,0,1-.26-.21c-.34-1.78-1.09-3-2.17-3.47a3,3,0,0,0-2.8.24.26.26,0,1,1-.25-.45,3.55,3.55,0,0,1,3.27-.26c.86.39,2,1.38,2.46,3.84a.26.26,0,0,1-.2.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,201.28a.3.3,0,0,1-.16-.05.26.26,0,0,1-.05-.36,19.88,19.88,0,0,0,3.44-9.78c.19-3-.44-5.43-1.57-6a.27.27,0,0,1-.11-.35.26.26,0,0,1,.35-.11c1.35.7,2.06,3.2,1.84,6.52a20.26,20.26,0,0,1-3.53,10A.28.28,0,0,1,322.15,201.28Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.87,253.48a4.37,4.37,0,0,0,2,3.42l1.61.93a4.4,4.4,0,0,0,3.61.16c-.93.36-1.64-.18-1.64-1.3V139.35a4,4,0,0,1,.58-1.95l-5.56-3.21a4,4,0,0,0-.58,1.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,253.48a4.37,4.37,0,0,0,2,3.42l1.61.93a4.4,4.4,0,0,0,3.61.16c-.93.36-1.64-.18-1.64-1.3V139.35a4,4,0,0,1,.58-1.95l-5.56-3.21a4,4,0,0,0-.58,1.95Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,257.44a.85.85,0,0,1-.25.13h0l-.08,0a1.17,1.17,0,0,1-.3.05c-.46,0-.53-.53-.53-.85V139.45a3.53,3.53,0,0,1,.51-1.67,3.41,3.41,0,0,1,1.19-1.27l59.07-34.1a1.34,1.34,0,0,1,.6-.19c.1,0,.36,0,.48.43a1.93,1.93,0,0,1,.05.42V220.41a2.51,2.51,0,0,1-1.51,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.29,102.69a1.33,1.33,0,0,1,0,.28V220.31c0,1.14,0,1.62-1.23,2.32l-59.26,34.24-.16.07h-.09a.83.83,0,0,1,0-.28V139.35a3,3,0,0,1,.44-1.41,3,3,0,0,1,1-1.05L426,102.8a.72.72,0,0,1,.26-.11m.06-1.13a1.74,1.74,0,0,0-.88.27l-59.08,34.1A3.92,3.92,0,0,0,365,137.4a4,4,0,0,0-.59,1.95V256.69c0,.9.45,1.41,1.09,1.41A1.72,1.72,0,0,0,366,258a.11.11,0,0,0,.07,0,2.11,2.11,0,0,0,.34-.16l59.25-34.24a3,3,0,0,0,1.79-3.28V103a2.2,2.2,0,0,0-.07-.56,1,1,0,0,0-1-.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38,102.41c-.23-.84-1-1.11-1.91-.59L366.4,135.93A3.8,3.8,0,0,0,365,137.4l-5.56-3.21a4,4,0,0,1,1.39-1.47l59.06-34.1a4.38,4.38,0,0,1,4,0l1.61.93A4.37,4.37,0,0,1,427.38,102.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38,102.41c-.23-.84-1-1.11-1.91-.59L366.4,135.93A3.8,3.8,0,0,0,365,137.4l-5.56-3.21a4,4,0,0,1,1.39-1.47l59.06-34.1a4.38,4.38,0,0,1,4,0l1.61.93A4.37,4.37,0,0,1,427.38,102.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385,189.65a.5.5,0,0,1-.25-.93L418,169.54a.5.5,0,1,1,.5.86l-33.26,19.19A.57.57,0,0,1,385,189.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,194a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68L418,173.85a.5.5,0,1,1,.5.87L385.26,193.9A.47.47,0,0,1,385,194Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,200.88a.54.54,0,0,1-.25-.06.52.52,0,0,1-.25-.44v-5.91a.5.5,0,0,1,.25-.43l5.1-2.95a.55.55,0,0,1,.5,0,.52.52,0,0,1,.25.44v5.91a.5.5,0,0,1-.25.43l-5.1,2.95A.54.54,0,0,1,373.59,200.88Zm.5-6.12v4.76l4.1-2.37v-4.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,197.51a.52.52,0,0,1-.35-.14l-1.36-1.29a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l.85.81,2.46-5.51a.5.5,0,0,1,.91.41l-2.75,6.15a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,202.32a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69L418,182.2a.5.5,0,1,1,.5.86l-33.26,19.19A.59.59,0,0,1,385,202.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,206.63a.5.5,0,0,1-.25-.93L418,186.51a.5.5,0,1,1,.5.87l-33.26,19.18A.47.47,0,0,1,385,206.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,213.55a.55.55,0,0,1-.25-.07.52.52,0,0,1-.25-.43v-5.92a.52.52,0,0,1,.25-.43l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.5.5,0,0,1-.25.43l-5.1,2.95A.55.55,0,0,1,373.59,213.55Zm.5-6.13v4.76l4.1-2.37v-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,210.17A.52.52,0,0,1,376,210l-1.36-1.29a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l.85.81,2.46-5.51a.5.5,0,0,1,.91.41l-2.75,6.15a.49.49,0,0,1-.36.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,215a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69L418,194.86a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-33.26,19.18A.47.47,0,0,1,385,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,219.29a.5.5,0,0,1-.25-.93L418,199.18a.5.5,0,1,1,.5.86l-33.26,19.19A.57.57,0,0,1,385,219.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,226.21a.45.45,0,0,1-.25-.07.5.5,0,0,1-.25-.43V219.8a.52.52,0,0,1,.25-.44l5.1-2.94a.5.5,0,0,1,.5,0,.5.5,0,0,1,.25.43v5.91a.52.52,0,0,1-.25.44l-5.1,2.94A.45.45,0,0,1,373.59,226.21Zm.5-6.13v4.76l4.1-2.37v-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,222.83a.52.52,0,0,1-.35-.14l-1.36-1.29a.5.5,0,0,1,.69-.72l.85.8,2.46-5.51a.5.5,0,0,1,.91.41l-2.75,6.16a.5.5,0,0,1-.36.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6,228.13l24.66-14.24c1.43-.82,2.58-.16,2.58,1.49v3.82a5.68,5.68,0,0,1-2.58,4.46L383.6,237.9c-1.43.83-2.58.16-2.58-1.48V232.6A5.68,5.68,0,0,1,383.6,228.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.39,232.74a.4.4,0,0,1-.37-.11.41.41,0,0,1-.07-.25,2.05,2.05,0,0,1,.08-.51c.06-.19.11-.3.18-.34a.14.14,0,0,1,.13,0l.14,0a.52.52,0,0,0,.37,0,.78.78,0,0,0,.28-.29.83.83,0,0,0,.13-.49.64.64,0,0,0-.07-.34.34.34,0,0,0-.15-.16l-.27-.09a1,1,0,0,1-.59-.41,1.87,1.87,0,0,1-.18-1,2.82,2.82,0,0,1,.31-1.34,2,2,0,0,1,.81-.88,1.09,1.09,0,0,1,.38-.14.53.53,0,0,1,.32,0c.06,0,.09.11.09.23a2.41,2.41,0,0,1-.06.49c0,.18-.09.29-.15.32a.3.3,0,0,1-.15,0,.72.72,0,0,0-.35.08.66.66,0,0,0-.29.31.83.83,0,0,0-.08.37.57.57,0,0,0,.1.4.73.73,0,0,0,.33.16l.12,0a.87.87,0,0,1,.53.39,1.88,1.88,0,0,1,.16.9,3.31,3.31,0,0,1-.13.93,2.84,2.84,0,0,1-.38.85,2,2,0,0,1-.65.61A1.35,1.35,0,0,1,389.39,232.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.49,231.5a.37.37,0,0,1,0-.22v-5.09a.7.7,0,0,1,0-.27.36.36,0,0,1,.15-.17l1.58-.91s.09,0,.11,0a.71.71,0,0,1,0,.3v.25a1,1,0,0,1,0,.33.27.27,0,0,1-.11.17l-.94.54v1.19l.83-.48c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-.83.48v1.33l.94-.54s.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C391.57,231.53,391.53,231.53,391.49,231.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.93,230.09a.33.33,0,0,1-.05-.22v-5.16a.52.52,0,0,1,.31-.45l.21-.12c.21-.12.31-.09.31.09v4.42l.8-.46a.08.08,0,0,1,.12,0,.81.81,0,0,1,0,.29v.25a1.34,1.34,0,0,1,0,.33.32.32,0,0,1-.12.17l-1.43.83Q394,230.15,393.93,230.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.1,228.84a.35.35,0,0,1-.05-.22v-5.09a.68.68,0,0,1,.05-.27.31.31,0,0,1,.15-.17l1.57-.91q.09,0,.12,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.25.25,0,0,1-.12.17l-.94.54V225l.84-.48s.09,0,.11,0a.66.66,0,0,1,0,.29v.25a1,1,0,0,1,0,.34.24.24,0,0,1-.11.16l-.84.48v1.33l.95-.54c.05,0,.09,0,.11,0a.66.66,0,0,1,0,.29v.26a1,1,0,0,1,0,.33.24.24,0,0,1-.11.16l-1.58.91C396.18,228.87,396.13,228.87,396.1,228.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.72,226.76a4.08,4.08,0,0,1-.34-2,6.74,6.74,0,0,1,.36-2.4,2.49,2.49,0,0,1,1.09-1.35,1.26,1.26,0,0,1,.47-.18c.11,0,.16.07.16.26a2.35,2.35,0,0,1-.07.6c-.05.19-.11.29-.18.29a.9.9,0,0,0-.34.11,1.24,1.24,0,0,0-.48.73,5.62,5.62,0,0,0-.16,1.46,3.69,3.69,0,0,0,.16,1.28.31.31,0,0,0,.5.17l.18-.12.18-.18.05,0c.07,0,.12,0,.16.11a2.17,2.17,0,0,1,.05.51.85.85,0,0,1,0,.23.6.6,0,0,1-.13.21,2.85,2.85,0,0,1-.24.22l-.31.22C399.31,227.13,399,227.11,398.72,226.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.42,225.6v-4.42l-.59.34c-.06,0-.09,0-.12,0a.85.85,0,0,1,0-.29V221a1.37,1.37,0,0,1,0-.34.26.26,0,0,1,.12-.16l2-1.17q.09,0,.12,0a.63.63,0,0,1,0,.29v.25a1,1,0,0,1,0,.33.25.25,0,0,1-.12.17l-.59.35v4.42a.53.53,0,0,1-.31.44l-.22.13C401.52,225.81,401.42,225.78,401.42,225.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,179.51l.06.11v.64l-.94.54v-.65l0-.18a1.41,1.41,0,0,1-1.49-.22l.66-1.4a.86.86,0,0,0,.82.21l0-.14v-.91l0-.16c-.72.15-1.39.16-1.39-1a3.48,3.48,0,0,1,1.38-2.63l0-.12V173l.94-.54v.64l-.06.2a1.12,1.12,0,0,1,1.31.34l-.67,1.43a.77.77,0,0,0-.65-.32l.07.14v.69l-.07.17.14,0c.83-.17,1.25.23,1.25,1.11A3.52,3.52,0,0,1,388,179.51Zm-.82-4.37a.84.84,0,0,0-.35.59c0,.15.13.23.34.18l0-.12v-.48Zm.83,2.06.05.14V178l-.05.17a.9.9,0,0,0,.36-.61C388.41,177.35,388.34,177.19,388.05,177.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.87,177.26c-.78.46-1.3.41-1.78-.14l.69-1.47c.39.4.67.45,1.09.21a1.72,1.72,0,0,0,.88-1.48c0-.46-.23-.87-.83-.52a2.86,2.86,0,0,0-1.14,1.37l-.62-.6.26-3.27,3.07-1.77V171l-2.26,1.3.09.1-.05.52-.08.23h0a2.38,2.38,0,0,1,.73-.69c1.23-.71,1.87,0,1.87,1.31A4.08,4.08,0,0,1,391.87,177.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.94,175.47c-.34.2-.52-.06-.52-.57a1.37,1.37,0,0,1,.52-1.18c.35-.2.53.07.53.57A1.34,1.34,0,0,1,394.94,175.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,173.75c-.7.4-1.24.41-1.61.06l.69-1.46a.73.73,0,0,0,.91,0,2.29,2.29,0,0,0,1-1.66h0a2.85,2.85,0,0,1-.92.94c-1.23.71-1.9,0-1.88-1.3a4.19,4.19,0,0,1,1.93-3.49c1.36-.78,2,.31,2,2.24C400,171.22,399.15,173.06,398,173.75Zm.11-5.49a1.94,1.94,0,0,0-.89,1.5c0,.41.23.85.85.49a1.91,1.91,0,0,0,.88-1.51C398.92,168.34,398.68,167.9,398.07,168.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.46,171.15c-.7.4-1.23.41-1.61.06l.69-1.46a.73.73,0,0,0,.91,0,2.33,2.33,0,0,0,1-1.66h0a3,3,0,0,1-.93.94c-1.22.71-1.9,0-1.88-1.3a4.22,4.22,0,0,1,1.93-3.49c1.36-.78,2,.31,2,2.24C404.53,168.62,403.65,170.46,402.46,171.15Zm.11-5.49a2,2,0,0,0-.89,1.51c0,.4.23.84.85.48a1.91,1.91,0,0,0,.88-1.51C403.42,165.74,403.18,165.31,402.57,165.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,158.39a.26.26,0,0,1-.25-.16,14.19,14.19,0,0,1-.53-1.74.26.26,0,0,1,.2-.31.26.26,0,0,1,.31.19,10.5,10.5,0,0,0,.51,1.67.26.26,0,0,1-.15.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,163.09a6.18,6.18,0,0,1-3.79-1.25,7.51,7.51,0,0,1-1.15-1.11.27.27,0,0,1,0-.37.26.26,0,0,1,.36,0,6.06,6.06,0,0,0,1.07,1,6,6,0,0,0,5.06,1c4-.89,8.22-4.89,11.13-10.45,4.52-8.63,4.55-18.4.08-21.78a5.58,5.58,0,0,0-2.54-1.08.26.26,0,0,1,.08-.51,6.2,6.2,0,0,1,2.77,1.17c4.66,3.53,4.7,13.6.07,22.44-3,5.69-7.37,9.79-11.47,10.71A8,8,0,0,1,391.25,163.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,153a.26.26,0,0,1-.26-.25,28.89,28.89,0,0,1,3.46-13.38c3-5.67,7.36-9.78,11.45-10.71a.26.26,0,0,1,.31.2.25.25,0,0,1-.19.31c-3.95.9-8.21,4.9-11.11,10.44a28.32,28.32,0,0,0-3.4,13.13.26.26,0,0,1-.26.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,128.54c.12-.11.24-.09.27.05a.52.52,0,0,1-.15.45c-.12.11-.24.09-.27,0A.54.54,0,0,1,400.17,128.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,135.34c.11-.11.23-.09.27,0a.52.52,0,0,1-.16.44c-.11.12-.23.09-.27,0A.53.53,0,0,1,408.82,135.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,154.4c.11-.11.23-.09.27,0a.55.55,0,0,1-.16.45c-.11.11-.23.08-.27-.05A.53.53,0,0,1,384.26,154.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.71,159.16c.11-.11.23-.09.27.05a.52.52,0,0,1-.16.44c-.11.12-.23.09-.27,0A.53.53,0,0,1,385.71,159.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,164.26c.12-.11.24-.09.27.05a.49.49,0,0,1-.15.45c-.12.11-.24.09-.27,0A.56.56,0,0,1,388.91,164.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.15,164.41c.11-.12.23-.09.27,0a.53.53,0,0,1-.16.45c-.11.11-.23.09-.27-.05A.52.52,0,0,1,390.15,164.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.69,164.28a.2.2,0,0,1-.11,0,6.68,6.68,0,0,1-1-.65c-5.43-4.1-5.79-15.19-.8-24.72a.25.25,0,0,1,.35-.11.27.27,0,0,1,.11.35c-4.8,9.15-4.49,20.18.65,24.07a7,7,0,0,0,1,.6.25.25,0,0,1,.11.35A.24.24,0,0,1,387.69,164.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.73,153.23a.23.23,0,0,1-.12,0,.26.26,0,0,1-.11-.35,32.65,32.65,0,0,0,3.61-14.36.26.26,0,0,1,.26-.26h0a.27.27,0,0,1,.26.26A32.88,32.88,0,0,1,406,153.1.28.28,0,0,1,405.73,153.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.25,133.33a.27.27,0,0,1-.25-.19,8.8,8.8,0,0,0-3-4.75c-3.73-2.72-9.07-1.42-13.59,3.33a.28.28,0,0,1-.37,0,.27.27,0,0,1,0-.37c4.72-5,10.32-6.28,14.28-3.38a9.3,9.3,0,0,1,3.22,5,.27.27,0,0,1-.18.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.35,151.43a.24.24,0,0,1-.22-.14,8.06,8.06,0,0,1-.83-3.8c0-4.84,3-10.49,6.61-12.6a4.64,4.64,0,0,1,4-.58,4.27,4.27,0,0,1,2.45,2.84.26.26,0,0,1-.16.33.27.27,0,0,1-.33-.17,3.79,3.79,0,0,0-2.14-2.51,4.13,4.13,0,0,0-3.55.54c-3.5,2-6.35,7.47-6.35,12.15a7.59,7.59,0,0,0,.76,3.56.26.26,0,0,1-.1.35A.28.28,0,0,1,389.35,151.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.07,153.37a.26.26,0,0,1-.25-.22.24.24,0,0,1,.21-.29,5.72,5.72,0,0,0,1.88-.7c2.47-1.43,4.74-4.69,5.77-8.31a.26.26,0,0,1,.5.14c-1.07,3.74-3.43,7.12-6,8.62a6,6,0,0,1-2.06.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.45,152.49h-.21a1.08,1.08,0,0,1-.85-.65,4.57,4.57,0,0,1,.37-3.08.19.19,0,0,1,.25-.11.18.18,0,0,1,.11.24,4.34,4.34,0,0,0-.37,2.79.67.67,0,0,0,.55.42c1.43.23,4.59-2.25,7.71-6,3.89-4.64,6.57-9.93,5.86-11.56-.21-.5-.76-.57-1.63-.22a.19.19,0,0,1-.25-.11.2.2,0,0,1,.11-.25c1.44-.58,1.95,0,2.13.42.78,1.81-1.82,7.07-5.92,12C393.19,150.08,390.09,152.49,388.45,152.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,155.32l-.31,0a1.57,1.57,0,0,1-1.24-1c-.55-1.28,0-3.66,1.45-6.72a.21.21,0,0,1,.26-.09.19.19,0,0,1,.09.26c-1.42,2.91-1.94,5.24-1.44,6.4a1.12,1.12,0,0,0,.94.72c1.88.29,5.66-2.49,9.34-6.88,4.78-5.7,7.85-12.23,6.84-14.55a1.1,1.1,0,0,0-.73-.68c-.72-.23-1.88.13-3.27,1a.18.18,0,0,1-.26-.06.2.2,0,0,1,.06-.27c1.51-.95,2.75-1.31,3.59-1a1.5,1.5,0,0,1,1,.89c1.07,2.49-2,9.06-6.9,15C393.62,152.56,389.91,155.32,387.81,155.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15,153.93l-.3,0a1.1,1.1,0,0,1-.82-.52.21.21,0,0,1,.09-.27.2.2,0,0,1,.26.09.67.67,0,0,0,.53.31c1,.15,3.13-.74,6-3.71a.19.19,0,0,1,.28,0,.2.2,0,0,1,0,.27C391.83,152.52,389.61,153.93,388.15,153.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.26,148.78a.41.41,0,0,1-.18.34c-.1.06-.19,0-.19-.13a.44.44,0,0,1,.19-.35C395.18,148.58,395.26,148.64,395.26,148.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,144.09a.82.82,0,0,1-.43-.12,1.33,1.33,0,0,1-.56-1.23,3.3,3.3,0,0,1,1.42-2.68,1,1,0,0,1,1-.07,1.35,1.35,0,0,1,.55,1.23,3.3,3.3,0,0,1-1.41,2.68A1.17,1.17,0,0,1,404,144.09Zm1-3.83a1,1,0,0,0-.43.13,3,3,0,0,0-1.22,2.35,1,1,0,0,0,.36.9.69.69,0,0,0,.67-.07,3,3,0,0,0,1.22-2.35,1,1,0,0,0-.36-.89A.44.44,0,0,0,405,140.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.59,157.85A1.47,1.47,0,0,1,391,159c-.33.19-.61,0-.61-.46a1.48,1.48,0,0,1,.61-1.17C391.32,157.2,391.59,157.4,391.59,157.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,147.84l.1.22.23-.09s.05,0,0,.07l-.16.31,0,.29s0,.08-.06.08l-.2,0L403,149s-.06,0-.05,0l0-.33-.17-.13s0-.07,0-.09l.23-.18.11-.34S403.21,147.81,403.22,147.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.27,156.19l-.11,0a.35.35,0,0,1-.18-.38l.17-1.4-.68-.49a.34.34,0,0,1-.13-.28.61.61,0,0,1,.21-.46l1-.78.46-1.5a.48.48,0,0,1,.38-.37.28.28,0,0,1,.27.17l.4.85.9-.34a.27.27,0,0,1,.32.07.46.46,0,0,1,0,.52l-.74,1.39.17,1.24a.6.6,0,0,1-.16.48.38.38,0,0,1-.29.11l-.84-.1-.89,1.13A.36.36,0,0,1,398.27,156.19Zm-.54-2.59.74.54a.23.23,0,0,1,.08.18l-.16,1.29.82-1a.18.18,0,0,1,.17-.07l1,.11s0-.09,0-.14l-.19-1.31a.27.27,0,0,1,0-.12l.76-1.43-.91.35a.2.2,0,0,1-.24-.1l-.41-.87-.48,1.56a.21.21,0,0,1-.06.1l-1.07.82A.19.19,0,0,0,397.73,153.6Zm1.6-2.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.94,158l.11.22.23-.09s0,0,0,.07l-.17.31,0,.29s0,.08-.05.08l-.21,0-.21.27s-.05,0-.05,0l0-.33-.17-.12s0-.07,0-.1l.23-.18.11-.34S395.93,157.92,395.94,158Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,143.61a.82.82,0,0,1-.69-.36c-.82-1.17.24-5.07,1.36-7.35a.19.19,0,0,1,.26-.09.19.19,0,0,1,.08.26c-1.17,2.38-2,6-1.38,7a.45.45,0,0,0,.45.19c1-.12,2.16-1.68,3.08-2.93a11,11,0,0,1,1.43-1.74c.62-.54,1.15-.71,1.56-.51s.7.87.69,1.89a.2.2,0,0,1-.19.19h0a.2.2,0,0,1-.19-.2c0-.83-.16-1.39-.46-1.53s-.66,0-1.15.45a10.72,10.72,0,0,0-1.37,1.67c-1,1.39-2.15,3-3.35,3.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.84,147.14a1.82,1.82,0,0,1-.89-.23c-.56-.31-1.19-1.09-1.08-3a.2.2,0,0,1,.2-.18.19.19,0,0,1,.18.21c-.07,1.37.24,2.32.89,2.69s1.59.14,2.62-.57c1.4-1,2.74-3.07,3.72-4.61a12.3,12.3,0,0,1,1.11-1.59c.16-.15.63-.62,1-.41s.4,1.29.37,1.5a.17.17,0,0,1-.21.17.19.19,0,0,1-.17-.21c.05-.46,0-1-.16-1.12s-.18-.05-.6.35a11.93,11.93,0,0,0-1.06,1.52c-1,1.57-2.36,3.71-3.82,4.72A4,4,0,0,1,390.84,147.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.3,139a.51.51,0,0,1-.41-.18c-.47-.6.28-2.63,1.69-4.53a.19.19,0,0,1,.27,0,.18.18,0,0,1,0,.27c-1.42,1.93-2,3.72-1.69,4.06.06.08.23,0,.33,0a9.9,9.9,0,0,0,1.93-1.59c1.18-1.13,2.2-2.09,2.78-1.68a.19.19,0,0,1,.05.27.22.22,0,0,1-.28,0c-.32-.22-1.5.9-2.28,1.65a9.43,9.43,0,0,1-2,1.66A1,1,0,0,1,395.3,139Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,150.18h-.07a.19.19,0,0,1-.11-.25,2.48,2.48,0,0,1,2.16-1.79H391a1.45,1.45,0,0,1,1.35,1.13.19.19,0,0,1-.14.24.2.2,0,0,1-.24-.14,1,1,0,0,0-1-.84,2.1,2.1,0,0,0-1.85,1.54A.2.2,0,0,1,389,150.18Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-191"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.86 83.58 416.38 55.34 434.68 60.2 376.86 83.58",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.86 83.58 416.38 55.34 434.68 60.2 376.86 83.58",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.86 83.58 410.67 52.34 402.37 43.68 376.86 83.58",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.86 83.58 410.67 52.34 402.37 43.68 376.86 83.58",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.67 52.34 411.02 59.17 376.86 83.58 410.67 52.34",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.67 52.34 411.02 59.17 376.86 83.58 410.67 52.34",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Line--inject-191",
    d: "M419.68,46.89l.38.93c.77-.32,1.54-.61,2.31-.88L422,46C421.26,46.27,420.47,46.57,419.68,46.89Zm22.49-3.23a37.48,37.48,0,0,0-5.11-.35v1a35.46,35.46,0,0,1,5,.34Zm-15.24.88.24,1a43,43,0,0,1,4.91-.9l-.12-1A43,43,0,0,0,426.93,44.54Zm19.7,130.63.59.8c1.37-1,2.71-2.05,4-3.12l-.63-.77C449.31,173.14,448,174.18,446.63,175.17Zm11.61-83.24L458,91a8,8,0,0,1-4.69,0l-.31.95a8.81,8.81,0,0,0,2.7.43A9.16,9.16,0,0,0,458.24,91.93ZM454.82,76.4l-.47-.88a12,12,0,0,0-1.65,1.07,17.19,17.19,0,0,0-2.4,2.21l.75.66a16.4,16.4,0,0,1,2.26-2.08A10.58,10.58,0,0,1,454.82,76.4Zm-7,7a7,7,0,0,0-.16,1.5,6.89,6.89,0,0,0,1.08,3.72l.84-.53a6,6,0,0,1-.92-3.19,6.46,6.46,0,0,1,.14-1.3ZM460.47,52.2a30.42,30.42,0,0,0-4-3.2l-.56.83a30.76,30.76,0,0,1,3.89,3.1Zm8.8,18.08a25.24,25.24,0,0,0-.86-5.07l-1,.27a25.46,25.46,0,0,1,.84,4.87Zm-14.88,98.5.68.74c1.24-1.15,2.46-2.34,3.64-3.55l-.72-.69C456.83,166.47,455.62,167.65,454.39,168.78Zm28.48-72.5a38.09,38.09,0,0,0-1.05-5l-1,.27a36.47,36.47,0,0,1,1,4.87ZM452,46.5a34,34,0,0,0-4.8-1.79l-.28,1a33.86,33.86,0,0,1,4.67,1.73Zm21.2,32.6.64-.77a20.48,20.48,0,0,0-4.37-2.76l-.42.91A19.07,19.07,0,0,1,473.18,79.1Zm3.71,56.78.93.36c.61-1.58,1.18-3.19,1.69-4.79l-.95-.31C478.06,132.73,477.49,134.32,476.89,135.88ZM480,86.47a26,26,0,0,0-2.65-4.41l-.8.6a24.41,24.41,0,0,1,2.54,4.24ZM472.73,145l.88.46c.79-1.49,1.54-3,2.24-4.56l-.91-.41C474.25,142,473.51,143.55,472.73,145ZM480,126.32l1,.24c.41-1.63.79-3.3,1.11-5l-1-.19C480.73,123.05,480.36,124.7,480,126.32Zm1.89-9.87,1,.13c.22-1.68.38-3.38.5-5.06l-1-.07C482.22,113.11,482.05,114.8,481.84,116.45ZM464.34,75l.16-1a18,18,0,0,0-5.18-.09l.13,1A16.74,16.74,0,0,1,464.34,75Zm19,26.31-1,.06c.1,1.58.14,3.18.14,4.76v.27h1v-.27C483.5,104.57,483.46,103,483.36,101.35Zm-22,60.22.76.66c1.11-1.28,2.19-2.6,3.22-3.93l-.79-.61C463.56,159,462.49,160.31,461.39,161.57Zm6.15-7.94.82.56c1-1.39,1.88-2.83,2.75-4.27l-.85-.52C469.4,150.83,468.48,152.25,467.54,153.63Zm-5.48-65.09.69.73a16.88,16.88,0,0,0,3.14-4.13l-.88-.49A15.79,15.79,0,0,1,462.06,88.54Zm7.06-13.11-1-.13A26.3,26.3,0,0,1,467,80.12l.95.32A26.73,26.73,0,0,0,469.12,75.43Zm-6-18.8a26.26,26.26,0,0,1,2.59,4.22l.9-.44A28.3,28.3,0,0,0,463.89,56ZM440.3,179.45l.53.85c.71-.44,1.42-.89,2.12-1.35l-.55-.84C441.71,178.56,441,179,440.3,179.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--envelope--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.71,296.76l-60.8-35.1-2.43,1.4a2.53,2.53,0,0,0-1.15,2v44.85a2.53,2.53,0,0,0,1.15,2L466,345.65a2.56,2.56,0,0,0,2.29,0l1.28-.74a2.56,2.56,0,0,0,1.15-2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.71,296.76l-60.8-35.1-2.43,1.4a2.53,2.53,0,0,0-1.15,2v44.85a2.53,2.53,0,0,0,1.15,2L466,345.65a2.56,2.56,0,0,0,2.29,0l1.28-.74a2.56,2.56,0,0,0,1.15-2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.25,257.71l-.25-.13.94-.55h0a1.42,1.42,0,0,1,.25-.12L438,247a1.85,1.85,0,0,1,2.06.66l29.93,43.71a5.23,5.23,0,0,1,.77,2.49v2.91l-.93.54-59.87-35.64v-2.91A2,2,0,0,1,410.25,257.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,247.86a1.64,1.64,0,0,1,.31.33L469,291.9a4.67,4.67,0,0,1,.56,1.25l.93-.54a6.44,6.44,0,0,0-.25-.66s0,0,0,0l-.12-.27,0,0a2.26,2.26,0,0,0-.16-.26L440,247.65l-.15-.18-.16-.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,257.57a1.42,1.42,0,0,1,.25-.12L437,247.53a1.86,1.86,0,0,1,1.75.33l.93-.54A1.86,1.86,0,0,0,438,247l-26.76,9.92a1.42,1.42,0,0,0-.25.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,248.19,469,291.9a5.12,5.12,0,0,1,.77,2.49v2.91L409,262.19v-2.9a2.11,2.11,0,0,1,1.29-1.84L437,247.53A1.85,1.85,0,0,1,439.08,248.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,248.19,469,291.9a5.12,5.12,0,0,1,.77,2.49v2.91L409,262.19v-2.9a2.11,2.11,0,0,1,1.29-1.84L437,247.53A1.85,1.85,0,0,1,439.08,248.19Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.88 296.76 461.54 292.45 454.19 288.16 439.46 279.62 424.69 271.14 417.3 266.91 409.89 262.71 417.24 267.03 424.59 271.32 439.32 279.85 454.09 288.34 461.48 292.56 468.88 296.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.63 311.88 410.63 245.53 465.42 277.16 465.42 343.52 410.63 311.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,245.8l54.48,31.45v66l-54.48-31.46v-66m-.31-.54V312l55.1,31.82V277.07l-55.1-31.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.58 277.07 466.81 276.37 411.7 244.55 410.48 245.26 465.58 277.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.81 276.37 466.81 343.08 465.58 343.79 465.58 277.07 466.81 276.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.52,285.54a.48.48,0,0,1-.28-.08l-45-26a.55.55,0,0,1-.2-.75.54.54,0,0,1,.75-.2l45,26a.55.55,0,0,1,.2.75A.56.56,0,0,1,460.52,285.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.52,294.31a.48.48,0,0,1-.28-.08l-45-26a.55.55,0,0,1-.2-.75.54.54,0,0,1,.75-.2l45,26a.55.55,0,0,1,.2.75A.56.56,0,0,1,460.52,294.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.52,303.08a.55.55,0,0,1-.28-.07l-45-26a.55.55,0,0,1-.2-.75.54.54,0,0,1,.75-.2l45,26a.55.55,0,0,1,.2.75A.56.56,0,0,1,460.52,303.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,264.75h0c.06-.32.23-.42.45-.26a1.19,1.19,0,0,1,.29.3l.13.18,25,38,3.74,5.2a2.14,2.14,0,0,0,2,.77l3.22-.77,24.6-9.05a1.27,1.27,0,0,1,.51,0,.64.64,0,0,1,.18.06l-.92-.54L442,307.28l-3.11,1.1a2.1,2.1,0,0,1-2.05-.77l-3.73-5.19L408,264.23a1,1,0,0,0-.28-.26l2.17-1.25-.91-.53-1.5.87A2.57,2.57,0,0,0,406.36,264.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,310.49a.47.47,0,0,0,.06.09l25.34-8a4.35,4.35,0,0,1,5.47,1.68l27.09,40.26,1,.58h0a.82.82,0,0,0,.77.09l-27.85-41.5a4.38,4.38,0,0,0-5.48-1.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,263.06l1.5-.87.91.52L407.72,264h0a1,1,0,0,1,.28.26l25.09,38.13.12.18-.17,0-.87.29L407.23,265l-.13-.18a1.19,1.19,0,0,0-.29-.3c-.22-.16-.39-.07-.45.26h0A2.57,2.57,0,0,1,407.48,263.06Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.34,299.85l5.37-3.09v46.17a2.56,2.56,0,0,1-1.15,2l-1.28.74a2.56,2.56,0,0,1-2.29,0l-.65-.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.34,299.85l5.37-3.09v46.17a2.56,2.56,0,0,1-1.15,2l-1.28.74a2.56,2.56,0,0,1-2.29,0l-.65-.37Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.33,265v44.85a2.35,2.35,0,0,0,.36,1.16,2.44,2.44,0,0,0,.67.75l0,0,.08.05L466,345.65a.79.79,0,0,0,.78.09.68.68,0,0,0,.35-.54,1.48,1.48,0,0,0,0-.21V300.14a1,1,0,0,0-1.29-1l-24.6,9.05L438,309a2.14,2.14,0,0,1-2-.77l-3.74-5.2-25-38-.13-.18C406.68,264.2,406.33,264.31,406.33,265Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.33,265v44.85a2.35,2.35,0,0,0,.36,1.16,2.44,2.44,0,0,0,.67.75l0,0,.08.05L466,345.65a.79.79,0,0,0,.78.09.68.68,0,0,0,.35-.54,1.48,1.48,0,0,0,0-.21V300.14a1,1,0,0,0-1.29-1l-24.6,9.05L438,309a2.14,2.14,0,0,1-2-.77l-3.74-5.2-25-38-.13-.18C406.68,264.2,406.33,264.31,406.33,265Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,310.64l25.23-8.1a4.45,4.45,0,0,1,5.54,1.69l1-.58a4.5,4.5,0,0,0-5.54-1.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,310.64l25.23-8.1a4.45,4.45,0,0,1,5.54,1.69l1-.58a4.5,4.5,0,0,0-5.54-1.77Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,311.87l-.08-.05,0,0a2.44,2.44,0,0,1-.67-.75,2.38,2.38,0,0,1-.36-1.14l25.9-6.93-17.34,13.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,311.05a2.44,2.44,0,0,0,.67.75l0,0L466,345.65h0a.77.77,0,0,0,.77.09l-28-41.52a4.39,4.39,0,0,0-5.51-1.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,311.05a2.44,2.44,0,0,0,.67.75h0l58.59,33.83.06,0a.77.77,0,0,0,.77.09l-28-41.52a4.39,4.39,0,0,0-5.51-1.69Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,292.61l-.93.54a4.53,4.53,0,0,1,.21,1.24v2.9l.93-.53v-2.91A4.53,4.53,0,0,0,470.5,292.61Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.61 298.63 466.53 299.17 467.47 298.63 469.78 297.3 468.88 296.76 465.61 298.63",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.56,298.65l3.32-1.89.9.54-2.31,1.33-.94.54h0l-.17-.05a1.06,1.06,0,0,0-.5,0l-1.87.69-21.49,7.9-.32-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.76,304.23l28,41.51a.79.79,0,0,0,.35-.75v-.75l-27.37-40.58h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.76,304.23l28,41.51a.79.79,0,0,0,.35-.75v-.75l-27.37-40.58h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-191",
    d: "M187.53,56.34c4.52-2.61,8.19-9.62,8.19-15.65s-3.67-8.8-8.19-6.19-8.19,9.62-8.19,15.65S183,59,187.53,56.34Zm14.21,5.54c-.83-4.7-4.27-6.42-8.24-4.13l-11.94,6.89c-4,2.3-7.41,8-8.24,13.65l-1.46,10c-.29,2,.74,3.09,2.13,2.29l27.08-15.64a5.17,5.17,0,0,0,2.13-4.74Zm4.29-23c3.25-1.87,5.89-6.91,5.89-11.24s-2.64-6.32-5.89-4.45-5.88,6.91-5.88,11.25S202.78,40.81,206,38.93Zm10.22,3c-.61-3.34-3.07-4.6-5.93-2.95l-8.57,4.95c-2.44,1.41-4.56,4.54-5.51,7.92,4.17-1.27,7.63.87,8.91,5.6l10.41-6c1.64-.94,1.87-1.64,1.53-3.59Zm-41.34,7.16c0-4.34-2.63-6.33-5.88-4.45s-5.89,6.91-5.89,11.24,2.64,6.33,5.89,4.45S174.91,53.39,174.91,49.06ZM158,82c-.33,2.35-.1,2.78,1.54,1.83l10.41-6c1.27-6.21,4.74-12.34,8.91-15.89-.95-2.29-3.07-3-5.51-1.56l-8.57,4.95c-2.86,1.65-5.32,5.75-5.93,9.79Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.76,459.14c-8.17-8.43-13-29.61-5-36.3H90.3c8,6.68,3.17,27.86-5,36.29l-.23.23a3.7,3.7,0,0,1-.28.28,9.7,9.7,0,0,1-.74.67l-.19.15c-.2.16-.4.32-.62.47a12.43,12.43,0,0,1-1,.68c-6.72,3.93-17.62,3.93-24.33,0h0a12.57,12.57,0,0,1-1.06-.68l-.57-.44L56,460.3c-.26-.21-.49-.43-.72-.64l-.32-.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,420.15c9.25,5.4,9.25,14.15,0,19.55s-24.25,5.4-33.5,0-9.24-14.15,0-19.55S77.53,414.75,86.78,420.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,422.75c6.79,4,6.79,10.39,0,14.36s-17.81,4-24.6,0-6.79-10.4,0-14.36S75.54,418.78,82.33,422.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.73,429.56c6.79-4,17.81-4,24.6,0a11.36,11.36,0,0,1,4.07,3.77,11.37,11.37,0,0,1-4.07,3.78c-6.79,4-17.81,4-24.6,0a11.46,11.46,0,0,1-4.07-3.78A11.44,11.44,0,0,1,57.73,429.56Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.3,375.51c-3.1,3.36-11.74,4.29-15.31-4.81-3.35-8.53-7-16.61-8-19.74a3.22,3.22,0,0,1,2.06-4.16s.25-4.69,8.19-1.52,13.54,8,17,15.79S72.62,374.46,67.3,375.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3,375.51c-3.1,3.36-11.74,4.29-15.31-4.81-3.35-8.53-7-16.61-8-19.74a3.22,3.22,0,0,1,2.06-4.16s.25-4.69,8.19-1.52,13.54,8,17,15.79S72.62,374.46,67.3,375.51Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.74,387.53a42,42,0,0,0-.69-4.74,65.55,65.55,0,0,0-2.63-9.15,67.35,67.35,0,0,0-9.2-17A58.85,58.85,0,0,0,51,348.44c-.08-.07-.14.11-.09.17a72.07,72.07,0,0,1,11.33,15.65A72.56,72.56,0,0,1,68.77,382c.39,1.73.77,3.46,1.08,5.21s.51,3.56.81,5.33c0,.18.3.29.32,0A32.92,32.92,0,0,0,70.74,387.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.74,387.53a42,42,0,0,0-.69-4.74,65.55,65.55,0,0,0-2.63-9.15,67.35,67.35,0,0,0-9.2-17A58.85,58.85,0,0,0,51,348.44c-.08-.07-.14.11-.09.17a72.07,72.07,0,0,1,11.33,15.65A72.56,72.56,0,0,1,68.77,382c.39,1.73.77,3.46,1.08,5.21s.51,3.56.81,5.33c0,.18.3.29.32,0A32.92,32.92,0,0,0,70.74,387.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,373.15c-7.14,2.2-12.44-3.36-10.6-12.09s11-18.43,14.47-15.82c2.16-2.17,6.93-1.39,9.17,5.7S86.64,376.24,73.4,373.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,373.15c-7.14,2.2-12.44-3.36-10.6-12.09s11-18.43,14.47-15.82c2.16-2.17,6.93-1.39,9.17,5.7S86.64,376.24,73.4,373.15Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,350.55a96,96,0,0,0-4.74,15.68,155.15,155.15,0,0,0-2.76,16.43,258.26,258.26,0,0,0-1.43,32.19c0,3,.07,5.94.12,8.91s0,6.15.27,9.19c.11,1.17,1.76.86,1.79-.21.1-5.35-.19-10.72-.25-16.07s0-10.57.1-15.86a223.46,223.46,0,0,1,2.89-32.15c.51-3,1.07-5.91,1.76-8.84s1.62-6.1,2.43-9.16C77.79,350.54,77.65,350.38,77.58,350.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,350.55a96,96,0,0,0-4.74,15.68,155.15,155.15,0,0,0-2.76,16.43,258.26,258.26,0,0,0-1.43,32.19c0,3,.07,5.94.12,8.91s0,6.15.27,9.19c.11,1.17,1.76.86,1.79-.21.1-5.35-.19-10.72-.25-16.07s0-10.57.1-15.86a223.46,223.46,0,0,1,2.89-32.15c.51-3,1.07-5.91,1.76-8.84s1.62-6.1,2.43-9.16C77.79,350.54,77.65,350.38,77.58,350.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,398.75c-3.12,3.53-10.26,3.22-15-3.08s-7.67-30-.92-28.46c1.42-3.16,20.05,4.43,22.44,19.88C70,398.32,61.79,398.75,61.79,398.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,398.75c-3.12,3.53-10.26,3.22-15-3.08s-7.67-30-.92-28.46c1.42-3.16,20.05,4.43,22.44,19.88C70,398.32,61.79,398.75,61.79,398.75Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,409.94a34.91,34.91,0,0,0-.92-4.32c-.78-2.9-1.71-5.76-2.77-8.56a90.7,90.7,0,0,0-8.32-16.34,81.05,81.05,0,0,0-5.91-8.34c-.06-.07-.12.09-.08.14,1.66,2.43,3.35,4.82,4.85,7.36A90.47,90.47,0,0,1,58.43,388a113.25,113.25,0,0,1,6.14,16.48c.46,1.6.83,3.22,1.31,4.82s1.11,3.29,1.52,5c.06.24.38.33.34,0C67.6,412.83,67.55,411.38,67.36,409.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,409.94a34.91,34.91,0,0,0-.92-4.32c-.78-2.9-1.71-5.76-2.77-8.56a90.7,90.7,0,0,0-8.32-16.34,81.05,81.05,0,0,0-5.91-8.34c-.06-.07-.12.09-.08.14,1.66,2.43,3.35,4.82,4.85,7.36A90.47,90.47,0,0,1,58.43,388a113.25,113.25,0,0,1,6.14,16.48c.46,1.6.83,3.22,1.31,4.82s1.11,3.29,1.52,5c.06.24.38.33.34,0C67.6,412.83,67.55,411.38,67.36,409.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.19,395.25c-4.07-.93-4.28-5.82.82-11.83s17.93-8.63,18.54-6.1c2.86,0,2.86,8.94-3.46,17.15S73.57,400.77,73.19,395.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.19,395.25c-4.07-.93-4.28-5.82.82-11.83s17.93-8.63,18.54-6.1c2.86,0,2.86,8.94-3.46,17.15S73.57,400.77,73.19,395.25Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.18,386.51a32.14,32.14,0,0,0-11.8,15.23c-.13.35.47.87.61.49A37.41,37.41,0,0,1,81.2,386.6S81.23,386.48,81.18,386.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.18,386.51a32.14,32.14,0,0,0-11.8,15.23c-.13.35.47.87.61.49A37.41,37.41,0,0,1,81.2,386.6S81.23,386.48,81.18,386.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.85,425.08c-5.65,2.28-3.23,9,2.28,14.12a25.22,25.22,0,0,0,17.19,6.18c3.79-.27,4.76-.79,4.76-.79a43.36,43.36,0,0,0,0-9.34,18.07,18.07,0,0,0-13.31-14.34C80,418.53,77.85,421.72,77.85,425.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.85,425.08c-5.65,2.28-3.23,9,2.28,14.12a25.22,25.22,0,0,0,17.19,6.18c3.79-.27,4.76-.79,4.76-.79a43.36,43.36,0,0,0,0-9.34,18.07,18.07,0,0,0-13.31-14.34C80,418.53,77.85,421.72,77.85,425.08Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,435a45.57,45.57,0,0,0-8.65-8c-3.21-2.12-7.5-3.92-11.35-2.6-1.5.51-3.82,2-3.54,3.85,0,.18.35.64.57.38a15.94,15.94,0,0,1,2-2.37,6,6,0,0,1,3-1.15,14.11,14.11,0,0,1,7.92,1.8c3.82,2,6.9,5.17,9.94,8.18C93.47,435.13,93.51,435,93.48,435Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,435a45.57,45.57,0,0,0-8.65-8c-3.21-2.12-7.5-3.92-11.35-2.6-1.5.51-3.82,2-3.54,3.85,0,.18.35.64.57.38a15.94,15.94,0,0,1,2-2.37,6,6,0,0,1,3-1.15,14.11,14.11,0,0,1,7.92,1.8c3.82,2,6.9,5.17,9.94,8.18C93.47,435.13,93.51,435,93.48,435Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,396.16c.53-2.57-3.18-8.73-14.75-9.91s-20.25,3.74-22,6-2.63,4.6-.54,5.19,9.34,1.29,14.09,3.48,14.4,8.64,21,6.72S59.62,398.72,56.35,396.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,396.16c.53-2.57-3.18-8.73-14.75-9.91s-20.25,3.74-22,6-2.63,4.6-.54,5.19,9.34,1.29,14.09,3.48,14.4,8.64,21,6.72S59.62,398.72,56.35,396.16Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,405.13C60.27,395,47.68,392,37.4,392a40.82,40.82,0,0,0-10,1.3c-.05,0-.06.13,0,.12a53.24,53.24,0,0,1,16.76-.17c5.46.89,10.82,2.58,15.31,5.9a21,21,0,0,1,5.48,6.15C65.06,405.56,65.25,405.33,65.15,405.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,405.13C60.27,395,47.68,392,37.4,392a40.82,40.82,0,0,0-10,1.3c-.05,0-.06.13,0,.12a53.24,53.24,0,0,1,16.76-.17c5.46.89,10.82,2.58,15.31,5.9a21,21,0,0,1,5.48,6.15C65.06,405.56,65.25,405.33,65.15,405.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,382.65c-.15,4.05,5.55,6.4,11.07,2.9s11.29-6.91,16.4-8.23,7.53-5.49,5.92-7.5-4.18-7.11-17.62-5.45-18.19,7.72-20,12S81.3,383.82,83.32,382.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,382.65c-.15,4.05,5.55,6.4,11.07,2.9s11.29-6.91,16.4-8.23,7.53-5.49,5.92-7.5-4.18-7.11-17.62-5.45-18.19,7.72-20,12S81.3,383.82,83.32,382.65Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,369.8a14.64,14.64,0,0,0-5.76.6,29,29,0,0,0-4.93,1.77,27.44,27.44,0,0,0-8.4,6.08,24.55,24.55,0,0,0-1.9,2.29,9.92,9.92,0,0,0-1.43,2.35c-.09.26.3.7.53.43.67-.77,1.17-1.71,1.79-2.52a28.07,28.07,0,0,1,2.16-2.47,27.55,27.55,0,0,1,5.18-4.08,30.59,30.59,0,0,1,9.08-3.79,11.31,11.31,0,0,1,3.65-.51C105.22,370,105.25,369.81,105.18,369.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,369.8a14.64,14.64,0,0,0-5.76.6,29,29,0,0,0-4.93,1.77,27.44,27.44,0,0,0-8.4,6.08,24.55,24.55,0,0,0-1.9,2.29,9.92,9.92,0,0,0-1.43,2.35c-.09.26.3.7.53.43.67-.77,1.17-1.71,1.79-2.52a28.07,28.07,0,0,1,2.16-2.47,27.55,27.55,0,0,1,5.18-4.08,30.59,30.59,0,0,1,9.08-3.79,11.31,11.31,0,0,1,3.65-.51C105.22,370,105.25,369.81,105.18,369.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,404.51c-1.88-1.89-7-1.45-9.41,4.11S66.93,420.27,67.5,422c2.33-1.35,4.15-.55,8.26-1.35a10.25,10.25,0,0,0,7.87-10.23C83.36,405.31,81.21,402,73.68,404.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,404.51c-1.88-1.89-7-1.45-9.41,4.11S66.93,420.27,67.5,422c2.33-1.35,4.15-.55,8.26-1.35a10.25,10.25,0,0,0,7.87-10.23C83.36,405.31,81.21,402,73.68,404.51Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.61,404a7.6,7.6,0,0,0-2.49,2.58,14,14,0,0,0-1.62,3.12,13.17,13.17,0,0,0-.71,7.08c0,.09.09,0,.09-.05a14.48,14.48,0,0,1,1.19-7,14.07,14.07,0,0,1,1.69-2.81,14.26,14.26,0,0,1,1.14-1.31A7.87,7.87,0,0,0,74,404.48C74.11,404.27,73.9,403.81,73.61,404Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.61,404a7.6,7.6,0,0,0-2.49,2.58,14,14,0,0,0-1.62,3.12,13.17,13.17,0,0,0-.71,7.08c0,.09.09,0,.09-.05a14.48,14.48,0,0,1,1.19-7,14.07,14.07,0,0,1,1.69-2.81,14.26,14.26,0,0,1,1.14-1.31A7.87,7.87,0,0,0,74,404.48C74.11,404.27,73.9,403.81,73.61,404Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.82,415.78c-.17-4.14-4.66-7.42-11-9.32a17.38,17.38,0,0,0-18,4.77c-4.66,5.07-7.07,9.38-5.18,10.59s10.36,4.31,15.88,6,12.77,2.24,18.29-1S70,417.85,64.82,415.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.82,415.78c-.17-4.14-4.66-7.42-11-9.32a17.38,17.38,0,0,0-18,4.77c-4.66,5.07-7.07,9.38-5.18,10.59s10.36,4.31,15.88,6,12.77,2.24,18.29-1S70,417.85,64.82,415.78Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.18,415.31a17.55,17.55,0,0,0-6.94-1.85,31.67,31.67,0,0,0-7,.09,42,42,0,0,0-7.19,1.52q-1.85.54-3.66,1.2a26.36,26.36,0,0,0-3.34,1.38s-.06.16,0,.14c1.17-.24,2.31-.7,3.46-1.05s2.47-.74,3.71-1.07a50.47,50.47,0,0,1,7.1-1.34,31.52,31.52,0,0,1,7.2,0,41.76,41.76,0,0,1,6.53,1.6C65.56,416.08,65.43,415.46,65.18,415.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.18,415.31a17.55,17.55,0,0,0-6.94-1.85,31.67,31.67,0,0,0-7,.09,42,42,0,0,0-7.19,1.52q-1.85.54-3.66,1.2a26.36,26.36,0,0,0-3.34,1.38s-.06.16,0,.14c1.17-.24,2.31-.7,3.46-1.05s2.47-.74,3.71-1.07a50.47,50.47,0,0,1,7.1-1.34,31.52,31.52,0,0,1,7.2,0,41.76,41.76,0,0,1,6.53,1.6C65.56,416.08,65.43,415.46,65.18,415.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,409.61c-4.57-3.62-3-12.32,12.93-12.79s27.38,3.7,26.87,8.84c2.57,2.57,1.27,9.78-11.66,12S74.7,418.82,78,409.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,409.61c-4.57-3.62-3-12.32,12.93-12.79s27.38,3.7,26.87,8.84c2.57,2.57,1.27,9.78-11.66,12S74.7,418.82,78,409.61Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,405.72A68.86,68.86,0,0,0,96,404.89a55.13,55.13,0,0,0-13.18,1.51,19.37,19.37,0,0,0-3.21,1.2,14.45,14.45,0,0,0-1.4.75c-.36.22-.77.41-.9.83a.44.44,0,0,0,.48.51,17.63,17.63,0,0,0,2.79-1.38,22.94,22.94,0,0,1,2.77-1,33.63,33.63,0,0,1,5.55-1.09,97.91,97.91,0,0,1,13.48-.75c2.62,0,5.24.24,7.86.45C110.34,405.91,110.37,405.74,110.29,405.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,405.72A68.86,68.86,0,0,0,96,404.89a55.13,55.13,0,0,0-13.18,1.51,19.37,19.37,0,0,0-3.21,1.2,14.45,14.45,0,0,0-1.4.75c-.36.22-.77.41-.9.83a.44.44,0,0,0,.48.51,17.63,17.63,0,0,0,2.79-1.38,22.94,22.94,0,0,1,2.77-1,33.63,33.63,0,0,1,5.55-1.09,97.91,97.91,0,0,1,13.48-.75c2.62,0,5.24.24,7.86.45C110.34,405.91,110.37,405.74,110.29,405.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/DigitalMarketing.e6a0841f3377db79a70ffe6427ee9cfe.svg";
export { ForwardRef as ReactComponent };